(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './core-core-api.js', './core-core-range-dynamic-range.js', './core-core-stl.js', './kotlinx-serialization-kotlinx-serialization-json.js', './kotlinx-serialization-kotlinx-serialization-core.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./core-core-api.js'), require('./core-core-range-dynamic-range.js'), require('./core-core-stl.js'), require('./kotlinx-serialization-kotlinx-serialization-json.js'), require('./kotlinx-serialization-kotlinx-serialization-core.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'ipex-range-format'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'ipex-range-format'.");
    }
    if (typeof this['core-core-api'] === 'undefined') {
      throw new Error("Error loading module 'ipex-range-format'. Its dependency 'core-core-api' was not found. Please, check whether 'core-core-api' is loaded prior to 'ipex-range-format'.");
    }
    if (typeof this['core-core-range-dynamic-range'] === 'undefined') {
      throw new Error("Error loading module 'ipex-range-format'. Its dependency 'core-core-range-dynamic-range' was not found. Please, check whether 'core-core-range-dynamic-range' is loaded prior to 'ipex-range-format'.");
    }
    if (typeof this['core-core-stl'] === 'undefined') {
      throw new Error("Error loading module 'ipex-range-format'. Its dependency 'core-core-stl' was not found. Please, check whether 'core-core-stl' is loaded prior to 'ipex-range-format'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-json'] === 'undefined') {
      throw new Error("Error loading module 'ipex-range-format'. Its dependency 'kotlinx-serialization-kotlinx-serialization-json' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-json' is loaded prior to 'ipex-range-format'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'ipex-range-format'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'ipex-range-format'.");
    }
    root['ipex-range-format'] = factory(typeof this['ipex-range-format'] === 'undefined' ? {} : this['ipex-range-format'], this['kotlin-kotlin-stdlib'], this['core-core-api'], this['core-core-range-dynamic-range'], this['core-core-stl'], this['kotlinx-serialization-kotlinx-serialization-json'], this['kotlinx-serialization-kotlinx-serialization-core']);
  }
}(this, function (_, kotlin_kotlin, kotlin_core_core_api, kotlin_core_core_range_dynamic_range, kotlin_core_core_stl, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var protoOf = kotlin_kotlin.$_$.u9;
  var interfaceMeta = kotlin_kotlin.$_$.b9;
  var setMetadataFor = kotlin_kotlin.$_$.v9;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.h;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.g;
  var Unit_instance = kotlin_kotlin.$_$.x3;
  var copyToArray = kotlin_kotlin.$_$.l5;
  var merge = kotlin_core_core_api.$_$.v6;
  var toString = kotlin_kotlin.$_$.z9;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.f1;
  var Error_0 = kotlin_kotlin.$_$.tc;
  var VOID = kotlin_kotlin.$_$.e;
  var Dimension = kotlin_core_core_range_dynamic_range.$_$.q;
  var classMeta = kotlin_kotlin.$_$.q8;
  var filterNotNull = kotlin_kotlin.$_$.s5;
  var SelectableComponent = kotlin_core_core_api.$_$.f6;
  var OutlineableComponent = kotlin_core_core_api.$_$.q5;
  var DraggableComponent = kotlin_core_core_api.$_$.q2;
  var DoorComponent_getInstance = kotlin_core_core_stl.$_$.q4;
  var DoorFrontComponent_getInstance = kotlin_core_core_stl.$_$.r4;
  var HandleComponent_getInstance = kotlin_core_core_stl.$_$.u4;
  var DrawerComponent_getInstance = kotlin_core_core_stl.$_$.s4;
  var FrameComponent_getInstance = kotlin_core_core_stl.$_$.t4;
  var LegComponent_getInstance = kotlin_core_core_stl.$_$.v4;
  var OutlinedComponent = kotlin_core_core_stl.$_$.e2;
  var ProppingComponent_instance = kotlin_core_core_api.$_$.xb;
  var AlwaysHangDownComponent_instance = kotlin_core_core_api.$_$.zc;
  var UnserializableEntityComponent = kotlin_core_core_api.$_$.q6;
  var listOf = kotlin_kotlin.$_$.p6;
  var ProductComponent = kotlin_core_core_api.$_$.q;
  var plus = kotlin_kotlin.$_$.c7;
  var ProductSpecification = kotlin_core_core_api.$_$.s;
  var AllowedDoorPairsComponentFromArrays = kotlin_core_core_stl.$_$.z3;
  var toMutableList = kotlin_kotlin.$_$.y7;
  var emptyMap = kotlin_kotlin.$_$.p5;
  var Pair = kotlin_kotlin.$_$.yc;
  var AssemblyStructureComponent = kotlin_core_core_api.$_$.i;
  var AssemblyPartsComponent = kotlin_core_core_api.$_$.g;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.q;
  var AssemblyPartSnapInfo = kotlin_core_core_api.$_$.f;
  var Companion_getInstance = kotlin_core_core_api.$_$.rb;
  var AssemblyPart = kotlin_core_core_api.$_$.h;
  var Vector = kotlin_core_core_api.$_$.c5;
  var Companion_getInstance_0 = kotlin_core_core_api.$_$.kb;
  var Degrees = kotlin_core_core_api.$_$.s4;
  var Transform = kotlin_core_core_api.$_$.b5;
  var Companion_getInstance_1 = kotlin_core_core_api.$_$.pc;
  var emptyList = kotlin_kotlin.$_$.o5;
  var Comparator = kotlin_kotlin.$_$.pc;
  var compareValues = kotlin_kotlin.$_$.d8;
  var sortedWith = kotlin_kotlin.$_$.m7;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.v4;
  var AutoAdaptGuestComponent = kotlin_core_core_stl.$_$.k;
  var AutoAdaptHostComponent = kotlin_core_core_stl.$_$.l;
  var ColliderShapeComponent = kotlin_core_core_api.$_$.y;
  var Size = kotlin_core_core_api.$_$.a5;
  var THROW_CCE = kotlin_kotlin.$_$.ad;
  var ConnectorTagConstants_instance = kotlin_core_core_api.$_$.ea;
  var charSequenceLength = kotlin_kotlin.$_$.o8;
  var charSequenceGet = kotlin_kotlin.$_$.n8;
  var toString_0 = kotlin_kotlin.$_$.r1;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.o1;
  var ConnectorsComponent = kotlin_core_core_api.$_$.u1;
  var DragProjectionPointComponent = kotlin_core_core_stl.$_$.c1;
  var DragSurface = kotlin_core_core_api.$_$.o2;
  var DragSurfacesComponent = kotlin_core_core_api.$_$.n2;
  var FunctionalMarginShapeComponent = kotlin_core_core_stl.$_$.p1;
  var FunctionalZone = kotlin_core_core_stl.$_$.u1;
  var FunctionalZonesLocalComponent = kotlin_core_core_stl.$_$.s1;
  var LightComponent = kotlin_core_core_stl.$_$.o2;
  var MetaDataComponent = kotlin_core_core_range_dynamic_range.$_$.d;
  var ModelInfoComponent = kotlin_core_core_api.$_$.o5;
  var ModelTransformComponent = kotlin_core_core_api.$_$.p5;
  var PlacementZoneByHeightComponent = kotlin_core_core_stl.$_$.i2;
  var hashCode = kotlin_kotlin.$_$.a9;
  var equals = kotlin_kotlin.$_$.t8;
  var ProductStructureConnection = kotlin_core_core_api.$_$.u;
  var ProductStructureItem = kotlin_core_core_api.$_$.v;
  var ProductStructureComponent = kotlin_core_core_api.$_$.t;
  var RecommendedInitialPositionFromFloorComponent = kotlin_core_core_stl.$_$.j2;
  var RelativeConnectorsComponent = kotlin_core_core_api.$_$.d2;
  var ConnectionRootComponent = kotlin_core_core_api.$_$.k1;
  var DisplayNameComponent = kotlin_core_core_api.$_$.e5;
  var VisualLightSourceComponent = kotlin_core_core_range_dynamic_range.$_$.e;
  var addAll = kotlin_kotlin.$_$.m4;
  var HashSet_init_$Create$ = kotlin_kotlin.$_$.n;
  var toMutableList_0 = kotlin_kotlin.$_$.x7;
  var contains = kotlin_kotlin.$_$.x4;
  var listOf_0 = kotlin_kotlin.$_$.o6;
  var Regex_init_$Create$ = kotlin_kotlin.$_$.u;
  var map = kotlin_kotlin.$_$.za;
  var addAll_0 = kotlin_kotlin.$_$.n4;
  var distinct = kotlin_kotlin.$_$.n5;
  var Json = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.h;
  var objectMeta = kotlin_kotlin.$_$.t9;
  var replace = kotlin_kotlin.$_$.sb;
  var firstOrNull = kotlin_kotlin.$_$.u5;
  var defineProp = kotlin_kotlin.$_$.s8;
  var LoggerState_getInstance = kotlin_core_core_api.$_$.fb;
  var joinToString = kotlin_kotlin.$_$.e6;
  var toString_1 = kotlin_kotlin.$_$.ae;
  var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.s;
  var mutableListOf = kotlin_kotlin.$_$.u6;
  var removeAll = kotlin_kotlin.$_$.d7;
  var createCustomAssembly = kotlin_core_core_api.$_$.o;
  var createCustomAssemblySpecification = kotlin_core_core_api.$_$.n;
  var ProductCatalog = kotlin_core_core_api.$_$.p;
  var reversedArray = kotlin_kotlin.$_$.g7;
  var Exception_init_$Create$ = kotlin_kotlin.$_$.z;
  var PrimitiveClasses_getInstance = kotlin_kotlin.$_$.n3;
  var DoubleSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r;
  var ReferenceArraySerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.i2;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.h2;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t;
  var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.x;
  var PositionTemplateSerializer_getInstance = kotlin_core_core_range_dynamic_range.$_$.h1;
  var getKClass = kotlin_kotlin.$_$.d;
  var BooleanSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.d;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b2;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c2;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o2;
  var objectCreate = kotlin_kotlin.$_$.s9;
  var Companion_getInstance_2 = kotlin_core_core_range_dynamic_range.$_$.c1;
  var Companion_instance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.b;
  var JsonPrimitive = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.g;
  var get_contentOrNull = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.i;
  var toIntOrNull = kotlin_kotlin.$_$.dc;
  var Exception = kotlin_kotlin.$_$.uc;
  var JsonObject = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.f;
  var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t2;
  var toMutableMap = kotlin_kotlin.$_$.z7;
  var plus_0 = kotlin_kotlin.$_$.x6;
  var plus_1 = kotlin_kotlin.$_$.y6;
  var sort = kotlin_kotlin.$_$.p7;
  var joinToString_0 = kotlin_kotlin.$_$.f6;
  var ConnectorItemTemplate = kotlin_core_core_range_dynamic_range.$_$.p;
  var Companion_getInstance_3 = kotlin_core_core_range_dynamic_range.$_$.b1;
  var ProductStructureItemTemplate = kotlin_core_core_range_dynamic_range.$_$.j;
  var $serializer_getInstance = kotlin_core_core_range_dynamic_range.$_$.w;
  var IntSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s;
  var JsonElementSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.c;
  var LinkedHashMapSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e2;
  var PolymorphicSerializer_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a;
  var CustomSerializer_getInstance = kotlin_core_core_range_dynamic_range.$_$.u;
  var $serializer_getInstance_0 = kotlin_core_core_api.$_$.hb;
  var CustomSerializer_getInstance_0 = kotlin_core_core_range_dynamic_range.$_$.a1;
  var $serializer_getInstance_1 = kotlin_core_core_range_dynamic_range.$_$.g1;
  var MarginTemplateSerializer_getInstance = kotlin_core_core_range_dynamic_range.$_$.f1;
  var $serializer_getInstance_2 = kotlin_core_core_range_dynamic_range.$_$.i1;
  var CustomSerializer_getInstance_1 = kotlin_core_core_range_dynamic_range.$_$.d1;
  var throwArrayMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.n2;
  var Part = kotlin_core_core_range_dynamic_range.$_$.h;
  var $serializer_getInstance_3 = kotlin_core_core_range_dynamic_range.$_$.v;
  var $serializer_getInstance_4 = kotlin_core_core_api.$_$.pb;
  var mapCapacity = kotlin_kotlin.$_$.q6;
  var coerceAtLeast = kotlin_kotlin.$_$.fa;
  var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.p;
  var get_elementNames = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p1;
  var get_jsonObject = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.m;
  var contains_0 = kotlin_kotlin.$_$.w4;
  var to = kotlin_kotlin.$_$.be;
  var toMap = kotlin_kotlin.$_$.w7;
  var get_jsonArray = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.l;
  //endregion
  //region block: pre-declaration
  setMetadataFor(ComponentMultiBuilder, 'ComponentMultiBuilder', interfaceMeta);
  setMetadataFor(ComponentSingleBuilder, 'ComponentSingleBuilder', interfaceMeta);
  setMetadataFor(ComponentsCommonData, 'ComponentsCommonData', classMeta);
  setMetadataFor(CustomComponentBuilder, 'CustomComponentBuilder', interfaceMeta);
  setMetadataFor(StaticComponentBuilder, 'StaticComponentBuilder', classMeta, VOID, [CustomComponentBuilder]);
  setMetadataFor(ProductSpecificationBuilder, 'ProductSpecificationBuilder', classMeta);
  setMetadataFor(AllowedDoorPairsComponentBuilder, 'AllowedDoorPairsComponentBuilder', classMeta, VOID, [ComponentSingleBuilder], AllowedDoorPairsComponentBuilder);
  setMetadataFor(AssemblyComponentsBuilder, 'AssemblyComponentsBuilder', classMeta, VOID, [ComponentMultiBuilder]);
  setMetadataFor(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', classMeta, VOID, [Comparator]);
  setMetadataFor(AutoAdaptGuestComponentBuilder, 'AutoAdaptGuestComponentBuilder', classMeta, VOID, [ComponentSingleBuilder]);
  setMetadataFor(AutoAdaptHostComponentBuilder, 'AutoAdaptHostComponentBuilder', classMeta, VOID, [ComponentSingleBuilder], AutoAdaptHostComponentBuilder);
  setMetadataFor(BooleanComponentBuilder, 'BooleanComponentBuilder', classMeta, VOID, [ComponentSingleBuilder]);
  setMetadataFor(ColliderShapeComponentBuilder, 'ColliderShapeComponentBuilder', classMeta, VOID, [ComponentSingleBuilder], ColliderShapeComponentBuilder);
  setMetadataFor(ConnectorsComponentBuilder, 'ConnectorsComponentBuilder', classMeta, VOID, [ComponentSingleBuilder], ConnectorsComponentBuilder);
  setMetadataFor(DragProjectionPointComponentBuilder, 'DragProjectionPointComponentBuilder', classMeta, VOID, [ComponentSingleBuilder], DragProjectionPointComponentBuilder);
  setMetadataFor(DragSurfacesComponentBuilder, 'DragSurfacesComponentBuilder', classMeta, VOID, [ComponentSingleBuilder], DragSurfacesComponentBuilder);
  setMetadataFor(FunctionalMarginShapeComponentBuilder, 'FunctionalMarginShapeComponentBuilder', classMeta, VOID, [ComponentSingleBuilder], FunctionalMarginShapeComponentBuilder);
  setMetadataFor(FunctionalZonesLocalComponentBuilder, 'FunctionalZonesLocalComponentBuilder', classMeta, VOID, [ComponentSingleBuilder], FunctionalZonesLocalComponentBuilder);
  setMetadataFor(LightComponentBuilder, 'LightComponentBuilder', classMeta, VOID, [ComponentSingleBuilder], LightComponentBuilder);
  setMetadataFor(MetaDataComponentBuilder, 'MetaDataComponentBuilder', classMeta, VOID, [ComponentSingleBuilder], MetaDataComponentBuilder);
  setMetadataFor(ModelInfoComponentBuilder, 'ModelInfoComponentBuilder', classMeta, VOID, [ComponentSingleBuilder], ModelInfoComponentBuilder);
  setMetadataFor(ModelTransformComponentBuilder, 'ModelTransformComponentBuilder', classMeta, VOID, [ComponentSingleBuilder], ModelTransformComponentBuilder);
  setMetadataFor(PlacementZoneByHeightComponentBuilder, 'PlacementZoneByHeightComponentBuilder', classMeta, VOID, [ComponentSingleBuilder], PlacementZoneByHeightComponentBuilder);
  setMetadataFor(PolyhedronColliderIdsPair, 'PolyhedronColliderIdsPair', classMeta);
  setMetadataFor(ProductStructureComponentBuilder, 'ProductStructureComponentBuilder', classMeta, VOID, [ComponentSingleBuilder], ProductStructureComponentBuilder);
  setMetadataFor(ProppingComponentBuilder, 'ProppingComponentBuilder', classMeta, VOID, [ComponentSingleBuilder], ProppingComponentBuilder);
  setMetadataFor(RecommendedInitialPositionFromFloorComponentBuilder, 'RecommendedInitialPositionFromFloorComponentBuilder', classMeta, VOID, [ComponentSingleBuilder], RecommendedInitialPositionFromFloorComponentBuilder);
  setMetadataFor(RelativeConnectorsComponentBuilder, 'RelativeConnectorsComponentBuilder', classMeta, VOID, [ComponentSingleBuilder], RelativeConnectorsComponentBuilder);
  setMetadataFor(RequiredComponentsBuilder, 'RequiredComponentsBuilder', classMeta, VOID, [ComponentMultiBuilder], RequiredComponentsBuilder);
  setMetadataFor(VisualLightSourceComponentBuilder, 'VisualLightSourceComponentBuilder', classMeta, VOID, [ComponentSingleBuilder], VisualLightSourceComponentBuilder);
  setMetadataFor(Companion, 'Companion', objectMeta);
  setMetadataFor(IPEXRangeFormatCatalog, 'IPEXRangeFormatCatalog', classMeta, VOID, [ProductCatalog], IPEXRangeFormatCatalog);
  setMetadataFor(AmendableCatalog, 'AmendableCatalog', classMeta, IPEXRangeFormatCatalog, VOID, AmendableCatalog);
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor(InheritanceResolver, 'InheritanceResolver', classMeta);
  setMetadataFor(ReadOnlyItemRepository, 'ReadOnlyItemRepository', interfaceMeta);
  setMetadataFor(ItemRepository, 'ItemRepository', classMeta, VOID, [ReadOnlyItemRepository], ItemRepository);
  setMetadataFor(Companion_1, 'Companion', objectMeta);
  setMetadataFor($serializer, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(AssemblyChildDTO, 'AssemblyChildDTO', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_5});
  setMetadataFor(Companion_2, 'Companion', objectMeta);
  setMetadataFor($serializer_0, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ColliderDTO, 'ColliderDTO', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_6});
  setMetadataFor(CustomSerializer, 'CustomSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(ProductDTO, 'ProductDTO', classMeta, VOID, VOID, VOID, VOID, {0: CustomSerializer_getInstance_2});
  setMetadataFor(Companion_3, 'Companion', objectMeta);
  setMetadataFor($serializer_1, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ItemComponentsDTO, 'ItemComponentsDTO', classMeta, VOID, VOID, ItemComponentsDTO, VOID, {0: $serializer_getInstance_7});
  setMetadataFor(Companion_4, 'Companion', objectMeta);
  setMetadataFor($serializer_2, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ItemParametersDTO, 'ItemParametersDTO', classMeta, VOID, VOID, ItemParametersDTO, VOID, {0: $serializer_getInstance_8});
  setMetadataFor(Companion_5, 'Companion', objectMeta);
  setMetadataFor($serializer_3, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RangeItemDTO, 'RangeItemDTO', classMeta, VOID, VOID, RangeItemDTO, VOID, {0: $serializer_getInstance_9});
  setMetadataFor(Companion_6, 'Companion', objectMeta);
  setMetadataFor(ItemParser, 'ItemParser', classMeta, VOID, VOID, ItemParser);
  //endregion
  function ComponentMultiBuilder() {
  }
  function ComponentSingleBuilder() {
  }
  function buildColliders($this, data, item) {
    var tmp0_safe_receiver = item.parameters;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.size;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.builder.ComponentsCommonData.buildColliders.<anonymous>' call
      var tmp_0;
      try {
        // Inline function 'kotlin.collections.mutableListOf' call
        var ids = ArrayList_init_$Create$();
        // Inline function 'kotlin.collections.toTypedArray' call
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$_0(data.length);
        var inductionVariable = 0;
        var last = data.length;
        while (inductionVariable < last) {
          var item_0 = data[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.range.ipex.range.builder.ComponentsCommonData.buildColliders.<anonymous>.<anonymous>' call
          ids.q(item_0.id);
          var tmp$ret$1 = $this.getPolyhedronForSize(item_0.dimension, tmp1_safe_receiver);
          destination.q(tmp$ret$1);
        }
        var polyhedra = copyToArray(destination);
        var tmp_1 = $this;
        var tmp_2;
        // Inline function 'kotlin.collections.isEmpty' call
        if (polyhedra.length === 0) {
          tmp_2 = null;
        } else {
          var tmp_3 = merge(polyhedra);
          // Inline function 'kotlin.collections.toTypedArray' call
          var tmp$ret$6 = copyToArray(ids);
          tmp_2 = new PolyhedronColliderIdsPair(tmp_3, tmp$ret$6);
        }
        tmp_1.o4a_1 = tmp_2;
        tmp_0 = $this.o4a_1;
      } catch ($p) {
        var tmp_4;
        if ($p instanceof Error_0) {
          var e = $p;
          var message = 'Specification of collider not valid. ' + e.message;
          throw IllegalStateException_init_$Create$(toString(message));
        } else {
          throw $p;
        }
      }
      tmp = tmp_0;
    }
    var tmp2_elvis_lhs = tmp;
    var tmp_5;
    if (tmp2_elvis_lhs == null) {
      var message_0 = 'No size set on ' + item.id;
      throw IllegalStateException_init_$Create$(toString(message_0));
    } else {
      tmp_5 = tmp2_elvis_lhs;
    }
    return tmp_5;
  }
  function ComponentsCommonData(item, modelRootURL) {
    modelRootURL = modelRootURL === VOID ? null : modelRootURL;
    this.item = item;
    this.modelRootURL = modelRootURL;
    this.o4a_1 = null;
  }
  protoOf(ComponentsCommonData).p4a = function () {
    return this.item;
  };
  protoOf(ComponentsCommonData).f48 = function () {
    return this.modelRootURL;
  };
  protoOf(ComponentsCommonData).getColliders = function (colliders) {
    var tmp;
    if (colliders == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.builder.ComponentsCommonData.getColliders.<anonymous>' call
      var tmp0_elvis_lhs = this.o4a_1;
      tmp = tmp0_elvis_lhs == null ? buildColliders(this, colliders, this.item) : tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(ComponentsCommonData).getPolyhedronForSize = function (dimension, size) {
    var tmp;
    if (dimension == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.builder.ComponentsCommonData.getPolyhedronForSize.<anonymous>' call
      tmp = dimension.getPolyhedronForSize(size);
    }
    var tmp4_elvis_lhs = tmp;
    var tmp_0;
    if (tmp4_elvis_lhs == null) {
      var tmp1_width = size.s2e_1;
      var tmp2_height = size.t2e_1;
      var tmp3_depth = size.u2e_1;
      tmp_0 = (new Dimension(VOID, VOID, tmp3_depth, VOID, tmp2_height, VOID, VOID, VOID, tmp1_width)).getPolyhedronForSize(size);
    } else {
      tmp_0 = tmp4_elvis_lhs;
    }
    return tmp_0;
  };
  function CustomComponentBuilder() {
  }
  function StaticComponentBuilder(component) {
    this.q4a_1 = component;
  }
  protoOf(StaticComponentBuilder).r4a = function (rangeItem, components, commonData) {
    return this.q4a_1;
  };
  protoOf(StaticComponentBuilder).build = function (rangeItem, components, commonData) {
    return this.r4a(rangeItem, components, commonData);
  };
  protoOf(StaticComponentBuilder).s4a = function (parentCustomComponentBuilder) {
    return this;
  };
  protoOf(StaticComponentBuilder).inherit = function (parentCustomComponentBuilder) {
    return this.s4a(parentCustomComponentBuilder);
  };
  function buildComponents($this, rangeItem) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var allComponents = ArrayList_init_$Create$();
    var commonData = new ComponentsCommonData(rangeItem, $this.t4a_1);
    if (!(rangeItem.components == null)) {
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = rangeItem.components.customComponents.p2().t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.range.ipex.range.builder.ProductSpecificationBuilder.buildComponents.<anonymous>' call
        allComponents.q(element.build(rangeItem, rangeItem.components, commonData));
      }
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator_0 = $this.u4a_1.t();
      while (tmp0_iterator_0.u()) {
        var element_0 = tmp0_iterator_0.w();
        // Inline function 'com.ikea.range.ipex.range.builder.ProductSpecificationBuilder.buildComponents.<anonymous>' call
        allComponents.q(element_0.buildSingle(rangeItem, rangeItem.components, commonData));
      }
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator_1 = $this.v4a_1.t();
      while (tmp0_iterator_1.u()) {
        var element_1 = tmp0_iterator_1.w();
        // Inline function 'com.ikea.range.ipex.range.builder.ProductSpecificationBuilder.buildComponents.<anonymous>' call
        allComponents.x(element_1.buildMulti(rangeItem, rangeItem.components, commonData));
      }
    }
    return filterNotNull(allComponents);
  }
  function ProductSpecificationBuilder$singleBuilders$lambda() {
    return new SelectableComponent();
  }
  function ProductSpecificationBuilder$singleBuilders$lambda_0(it) {
    return it.selectable === true;
  }
  function ProductSpecificationBuilder$singleBuilders$lambda_1() {
    return new OutlineableComponent();
  }
  function ProductSpecificationBuilder$singleBuilders$lambda_2(it) {
    return it.outlineable === true;
  }
  function ProductSpecificationBuilder$singleBuilders$lambda_3() {
    return new DraggableComponent();
  }
  function ProductSpecificationBuilder$singleBuilders$lambda_4(it) {
    return it.draggable === true;
  }
  function ProductSpecificationBuilder$singleBuilders$lambda_5() {
    return DoorComponent_getInstance();
  }
  function ProductSpecificationBuilder$singleBuilders$lambda_6(it) {
    return it.door === true;
  }
  function ProductSpecificationBuilder$singleBuilders$lambda_7() {
    return DoorFrontComponent_getInstance();
  }
  function ProductSpecificationBuilder$singleBuilders$lambda_8(it) {
    return it.doorFront === true;
  }
  function ProductSpecificationBuilder$singleBuilders$lambda_9() {
    return HandleComponent_getInstance();
  }
  function ProductSpecificationBuilder$singleBuilders$lambda_10(it) {
    return it.handle === true;
  }
  function ProductSpecificationBuilder$singleBuilders$lambda_11() {
    return DrawerComponent_getInstance();
  }
  function ProductSpecificationBuilder$singleBuilders$lambda_12(it) {
    return it.drawer === true;
  }
  function ProductSpecificationBuilder$singleBuilders$lambda_13() {
    return FrameComponent_getInstance();
  }
  function ProductSpecificationBuilder$singleBuilders$lambda_14(it) {
    return it.frame === true;
  }
  function ProductSpecificationBuilder$singleBuilders$lambda_15() {
    return LegComponent_getInstance();
  }
  function ProductSpecificationBuilder$singleBuilders$lambda_16(it) {
    return it.leg === true;
  }
  function ProductSpecificationBuilder$singleBuilders$lambda_17() {
    return new OutlinedComponent();
  }
  function ProductSpecificationBuilder$singleBuilders$lambda_18(it) {
    return it.outlined === true;
  }
  function ProductSpecificationBuilder$singleBuilders$lambda_19() {
    return ProppingComponent_instance;
  }
  function ProductSpecificationBuilder$singleBuilders$lambda_20(it) {
    return it.propping === true;
  }
  function ProductSpecificationBuilder$singleBuilders$lambda_21() {
    return AlwaysHangDownComponent_instance;
  }
  function ProductSpecificationBuilder$singleBuilders$lambda_22(it) {
    return it.alwaysHangDown === true;
  }
  function ProductSpecificationBuilder$singleBuilders$lambda_23() {
    return new UnserializableEntityComponent();
  }
  function ProductSpecificationBuilder$singleBuilders$lambda_24(it) {
    return it.serializeEntity === false;
  }
  function ProductSpecificationBuilder(itemRepository, modelRootURL) {
    modelRootURL = modelRootURL === VOID ? null : modelRootURL;
    this.t4a_1 = modelRootURL;
    var tmp = this;
    var tmp_0 = new AutoAdaptGuestComponentBuilder(itemRepository);
    var tmp_1 = ProductSpecificationBuilder$singleBuilders$lambda;
    var tmp_2 = new BooleanComponentBuilder(tmp_1, ProductSpecificationBuilder$singleBuilders$lambda_0);
    var tmp_3 = ProductSpecificationBuilder$singleBuilders$lambda_1;
    var tmp_4 = new BooleanComponentBuilder(tmp_3, ProductSpecificationBuilder$singleBuilders$lambda_2);
    var tmp_5 = ProductSpecificationBuilder$singleBuilders$lambda_3;
    var tmp_6 = new BooleanComponentBuilder(tmp_5, ProductSpecificationBuilder$singleBuilders$lambda_4);
    var tmp_7 = ProductSpecificationBuilder$singleBuilders$lambda_5;
    var tmp_8 = new BooleanComponentBuilder(tmp_7, ProductSpecificationBuilder$singleBuilders$lambda_6);
    var tmp_9 = ProductSpecificationBuilder$singleBuilders$lambda_7;
    var tmp_10 = new BooleanComponentBuilder(tmp_9, ProductSpecificationBuilder$singleBuilders$lambda_8);
    var tmp_11 = ProductSpecificationBuilder$singleBuilders$lambda_9;
    var tmp_12 = new BooleanComponentBuilder(tmp_11, ProductSpecificationBuilder$singleBuilders$lambda_10);
    var tmp_13 = ProductSpecificationBuilder$singleBuilders$lambda_11;
    var tmp_14 = new BooleanComponentBuilder(tmp_13, ProductSpecificationBuilder$singleBuilders$lambda_12);
    var tmp_15 = ProductSpecificationBuilder$singleBuilders$lambda_13;
    var tmp_16 = new BooleanComponentBuilder(tmp_15, ProductSpecificationBuilder$singleBuilders$lambda_14);
    var tmp_17 = ProductSpecificationBuilder$singleBuilders$lambda_15;
    var tmp_18 = new BooleanComponentBuilder(tmp_17, ProductSpecificationBuilder$singleBuilders$lambda_16);
    var tmp_19 = ProductSpecificationBuilder$singleBuilders$lambda_17;
    var tmp_20 = new BooleanComponentBuilder(tmp_19, ProductSpecificationBuilder$singleBuilders$lambda_18);
    var tmp_21 = ProductSpecificationBuilder$singleBuilders$lambda_19;
    var tmp_22 = new BooleanComponentBuilder(tmp_21, ProductSpecificationBuilder$singleBuilders$lambda_20);
    var tmp_23 = ProductSpecificationBuilder$singleBuilders$lambda_21;
    var tmp_24 = new BooleanComponentBuilder(tmp_23, ProductSpecificationBuilder$singleBuilders$lambda_22);
    var tmp_25 = ProductSpecificationBuilder$singleBuilders$lambda_23;
    tmp.u4a_1 = listOf([tmp_0, tmp_2, tmp_4, tmp_6, tmp_8, tmp_10, tmp_12, tmp_14, tmp_16, tmp_18, tmp_20, tmp_22, tmp_24, new BooleanComponentBuilder(tmp_25, ProductSpecificationBuilder$singleBuilders$lambda_24), new ConnectorsComponentBuilder(), new ModelInfoComponentBuilder(), new ModelTransformComponentBuilder(), new RelativeConnectorsComponentBuilder(), new ColliderShapeComponentBuilder(), new MetaDataComponentBuilder(), new AllowedDoorPairsComponentBuilder(), new AutoAdaptHostComponentBuilder(), new LightComponentBuilder(), new PlacementZoneByHeightComponentBuilder(), new RecommendedInitialPositionFromFloorComponentBuilder(), new VisualLightSourceComponentBuilder(), new DragProjectionPointComponentBuilder(), new FunctionalMarginShapeComponentBuilder(), new FunctionalZonesLocalComponentBuilder(), new ProppingComponentBuilder(), new DragSurfacesComponentBuilder(), new ProductStructureComponentBuilder()]);
    this.v4a_1 = listOf([new RequiredComponentsBuilder(), new AssemblyComponentsBuilder(itemRepository)]);
  }
  protoOf(ProductSpecificationBuilder).buildProductSpecification = function (rangeItem) {
    var productComponent = new ProductComponent(rangeItem.id);
    var components = buildComponents(this, rangeItem);
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = plus(components, productComponent);
    var tmp$ret$0 = copyToArray(this_0);
    return new ProductSpecification(tmp$ret$0);
  };
  function AllowedDoorPairsComponentBuilder() {
  }
  protoOf(AllowedDoorPairsComponentBuilder).buildSingle = function (item, components, commonData) {
    var tmp0_safe_receiver = components.allowedDoorPairs;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.builder.component.AllowedDoorPairsComponentBuilder.buildSingle.<anonymous>' call
      tmp = AllowedDoorPairsComponentFromArrays(tmp0_safe_receiver);
    }
    return tmp;
  };
  function buildAssemblyComponents($this, rangeItem, components) {
    var tmp0_safe_receiver = rangeItem.parameters;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.parts;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : toMutableList(tmp1_safe_receiver);
    var tmp;
    if (tmp2_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.builder.component.AssemblyComponentsBuilder.buildAssemblyComponents.<anonymous>' call
      var tmp0_safe_receiver_0 = components.assembly;
      var tmp_0;
      if (tmp0_safe_receiver_0 == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.range.ipex.range.builder.component.AssemblyComponentsBuilder.buildAssemblyComponents.<anonymous>.<anonymous>' call
        tmp_0 = mapPartsToAssemblyStructureChildren($this, tmp2_safe_receiver, tmp0_safe_receiver_0, rangeItem.parameters.size);
      }
      tmp = tmp_0;
    }
    var tmp3_elvis_lhs = tmp;
    var tmp_1;
    if (tmp3_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      var tmp$ret$4 = [];
      tmp_1 = new Pair(tmp$ret$4, emptyMap());
    } else {
      tmp_1 = tmp3_elvis_lhs;
    }
    var tmp4_container = tmp_1;
    var assemblyParts = tmp4_container.af();
    var partsMap = tmp4_container.bf();
    return listOf([new AssemblyStructureComponent(assemblyParts), new AssemblyPartsComponent(partsMap)]);
  }
  function mapPartsToAssemblyStructureChildren($this, catalogParts, assemblyChildren, catalogSize) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var assemblyParts = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.mutableMapOf' call
    var partsMap = LinkedHashMap_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = assemblyChildren.length;
    while (inductionVariable < last) {
      var element = assemblyChildren[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.range.ipex.range.builder.component.AssemblyComponentsBuilder.mapPartsToAssemblyStructureChildren.<anonymous>' call
      var tmp$ret$3;
      $l$block: {
        // Inline function 'kotlin.collections.indexOfFirst' call
        var index = 0;
        var tmp0_iterator = catalogParts.t();
        while (tmp0_iterator.u()) {
          var item = tmp0_iterator.w();
          // Inline function 'com.ikea.range.ipex.range.builder.component.AssemblyComponentsBuilder.mapPartsToAssemblyStructureChildren.<anonymous>.<anonymous>' call
          if (item.partKey === element.partKey) {
            tmp$ret$3 = index;
            break $l$block;
          }
          index = index + 1 | 0;
        }
        tmp$ret$3 = -1;
      }
      var partIndex = tmp$ret$3;
      var tmp;
      if (!(element.connector == null) ? !(element.connectorOnHost == null) : false) {
        tmp = new AssemblyPartSnapInfo(element.connectorOnHost, element.connector);
      } else {
        tmp = null;
      }
      var snapInfo = tmp;
      if (partIndex > -1) {
        var part = catalogParts.h1(partIndex);
        var tmp_0;
        if (!(element.children == null)) {
          var tmp0_safe_receiver = $this.w4a_1.findItemDTO(part.id);
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.parameters;
          var childCatalogSize = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.size;
          tmp_0 = mapPartsToAssemblyStructureChildren($this, catalogParts, element.children, childCatalogSize);
        } else {
          tmp_0 = new Pair(null, null);
        }
        var tmp2_container = tmp_0;
        var children = tmp2_container.af();
        var childrenParts = tmp2_container.bf();
        if (childrenParts == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          partsMap.s2(childrenParts);
        }
        var tmp_1;
        if (!(element.position == null)) {
          var tmp_2;
          if (!(catalogSize == null)) {
            tmp_2 = element.position.applyToBox(Companion_getInstance_1().fromSize(catalogSize.vector));
          } else {
            tmp_2 = element.position.absoluteTransform;
          }
          tmp_1 = tmp_2;
        } else if (!(element.transform == null)) {
          tmp_1 = new Transform(new Vector(element.transform[0], element.transform[1], element.transform[2]), Companion_getInstance_0().fromEulerDegrees(new Degrees(element.transform[3]), new Degrees(element.transform[4]), new Degrees(element.transform[5])));
        } else {
          tmp_1 = Companion_getInstance().IDENTITY;
        }
        var transform = tmp_1;
        var tmp4_elvis_lhs = element.locked;
        var assemblyPart = new AssemblyPart(element.partKey, transform, snapInfo, children, tmp4_elvis_lhs == null ? true : tmp4_elvis_lhs);
        // Inline function 'kotlin.collections.set' call
        var key = element.partKey;
        var value = part.id;
        partsMap.r2(key, value);
        assemblyParts.q(assemblyPart);
      } else {
        var tmp5_safe_receiver = element.position;
        var tmp6_elvis_lhs = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.absoluteTransform;
        var transform_0 = tmp6_elvis_lhs == null ? Companion_getInstance().IDENTITY : tmp6_elvis_lhs;
        var tmp7_elvis_lhs = element.locked;
        var assemblyPart_0 = new AssemblyPart(element.partKey, transform_0, snapInfo, null, tmp7_elvis_lhs == null ? true : tmp7_elvis_lhs);
        // Inline function 'kotlin.collections.set' call
        var key_0 = element.partKey;
        partsMap.r2(key_0, '');
        assemblyParts.q(assemblyPart_0);
      }
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$5 = copyToArray(assemblyParts);
    return new Pair(tmp$ret$5, partsMap);
  }
  function AssemblyComponentsBuilder(itemRepository) {
    this.w4a_1 = itemRepository;
  }
  protoOf(AssemblyComponentsBuilder).buildMulti = function (item, components, commonData) {
    var tmp;
    if (!(components.assembly == null)) {
      tmp = buildAssemblyComponents(this, item, components);
    } else {
      tmp = emptyList();
    }
    return tmp;
  };
  function sam$kotlin_Comparator$0(function_0) {
    this.x4a_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0).u1j = function (a, b) {
    return this.x4a_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
    return this.u1j(a, b);
  };
  function AutoAdaptGuestComponentBuilder$buildSingle$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'com.ikea.range.ipex.range.builder.component.AutoAdaptGuestComponentBuilder.buildSingle.<anonymous>.<anonymous>' call
    var tmp0_safe_receiver = b.components;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.autoAdaptGroup;
    var tmp = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.priority;
    // Inline function 'com.ikea.range.ipex.range.builder.component.AutoAdaptGuestComponentBuilder.buildSingle.<anonymous>.<anonymous>' call
    var tmp0_safe_receiver_0 = a.components;
    var tmp1_safe_receiver_0 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.autoAdaptGroup;
    var tmp$ret$1 = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.priority;
    return compareValues(tmp, tmp$ret$1);
  }
  function AutoAdaptGuestComponentBuilder(itemRepository) {
    this.y4a_1 = itemRepository;
  }
  protoOf(AutoAdaptGuestComponentBuilder).buildSingle = function (item, components, commonData) {
    var tmp0_safe_receiver = components.autoAdaptGroup;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.builder.component.AutoAdaptGuestComponentBuilder.buildSingle.<anonymous>' call
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.sortedByDescending' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_0 = this.y4a_1.getAllItemDTOs();
      var destination = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.range.ipex.range.builder.component.AutoAdaptGuestComponentBuilder.buildSingle.<anonymous>.<anonymous>' call
        var tmp0_safe_receiver_0 = element.components;
        var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.autoAdaptGroup;
        if ((tmp1_safe_receiver == null ? null : tmp1_safe_receiver.key) === tmp0_safe_receiver.key) {
          destination.q(element);
        }
      }
      // Inline function 'kotlin.comparisons.compareByDescending' call
      var tmp_0 = AutoAdaptGuestComponentBuilder$buildSingle$lambda;
      var tmp$ret$3 = new sam$kotlin_Comparator$0(tmp_0);
      var this_1 = sortedWith(destination, tmp$ret$3);
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_1, 10));
      var tmp0_iterator = this_1.t();
      while (tmp0_iterator.u()) {
        var item_0 = tmp0_iterator.w();
        // Inline function 'com.ikea.range.ipex.range.builder.component.AutoAdaptGuestComponentBuilder.buildSingle.<anonymous>.<anonymous>' call
        var tmp$ret$5 = item_0.id;
        destination_0.q(tmp$ret$5);
      }
      var variants = copyToArray(destination_0);
      tmp = new AutoAdaptGuestComponent(variants, tmp0_safe_receiver.key);
    }
    return tmp;
  };
  function AutoAdaptHostComponentBuilder() {
  }
  protoOf(AutoAdaptHostComponentBuilder).buildSingle = function (item, components, commonData) {
    var tmp0_safe_receiver = components.autoAdaptHost;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.builder.component.AutoAdaptHostComponentBuilder.buildSingle.<anonymous>' call
      var tmp0_safe_receiver_0 = item.parameters;
      var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.size;
      var tmp_0;
      if (tmp1_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.range.ipex.range.builder.component.AutoAdaptHostComponentBuilder.buildSingle.<anonymous>.<anonymous>' call
        var tmp3_elvis_lhs = tmp0_safe_receiver.hostZone;
        var tmp_1;
        if (tmp3_elvis_lhs == null) {
          var tmp0_width = tmp1_safe_receiver.s2e_1;
          var tmp1_height = tmp1_safe_receiver.t2e_1;
          var tmp2_depth = tmp1_safe_receiver.u2e_1;
          tmp_1 = new Dimension(VOID, VOID, tmp2_depth, VOID, tmp1_height, VOID, VOID, VOID, tmp0_width);
        } else {
          tmp_1 = tmp3_elvis_lhs;
        }
        var dim = tmp_1;
        tmp_0 = new AutoAdaptHostComponent(dim.getPolyhedronForSize(tmp1_safe_receiver));
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  function BooleanComponentBuilder(builder, selector) {
    this.builder = builder;
    this.selector = selector;
  }
  protoOf(BooleanComponentBuilder).z4a = function () {
    return this.builder;
  };
  protoOf(BooleanComponentBuilder).a4b = function () {
    return this.selector;
  };
  protoOf(BooleanComponentBuilder).buildSingle = function (item, components, commonData) {
    var tmp;
    if (this.selector(components)) {
      tmp = this.builder();
    } else {
      tmp = null;
    }
    return tmp;
  };
  function ColliderShapeComponentBuilder() {
  }
  protoOf(ColliderShapeComponentBuilder).buildSingle = function (item, components, commonData) {
    var tmp0_safe_receiver = components.colliders;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp_0;
      // Inline function 'kotlin.collections.isEmpty' call
      if (tmp0_safe_receiver.length === 0) {
        tmp_0 = null;
      } else {
        var tmp0_safe_receiver_0 = commonData.getColliders(tmp0_safe_receiver);
        var tmp_1;
        if (tmp0_safe_receiver_0 == null) {
          tmp_1 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'com.ikea.range.ipex.range.builder.component.ColliderShapeComponentBuilder.buildSingle.<anonymous>.<anonymous>' call
          tmp_1 = new ColliderShapeComponent(tmp0_safe_receiver_0.b4b_1, tmp0_safe_receiver_0.c4b_1);
        }
        return tmp_1;
      }
      return tmp_0;
    }
    return tmp;
  };
  function buildConnector($this, data, item) {
    var tmp0_safe_receiver = item.parameters;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.size;
    var tmp = tmp1_elvis_lhs == null ? new Size() : tmp1_elvis_lhs;
    return data.getConnectorForSize(tmp, ConnectorsComponentBuilder$buildConnector$lambda($this, data, item));
  }
  function addConnectorTags($this, data, item, connector) {
    var tmp0_safe_receiver = data.demands;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.builder.component.ConnectorsComponentBuilder.addConnectorTags.<anonymous>' call
      var tmp0_safe_receiver_0 = item.parameters;
      connector.setDemands(convertMagicLabels($this, tmp0_safe_receiver, tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.labels).slice());
    }
    var tmp1_safe_receiver = data.offers;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.builder.component.ConnectorsComponentBuilder.addConnectorTags.<anonymous>' call
      var tmp0_safe_receiver_1 = item.parameters;
      connector.setOffers(convertMagicLabels($this, tmp1_safe_receiver, tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.labels).slice());
    }
    var tmp;
    if (!(data.requireUpwardParent == null)) {
      var tmp_0 = data.requireUpwardParent;
      tmp = (!(tmp_0 == null) ? typeof tmp_0 === 'boolean' : false) ? tmp_0 : THROW_CCE();
    } else {
      tmp = false;
    }
    if (tmp) {
      connector.withTag('requireUpwardParent');
    }
    var tmp_1;
    if (!(data.requireDownwardParent == null)) {
      var tmp_2 = data.requireDownwardParent;
      tmp_1 = (!(tmp_2 == null) ? typeof tmp_2 === 'boolean' : false) ? tmp_2 : THROW_CCE();
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      connector.withTag('requireDownwardParent');
    }
    return connector;
  }
  function convertMagicLabels($this, connectorLabels, parameterLabels) {
    var tmp;
    if (parameterLabels == null) {
      tmp = connectorLabels;
    } else {
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(connectorLabels.length);
      var inductionVariable = 0;
      var last = connectorLabels.length;
      while (inductionVariable < last) {
        var item = connectorLabels[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.range.ipex.range.builder.component.ConnectorsComponentBuilder.convertMagicLabels.<anonymous>' call
        var tmp_0;
        try {
          var result = '';
          var curParam = null;
          var inductionVariable_0 = 0;
          var last_0 = charSequenceLength(item) - 1 | 0;
          if (inductionVariable_0 <= last_0)
            do {
              var i = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              if (curParam == null ? charSequenceGet(item, i) === _Char___init__impl__6a9atx(123) : false)
                curParam = '';
              else if (!(curParam == null) ? !(charSequenceGet(item, i) === _Char___init__impl__6a9atx(125)) : false)
                curParam = curParam + toString_0(charSequenceGet(item, i));
              else if (!(curParam == null) ? charSequenceGet(item, i) === _Char___init__impl__6a9atx(125) : false) {
                var tmp1_safe_receiver = parameterLabels.b3(curParam);
                var tmp_1;
                if (tmp1_safe_receiver == null) {
                  tmp_1 = null;
                } else {
                  // Inline function 'kotlin.let' call
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'com.ikea.range.ipex.range.builder.component.ConnectorsComponentBuilder.convertMagicLabels.<anonymous>.<anonymous>' call
                  tmp_1 = result + tmp1_safe_receiver;
                }
                var tmp2_elvis_lhs = tmp_1;
                var tmp_2;
                if (tmp2_elvis_lhs == null) {
                  var message = 'magic failed';
                  throw IllegalStateException_init_$Create$(toString(message));
                } else {
                  tmp_2 = tmp2_elvis_lhs;
                }
                result = tmp_2;
                curParam = null;
              } else
                result = result + toString_0(charSequenceGet(item, i));
            }
             while (inductionVariable_0 <= last_0);
          tmp_0 = result;
        } catch ($p) {
          var tmp_3;
          if ($p instanceof Error_0) {
            var e = $p;
            tmp_3 = item;
          } else {
            throw $p;
          }
          tmp_0 = tmp_3;
        }
        var tmp$ret$2 = tmp_0;
        destination.q(tmp$ret$2);
      }
      tmp = copyToArray(destination);
    }
    return tmp;
  }
  function ConnectorsComponentBuilder$buildConnector$lambda(this$0, $data, $item) {
    return function (it) {
      addConnectorTags(this$0, $data, $item, it);
      return Unit_instance;
    };
  }
  function ConnectorsComponentBuilder() {
  }
  protoOf(ConnectorsComponentBuilder).buildSingle = function (item, components, commonData) {
    var tmp0_safe_receiver = components.connectors;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp_0;
      // Inline function 'kotlin.collections.isEmpty' call
      if (tmp0_safe_receiver.length === 0) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.collections.toTypedArray' call
        // Inline function 'kotlin.collections.mapNotNull' call
        // Inline function 'kotlin.collections.mapNotNullTo' call
        var destination = ArrayList_init_$Create$();
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable = 0;
        var last = tmp0_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp0_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
          // Inline function 'com.ikea.range.ipex.range.builder.component.ConnectorsComponentBuilder.buildSingle.<anonymous>.<anonymous>' call
          var tmp0_safe_receiver_0 = buildConnector(this, element, item);
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            destination.q(tmp0_safe_receiver_0);
          }
        }
        var tmp$ret$5 = copyToArray(destination);
        tmp_0 = new ConnectorsComponent(tmp$ret$5);
      }
      return tmp_0;
    }
    return tmp;
  };
  function DragProjectionPointComponentBuilder() {
  }
  protoOf(DragProjectionPointComponentBuilder).buildSingle = function (item, components, commonData) {
    var tmp0_safe_receiver = item.parameters;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.size;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.builder.component.DragProjectionPointComponentBuilder.buildSingle.<anonymous>' call
      var tmp0_safe_receiver_0 = components.dragProjectionPoint;
      var tmp_0;
      if (tmp0_safe_receiver_0 == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.range.ipex.range.builder.component.DragProjectionPointComponentBuilder.buildSingle.<anonymous>.<anonymous>' call
        var point = tmp0_safe_receiver_0.applyToBox(Companion_getInstance_1().fromSize(tmp1_safe_receiver.vector)).position;
        tmp_0 = new DragProjectionPointComponent(point);
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  function generateDragSurface($this, dragData, size, collider) {
    var tmp;
    if (dragData.sameAsCollider) {
      var tmp_0;
      if (collider == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.range.ipex.range.builder.component.DragSurfacesComponentBuilder.generateDragSurface.<anonymous>' call
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp_0 = [new DragSurface(collider, null)];
      }
      tmp = tmp_0;
    } else {
      var tmp1_safe_receiver = dragData.surfaces;
      var tmp_1;
      if (tmp1_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.collections.mapNotNull' call
        // Inline function 'kotlin.collections.mapNotNullTo' call
        var destination = ArrayList_init_$Create$();
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable = 0;
        var last = tmp1_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp1_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
          // Inline function 'com.ikea.range.ipex.range.builder.component.DragSurfacesComponentBuilder.generateDragSurface.<anonymous>' call
          var tmp0_safe_receiver = element.generateDragSurface(size);
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            destination.q(tmp0_safe_receiver);
          }
        }
        tmp_1 = destination;
      }
      var tmp2_safe_receiver = tmp_1;
      var tmp_2;
      if (tmp2_safe_receiver == null) {
        tmp_2 = null;
      } else {
        // Inline function 'kotlin.collections.toTypedArray' call
        tmp_2 = copyToArray(tmp2_safe_receiver);
      }
      var tmp3_elvis_lhs = tmp_2;
      var tmp_3;
      if (tmp3_elvis_lhs == null) {
        // Inline function 'kotlin.emptyArray' call
        tmp_3 = [];
      } else {
        tmp_3 = tmp3_elvis_lhs;
      }
      var polyhedronForSurfaces = tmp_3;
      var tmp_4;
      // Inline function 'kotlin.collections.isNotEmpty' call
      // Inline function 'kotlin.collections.isEmpty' call
      if (!(polyhedronForSurfaces.length === 0)) {
        tmp_4 = polyhedronForSurfaces;
      } else {
        tmp_4 = null;
      }
      tmp = tmp_4;
    }
    return tmp;
  }
  function DragSurfacesComponentBuilder() {
  }
  protoOf(DragSurfacesComponentBuilder).buildSingle = function (item, components, commonData) {
    var tmp0_safe_receiver = item.parameters;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.size;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.builder.component.DragSurfacesComponentBuilder.buildSingle.<anonymous>' call
      var tmp0_safe_receiver_0 = components.dragSurfaces;
      var tmp_0;
      if (tmp0_safe_receiver_0 == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.range.ipex.range.builder.component.DragSurfacesComponentBuilder.buildSingle.<anonymous>.<anonymous>' call
        var tmp0_safe_receiver_1 = commonData.getColliders(components.colliders);
        var tmp_1;
        if (tmp0_safe_receiver_1 == null) {
          tmp_1 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'com.ikea.range.ipex.range.builder.component.DragSurfacesComponentBuilder.buildSingle.<anonymous>.<anonymous>.<anonymous>' call
          var dragSurfaces = generateDragSurface(this, tmp0_safe_receiver_0, tmp1_safe_receiver, tmp0_safe_receiver_1.b4b_1);
          var tmp_2;
          if (dragSurfaces == null) {
            tmp_2 = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'com.ikea.range.ipex.range.builder.component.DragSurfacesComponentBuilder.buildSingle.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
            tmp_2 = new DragSurfacesComponent(dragSurfaces, false);
          }
          tmp_1 = tmp_2;
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  function FunctionalMarginShapeComponentBuilder() {
  }
  protoOf(FunctionalMarginShapeComponentBuilder).buildSingle = function (item, components, commonData) {
    var tmp0_safe_receiver = components.functionalMargin;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.builder.component.FunctionalMarginShapeComponentBuilder.buildSingle.<anonymous>' call
      tmp = new FunctionalMarginShapeComponent(tmp0_safe_receiver.toMargin());
    }
    return tmp;
  };
  function FunctionalZonesLocalComponentBuilder() {
  }
  protoOf(FunctionalZonesLocalComponentBuilder).buildSingle = function (item, components, commonData) {
    var tmp0_safe_receiver = item.parameters;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.size;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.builder.component.FunctionalZonesLocalComponentBuilder.buildSingle.<anonymous>' call
      var tmp0_safe_receiver_0 = components.functionalZones;
      var tmp_0;
      if (tmp0_safe_receiver_0 == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.range.ipex.range.builder.component.FunctionalZonesLocalComponentBuilder.buildSingle.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.toTypedArray' call
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$_0(tmp0_safe_receiver_0.length);
        var inductionVariable = 0;
        var last = tmp0_safe_receiver_0.length;
        while (inductionVariable < last) {
          var item_0 = tmp0_safe_receiver_0[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.range.ipex.range.builder.component.FunctionalZonesLocalComponentBuilder.buildSingle.<anonymous>.<anonymous>.<anonymous>' call
          var tmp$ret$0 = new FunctionalZone(item_0.id, item_0.layer, commonData.getPolyhedronForSize(item_0.dimension, tmp1_safe_receiver));
          destination.q(tmp$ret$0);
        }
        var tmp$ret$3 = copyToArray(destination);
        tmp_0 = new FunctionalZonesLocalComponent(tmp$ret$3);
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  function LightComponentBuilder() {
  }
  protoOf(LightComponentBuilder).buildSingle = function (item, components, commonData) {
    var tmp;
    if (components.outerLight === true) {
      tmp = new LightComponent('outer');
    } else if (components.innerLight === true) {
      tmp = new LightComponent('inner');
    } else {
      tmp = null;
    }
    return tmp;
  };
  function MetaDataComponentBuilder() {
  }
  protoOf(MetaDataComponentBuilder).buildSingle = function (item, components, commonData) {
    var tmp0_safe_receiver = components.meta;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.builder.component.MetaDataComponentBuilder.buildSingle.<anonymous>' call
      tmp = new MetaDataComponent(tmp0_safe_receiver);
    }
    return tmp;
  };
  function ModelInfoComponentBuilder() {
  }
  protoOf(ModelInfoComponentBuilder).buildSingle = function (item, components, commonData) {
    var tmp0_safe_receiver = components.modelURI;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.builder.component.ModelInfoComponentBuilder.buildSingle.<anonymous>' call
      tmp = new ModelInfoComponent(commonData.modelRootURL, tmp0_safe_receiver, null);
    }
    return tmp;
  };
  function ModelTransformComponentBuilder() {
  }
  protoOf(ModelTransformComponentBuilder).buildSingle = function (item, components, commonData) {
    var tmp0_safe_receiver = components.modelTransform;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.builder.component.ModelTransformComponentBuilder.buildSingle.<anonymous>' call
      tmp = new ModelTransformComponent(tmp0_safe_receiver);
    }
    return tmp;
  };
  function PlacementZoneByHeightComponentBuilder() {
  }
  protoOf(PlacementZoneByHeightComponentBuilder).buildSingle = function (item, components, commonData) {
    var tmp0_safe_receiver = components.placementZoneByHeight;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.builder.component.PlacementZoneByHeightComponentBuilder.buildSingle.<anonymous>' call
      tmp = new PlacementZoneByHeightComponent(tmp0_safe_receiver.minY, tmp0_safe_receiver.maxY);
    }
    return tmp;
  };
  function PolyhedronColliderIdsPair(polyhedron, ids) {
    this.b4b_1 = polyhedron;
    this.c4b_1 = ids;
  }
  protoOf(PolyhedronColliderIdsPair).toString = function () {
    return 'PolyhedronColliderIdsPair(polyhedron=' + this.b4b_1 + ', ids=' + toString(this.c4b_1) + ')';
  };
  protoOf(PolyhedronColliderIdsPair).hashCode = function () {
    var result = hashCode(this.b4b_1);
    result = imul(result, 31) + hashCode(this.c4b_1) | 0;
    return result;
  };
  protoOf(PolyhedronColliderIdsPair).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PolyhedronColliderIdsPair))
      return false;
    var tmp0_other_with_cast = other instanceof PolyhedronColliderIdsPair ? other : THROW_CCE();
    if (!equals(this.b4b_1, tmp0_other_with_cast.b4b_1))
      return false;
    if (!equals(this.c4b_1, tmp0_other_with_cast.c4b_1))
      return false;
    return true;
  };
  function buildProductStructureComponent($this, productStructure, sizeAABB, parts) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = productStructure.length;
    while (inductionVariable < last) {
      var element = productStructure[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      var tmp$ret$3;
      $l$block_0: {
        // Inline function 'com.ikea.range.ipex.range.builder.component.ProductStructureComponentBuilder.buildProductStructureComponent.<anonymous>' call
        var tmp;
        if (parts == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.collections.find' call
          var tmp$ret$1;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var inductionVariable_0 = 0;
            var last_0 = parts.length;
            while (inductionVariable_0 < last_0) {
              var element_0 = parts[inductionVariable_0];
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              // Inline function 'com.ikea.range.ipex.range.builder.component.ProductStructureComponentBuilder.buildProductStructureComponent.<anonymous>.<anonymous>' call
              if (element_0.partKey === element.partKey) {
                tmp$ret$1 = element_0;
                break $l$block;
              }
            }
            tmp$ret$1 = null;
          }
          tmp = tmp$ret$1;
        }
        var tmp1_safe_receiver = tmp;
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.id;
        var tmp_0;
        if (tmp2_elvis_lhs == null) {
          tmp$ret$3 = null;
          break $l$block_0;
        } else {
          tmp_0 = tmp2_elvis_lhs;
        }
        var productRef = tmp_0;
        var tmp3_safe_receiver = element.snap;
        var tmp_1;
        if (tmp3_safe_receiver == null) {
          tmp_1 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'com.ikea.range.ipex.range.builder.component.ProductStructureComponentBuilder.buildProductStructureComponent.<anonymous>.<anonymous>' call
          tmp_1 = new ProductStructureConnection(tmp3_safe_receiver.offeringPartKey, tmp3_safe_receiver.demandingConnector, tmp3_safe_receiver.offeringConnector);
        }
        tmp$ret$3 = new ProductStructureItem(element.partKey, productRef, tmp_1, element.transform.applyToBox(sizeAABB));
      }
      var tmp0_safe_receiver = tmp$ret$3;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.q(tmp0_safe_receiver);
      }
    }
    var tmp$ret$9 = copyToArray(destination);
    return new ProductStructureComponent(tmp$ret$9);
  }
  function ProductStructureComponentBuilder() {
  }
  protoOf(ProductStructureComponentBuilder).buildSingle = function (item, components, commonData) {
    var tmp0_safe_receiver = components.productStructure;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.builder.component.ProductStructureComponentBuilder.buildSingle.<anonymous>' call
      var tmp0_safe_receiver_0 = item.parameters;
      var tmp1_elvis_lhs = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.size;
      var size = tmp1_elvis_lhs == null ? new Size() : tmp1_elvis_lhs;
      var tmp_0 = Companion_getInstance_1().fromSize(size.vector);
      var tmp2_safe_receiver = item.parameters;
      tmp = buildProductStructureComponent(this, tmp0_safe_receiver, tmp_0, tmp2_safe_receiver == null ? null : tmp2_safe_receiver.parts);
    }
    return tmp;
  };
  function ProppingComponentBuilder() {
  }
  protoOf(ProppingComponentBuilder).buildSingle = function (item, components, commonData) {
    var tmp;
    if (components.propping === true) {
      tmp = ProppingComponent_instance;
    } else {
      tmp = null;
    }
    return tmp;
  };
  function RecommendedInitialPositionFromFloorComponentBuilder() {
  }
  protoOf(RecommendedInitialPositionFromFloorComponentBuilder).buildSingle = function (item, components, commonData) {
    var tmp0_safe_receiver = components.recommendedInitialPositionFromFloor;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.builder.component.RecommendedInitialPositionFromFloorComponentBuilder.buildSingle.<anonymous>' call
      tmp = new RecommendedInitialPositionFromFloorComponent(tmp0_safe_receiver);
    }
    return tmp;
  };
  function getRelativeConnectorData($this, item, components) {
    var tmp0_safe_receiver = item.parameters;
    var tmp;
    if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.size) == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp_0;
      // Inline function 'kotlin.collections.isNullOrEmpty' call
      var this_0 = components.connectors;
      // Inline function 'kotlin.contracts.contract' call
      var tmp_1;
      if (this_0 == null) {
        tmp_1 = true;
      } else {
        // Inline function 'kotlin.collections.isEmpty' call
        tmp_1 = this_0.length === 0;
      }
      if (tmp_1) {
        tmp_0 = null;
      } else {
        var tmp0_safe_receiver_0 = components.connectors;
        var tmp_2;
        if (tmp0_safe_receiver_0 == null) {
          tmp_2 = null;
        } else {
          // Inline function 'kotlin.collections.filter' call
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList_init_$Create$();
          var inductionVariable = 0;
          var last = tmp0_safe_receiver_0.length;
          while (inductionVariable < last) {
            var element = tmp0_safe_receiver_0[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'com.ikea.range.ipex.range.builder.component.RelativeConnectorsComponentBuilder.getRelativeConnectorData.<anonymous>.<anonymous>' call
            if (element.isRelativeToBounds()) {
              destination.q(element);
            }
          }
          tmp_2 = destination;
        }
        var tmp1_safe_receiver = tmp_2;
        var tmp_3;
        if (tmp1_safe_receiver == null) {
          tmp_3 = null;
        } else {
          // Inline function 'kotlin.collections.map' call
          // Inline function 'kotlin.collections.mapTo' call
          var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_safe_receiver, 10));
          var tmp0_iterator = tmp1_safe_receiver.t();
          while (tmp0_iterator.u()) {
            var item_0 = tmp0_iterator.w();
            // Inline function 'com.ikea.range.ipex.range.builder.component.RelativeConnectorsComponentBuilder.getRelativeConnectorData.<anonymous>.<anonymous>' call
            var tmp$ret$5 = item_0.createRelativeConnectorData(item.parameters.size);
            destination_0.q(tmp$ret$5);
          }
          tmp_3 = destination_0;
        }
        var tmp2_safe_receiver = tmp_3;
        var tmp_4;
        if (tmp2_safe_receiver == null) {
          tmp_4 = null;
        } else {
          // Inline function 'kotlin.collections.toTypedArray' call
          tmp_4 = copyToArray(tmp2_safe_receiver);
        }
        tmp_0 = tmp_4;
      }
      return tmp_0;
    }
    return tmp;
  }
  function RelativeConnectorsComponentBuilder() {
  }
  protoOf(RelativeConnectorsComponentBuilder).buildSingle = function (item, components, commonData) {
    var tmp0_safe_receiver = getRelativeConnectorData(this, item, components);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.builder.component.RelativeConnectorsComponentBuilder.buildSingle.<anonymous>' call
      tmp = new RelativeConnectorsComponent(tmp0_safe_receiver);
    }
    return tmp;
  };
  function RequiredComponentsBuilder() {
  }
  protoOf(RequiredComponentsBuilder).buildMulti = function (item, components, commonData) {
    return listOf([new ConnectionRootComponent(), new DisplayNameComponent(item.description)]);
  };
  function VisualLightSourceComponentBuilder() {
  }
  protoOf(VisualLightSourceComponentBuilder).buildSingle = function (item, components, commonData) {
    var tmp0_safe_receiver = components.visualLightSource;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.builder.component.VisualLightSourceComponentBuilder.buildSingle.<anonymous>' call
      tmp = new VisualLightSourceComponent(tmp0_safe_receiver.type, tmp0_safe_receiver.intensity, tmp0_safe_receiver.colorTemperature);
    }
    return tmp;
  };
  function AmendableCatalog$Companion$jsonParser$lambda($this$Json) {
    $this$Json.f16_1 = true;
    $this$Json.e16_1 = true;
    return Unit_instance;
  }
  function cleanupAndGetItemsAffectedByAmend($this, amendedItems) {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = amendedItems.length;
    while (inductionVariable < last) {
      var element = amendedItems[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.cleanupAndGetItemsAffectedByAmend.<anonymous>' call
      $this.j4b_1.set(element.id, element);
    }
    // Inline function 'kotlin.collections.distinctBy' call
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable_0 = 0;
    var last_0 = amendedItems.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = amendedItems[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.cleanupAndGetItemsAffectedByAmend.<anonymous>' call
      var list = getItemsAffectedByAmend($this, element_0, $this.j4b_1.getAllItemDTOs());
      addAll(destination, list);
    }
    var set = HashSet_init_$Create$();
    var list_0 = ArrayList_init_$Create$();
    var tmp0_iterator = destination.t();
    while (tmp0_iterator.u()) {
      var e = tmp0_iterator.w();
      // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.cleanupAndGetItemsAffectedByAmend.<anonymous>' call
      var key = e.id;
      if (set.q(key)) {
        list_0.q(e);
      }
    }
    var itemsToResolve = list_0;
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(itemsToResolve, 10));
    var tmp0_iterator_0 = itemsToResolve.t();
    while (tmp0_iterator_0.u()) {
      var item = tmp0_iterator_0.w();
      // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.cleanupAndGetItemsAffectedByAmend.<anonymous>' call
      var tmp$ret$5 = item.id;
      destination_0.q(tmp$ret$5);
    }
    var itemIdsToResolve = copyToArray(destination_0);
    $this.itemRepository.clear(itemIdsToResolve);
    return toMutableList_0(itemsToResolve);
  }
  function getItemsAffectedByAmend($this, item, items) {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = items.length;
    while (inductionVariable < last) {
      var element = items[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.getItemsAffectedByAmend.<anonymous>' call
      var tmp0_safe_receiver = element.inherits;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : contains(tmp0_safe_receiver, item.id);
      if (tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs) {
        destination.q(element);
      }
    }
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination_0 = ArrayList_init_$Create$();
    var tmp0_iterator = destination.t();
    while (tmp0_iterator.u()) {
      var element_0 = tmp0_iterator.w();
      // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.getItemsAffectedByAmend.<anonymous>' call
      var list = getItemsAffectedByAmend($this, element_0, items);
      addAll(destination_0, list);
    }
    return plus(destination_0, item);
  }
  function collectMissingAncestors($this, ri) {
    var tmp0_safe_receiver = ri.inherits;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var destination = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp0_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.collectMissingAncestors.<anonymous>' call
        var tmp0_safe_receiver_0 = $this.j4b_1.findItemDTO(element);
        var tmp_0;
        if (tmp0_safe_receiver_0 == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.collectMissingAncestors.<anonymous>.<anonymous>' call
          tmp_0 = collectMissingAncestors($this, tmp0_safe_receiver_0);
        }
        var tmp1_elvis_lhs = tmp_0;
        var list = tmp1_elvis_lhs == null ? listOf_0(element) : tmp1_elvis_lhs;
        addAll(destination, list);
      }
      tmp = destination;
    }
    var tmp1_elvis_lhs_0 = tmp;
    var tmp_1;
    if (tmp1_elvis_lhs_0 == null) {
      // Inline function 'kotlin.collections.listOf' call
      tmp_1 = emptyList();
    } else {
      tmp_1 = tmp1_elvis_lhs_0;
    }
    return tmp_1;
  }
  function collectMissingLabels($this, ri) {
    var tmp0_safe_receiver = ri.components;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.connectors;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.collectMissingLabels.<anonymous>' call
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var destination = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.collectMissingLabels.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.plus' call
        var tmp1_elvis_lhs = element.offers;
        var tmp_0;
        if (tmp1_elvis_lhs == null) {
          // Inline function 'kotlin.arrayOf' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          tmp_0 = [];
        } else {
          tmp_0 = tmp1_elvis_lhs;
        }
        var this_0 = tmp_0;
        var tmp0_elvis_lhs = element.demands;
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.arrayOf' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          tmp_1 = [];
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        var elements = tmp_1;
        // Inline function 'kotlin.js.asDynamic' call
        var tags = this_0.concat(elements);
        // Inline function 'kotlin.collections.toTypedArray' call
        // Inline function 'kotlin.collections.flatMap' call
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination_0 = ArrayList_init_$Create$_0(tags.length);
        var inductionVariable_0 = 0;
        var last_0 = tags.length;
        while (inductionVariable_0 < last_0) {
          var item = tags[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.collectMissingLabels.<anonymous>.<anonymous>.<anonymous>' call
          var tmp$ret$8 = Regex_init_$Create$('\\{.+?\\}').a9(item);
          destination_0.q(tmp$ret$8);
        }
        // Inline function 'kotlin.collections.flatMapTo' call
        var destination_1 = ArrayList_init_$Create$();
        var tmp0_iterator = destination_0.t();
        while (tmp0_iterator.u()) {
          var element_0 = tmp0_iterator.w();
          // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.collectMissingLabels.<anonymous>.<anonymous>.<anonymous>' call
          var list = map(element_0, AmendableCatalog$collectMissingLabels$lambda);
          addAll_0(destination_1, list);
        }
        var this_1 = distinct(destination_1);
        var o = copyToArray(this_1);
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination_2 = ArrayList_init_$Create$();
        var inductionVariable_1 = 0;
        var last_1 = o.length;
        while (inductionVariable_1 < last_1) {
          var element_1 = o[inductionVariable_1];
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.collectMissingLabels.<anonymous>.<anonymous>.<anonymous>' call
          var tmp0_safe_receiver_0 = ri.parameters;
          var tmp1_safe_receiver_0 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.labels;
          if ((tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.b3(element_1)) == null) {
            destination_2.q(element_1);
          }
        }
        var list_0 = destination_2;
        addAll(destination, list_0);
      }
      tmp = destination;
    }
    var tmp2_elvis_lhs = tmp;
    var tmp_2;
    if (tmp2_elvis_lhs == null) {
      // Inline function 'kotlin.collections.listOf' call
      tmp_2 = emptyList();
    } else {
      tmp_2 = tmp2_elvis_lhs;
    }
    return tmp_2;
  }
  function Companion() {
    Companion_instance_0 = this;
    var tmp = this;
    tmp.q4b_1 = Json(VOID, AmendableCatalog$Companion$jsonParser$lambda);
  }
  var Companion_instance_0;
  function Companion_getInstance_4() {
    if (Companion_instance_0 == null)
      new Companion();
    return Companion_instance_0;
  }
  function AmendableCatalog$collectMissingLabels$lambda(it) {
    return replace(replace(it.u2(), '{', ''), '}', '');
  }
  function AmendableCatalog(modelRootURL) {
    Companion_getInstance_4();
    modelRootURL = modelRootURL === VOID ? null : modelRootURL;
    IPEXRangeFormatCatalog.call(this, modelRootURL);
    this.j4b_1 = new ItemRepository();
  }
  protoOf(AmendableCatalog).addItem = function (itemJson) {
    var rangeItem = this.parser.parseItem(itemJson, this.customComponentsParsers);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [rangeItem];
    return firstOrNull(this.resolveItems(cleanupAndGetItemsAffectedByAmend(this, tmp$ret$2)));
  };
  protoOf(AmendableCatalog).addItems = function (itemsJson) {
    var rangeItems = toMutableList(this.parser.parseItems(itemsJson, this.customComponentsParsers));
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$0 = copyToArray(rangeItems);
    return this.resolveItems(cleanupAndGetItemsAffectedByAmend(this, tmp$ret$0));
  };
  protoOf(AmendableCatalog).addItemsFromArray = function (items) {
    return this.resolveItems(cleanupAndGetItemsAffectedByAmend(this, items));
  };
  protoOf(AmendableCatalog).getResolvedItem = function (id) {
    var tmp0_safe_receiver = this.itemRepository.findItemDTO(id);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.getResolvedItem.<anonymous>' call
      tmp = Companion_getInstance_4().q4b_1.i15(Companion_getInstance_10().l17(), tmp0_safe_receiver);
    }
    return tmp;
  };
  protoOf(AmendableCatalog).getUnresolvedItem = function (id) {
    var tmp0_safe_receiver = this.j4b_1.findItemDTO(id);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.getUnresolvedItem.<anonymous>' call
      tmp = Companion_getInstance_4().q4b_1.i15(Companion_getInstance_10().l17(), tmp0_safe_receiver);
    }
    return tmp;
  };
  protoOf(AmendableCatalog).validateProductItem = function (id) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var errors = ArrayList_init_$Create$();
    var tmp0_safe_receiver = this.itemRepository.findItemDTO(id);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp0_safe_receiver_0 = tmp0_safe_receiver.components;
      var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.product;
      if (tmp1_safe_receiver == null)
        null;
      else {
        $l$block: {
          // Inline function 'com.ikea.core.utils.orElse' call
          if (tmp1_safe_receiver == null) {
            // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.validateProductItem.<anonymous>.<anonymous>' call
            errors.q('ITEM_IS_NOT_A_PRODUCT:' + id);
            break $l$block;
          }
        }
      }
      var tmp2_safe_receiver = tmp0_safe_receiver.components;
      if ((tmp2_safe_receiver == null ? null : tmp2_safe_receiver.product) == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.validateProductItem.<anonymous>.<anonymous>' call
        var tmp0_safe_receiver_1 = tmp0_safe_receiver.parameters;
        var tmp1_safe_receiver_0 = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.size;
        if (tmp1_safe_receiver_0 == null)
          null;
        else {
          $l$block_0: {
            // Inline function 'com.ikea.core.utils.orElse' call
            if (tmp1_safe_receiver_0 == null) {
              // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.validateProductItem.<anonymous>.<anonymous>.<anonymous>' call
              errors.q('ITEM_HAS_NO_SIZE:' + id);
              break $l$block_0;
            }
          }
        }
        var tmp2_safe_receiver_0 = tmp0_safe_receiver.components.modelURI;
        var tmp_0;
        if (tmp2_safe_receiver_0 == null) {
          tmp_0 = null;
        } else {
          var tmp$ret$6;
          $l$block_1: {
            // Inline function 'com.ikea.core.utils.orElse' call
            if (tmp2_safe_receiver_0 == null) {
              // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.validateProductItem.<anonymous>.<anonymous>.<anonymous>' call
              tmp$ret$6 = errors.q('ITEM_HAS_NO_MODEL:' + id);
              break $l$block_1;
            }
            tmp$ret$6 = tmp2_safe_receiver_0;
          }
          tmp_0 = tmp$ret$6;
        }
      }
      var tmp0_iterator = collectMissingLabels(this, tmp0_safe_receiver).t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.validateProductItem.<anonymous>.<anonymous>' call
        errors.q('MAGIC_LABEL_MISSING_IN_PARAMETERS:' + id + ':' + element);
      }
      tmp = Unit_instance;
    }
    var tmp2_elvis_lhs = tmp;
    var tmp_1;
    if (tmp2_elvis_lhs == null) {
      var tmp1_safe_receiver_1 = this.j4b_1.findItemDTO(id);
      var tmp_2;
      if (tmp1_safe_receiver_1 == null) {
        tmp_2 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp0_iterator_0 = collectMissingAncestors(this, tmp1_safe_receiver_1).t();
        while (tmp0_iterator_0.u()) {
          var element_0 = tmp0_iterator_0.w();
          // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.validateProductItem.<anonymous>.<anonymous>' call
          errors.q('PARENT_ITEM_MISSING:' + id + ':' + element_0);
        }
        tmp_2 = Unit_instance;
      }
      tmp_1 = tmp_2;
    } else {
      tmp_1 = tmp2_elvis_lhs;
    }
    if (tmp_1 == null)
      errors.q('MISSING_ITEM:' + id);
    var tmp_3;
    if (errors.n() > 0) {
      // Inline function 'kotlin.collections.toTypedArray' call
      tmp_3 = copyToArray(errors);
    } else {
      tmp_3 = null;
    }
    return tmp_3;
  };
  protoOf(AmendableCatalog).clearItems = function (itemIds) {
    protoOf(IPEXRangeFormatCatalog).clearItems.call(this, itemIds);
    this.j4b_1.clear(itemIds);
  };
  function resolveInheritanceAndAdd($this, untouchedItem) {
    try {
      var withInheritance = $this.o4b_1.itemWithResolvedInheritance(untouchedItem);
      $this.itemRepository.set(untouchedItem.id, withInheritance);
      return withInheritance;
    } catch ($p) {
      if ($p instanceof Error_0) {
        var e = $p;
        var tmp = Companion_getInstance_5().w4b_1;
        tmp.warn(IPEXRangeFormatCatalog$resolveInheritanceAndAdd$lambda(e));
      } else {
        throw $p;
      }
    }
    return null;
  }
  function Companion_0() {
    Companion_instance_1 = this;
    this.w4b_1 = LoggerState_getInstance().m1m('IPEXRangeFormatCatalog');
  }
  var Companion_instance_1;
  function Companion_getInstance_5() {
    if (Companion_instance_1 == null)
      new Companion_0();
    return Companion_instance_1;
  }
  function IPEXRangeFormatCatalog$productSpecification$lambda($e) {
    return function () {
      return $e.message;
    };
  }
  function IPEXRangeFormatCatalog$resolveItems$lambda(this$0) {
    return function (it) {
      return !(this$0.itemRepository.findItemDTO(it.id) == null);
    };
  }
  function IPEXRangeFormatCatalog$resolveItems$lambda$lambda($e) {
    return function () {
      return 'Failed to resolve item. ' + $e.message;
    };
  }
  function IPEXRangeFormatCatalog$resolveItems$lambda_0($items, this$0, $resolvedItems) {
    return function (item) {
      var tmp;
      try {
        $items.r(item);
        var tmp0_safe_receiver = resolveInheritanceAndAdd(this$0, item);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'com.ikea.range.ipex.range.catalog.IPEXRangeFormatCatalog.resolveItems.<anonymous>.<anonymous>' call
          $resolvedItems.q(tmp0_safe_receiver);
        }
        tmp = Unit_instance;
      } catch ($p) {
        var tmp_0;
        if ($p instanceof Error_0) {
          var e = $p;
          var tmp_1 = Companion_getInstance_5().w4b_1;
          tmp_1.warn(IPEXRangeFormatCatalog$resolveItems$lambda$lambda(e));
          tmp_0 = Unit_instance;
        } else {
          throw $p;
        }
        tmp = tmp_0;
      }
      return Unit_instance;
    };
  }
  function IPEXRangeFormatCatalog$resolveItems$lambda$lambda_0(it) {
    return it.id;
  }
  function IPEXRangeFormatCatalog$resolveItems$lambda_1($items) {
    return function () {
      return 'Inheritance could not be resolved for ' + joinToString($items, VOID, VOID, VOID, VOID, VOID, IPEXRangeFormatCatalog$resolveItems$lambda$lambda_0);
    };
  }
  function IPEXRangeFormatCatalog$resolveInheritanceAndAdd$lambda($e) {
    return function () {
      return toString_1($e.message);
    };
  }
  function ItemRepository$getAllItemDTOs$ref($boundThis) {
    var l = function () {
      return $boundThis.getAllItemDTOs();
    };
    l.callableName = 'getAllItemDTOs';
    return l;
  }
  function IPEXRangeFormatCatalog(modelRootURL) {
    Companion_getInstance_5();
    modelRootURL = modelRootURL === VOID ? null : modelRootURL;
    this.modelRootURL = modelRootURL;
    this.k4b_1 = true;
    this.l4b_1 = 'ipex-range';
    this.m4b_1 = '0';
    this.itemRepository = new ItemRepository();
    this.parser = new ItemParser();
    this.n4b_1 = new ProductSpecificationBuilder(this.itemRepository, this.modelRootURL);
    this.o4b_1 = new InheritanceResolver(this.itemRepository);
    var tmp = this;
    // Inline function 'kotlin.collections.mutableSetOf' call
    tmp.p4b_1 = LinkedHashSet_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_0.customComponentsParsers = ArrayList_init_$Create$();
    var tmp_1 = this;
    tmp_1.getAllItemDTOs = ItemRepository$getAllItemDTOs$ref(this.itemRepository);
  }
  protoOf(IPEXRangeFormatCatalog).f48 = function () {
    return this.modelRootURL;
  };
  protoOf(IPEXRangeFormatCatalog).a1m = function () {
    return this.k4b_1;
  };
  protoOf(IPEXRangeFormatCatalog).rangeId = function () {
    return this.l4b_1;
  };
  protoOf(IPEXRangeFormatCatalog).rangeVersion = function () {
    return this.m4b_1;
  };
  protoOf(IPEXRangeFormatCatalog).s4b = function () {
    return this.itemRepository;
  };
  protoOf(IPEXRangeFormatCatalog).t4b = function () {
    return this.parser;
  };
  protoOf(IPEXRangeFormatCatalog).u4b = function () {
    return this.customComponentsParsers;
  };
  protoOf(IPEXRangeFormatCatalog).addInterceptor = function (interceptor) {
    this.p4b_1.q(interceptor);
  };
  protoOf(IPEXRangeFormatCatalog).removeInterceptor = function (interceptor) {
    this.p4b_1.r(interceptor);
  };
  protoOf(IPEXRangeFormatCatalog).beforeDeserialize = function (json, catalogVersion) {
    var res = json;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.p4b_1.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.range.ipex.range.catalog.IPEXRangeFormatCatalog.beforeDeserialize.<anonymous>' call
      res = element.beforeDeserialize(res, catalogVersion);
    }
    return res;
  };
  protoOf(IPEXRangeFormatCatalog).beforeBuildingEntities = function (serializableTree, catalogVersion) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.p4b_1.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.range.ipex.range.catalog.IPEXRangeFormatCatalog.beforeBuildingEntities.<anonymous>' call
      element.beforeBuildingEntities(serializableTree, catalogVersion);
    }
  };
  protoOf(IPEXRangeFormatCatalog).beforeParsingComponents = function (serializableTree, catalogVersion) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.p4b_1.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.range.ipex.range.catalog.IPEXRangeFormatCatalog.beforeParsingComponents.<anonymous>' call
      element.beforeParsingComponents(serializableTree, catalogVersion);
    }
  };
  protoOf(IPEXRangeFormatCatalog).afterDeserializeComplete = function (root, catalogVersion) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.p4b_1.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.range.ipex.range.catalog.IPEXRangeFormatCatalog.afterDeserializeComplete.<anonymous>' call
      element.afterDeserializeComplete(root, catalogVersion);
    }
  };
  protoOf(IPEXRangeFormatCatalog).addCustomComponentParser = function (parser) {
    this.customComponentsParsers.q(parser);
  };
  protoOf(IPEXRangeFormatCatalog).removeCustomComponentParser = function (parser) {
    this.customComponentsParsers.r(parser);
  };
  protoOf(IPEXRangeFormatCatalog).productSpecification = function (productRef) {
    var tmp0_elvis_lhs = this.itemRepository.findItemDTO(productRef);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var item = tmp;
    try {
      return this.n4b_1.buildProductSpecification(item);
    } catch ($p) {
      if ($p instanceof Error_0) {
        var e = $p;
        var tmp_0 = Companion_getInstance_5().w4b_1;
        tmp_0.warn(IPEXRangeFormatCatalog$productSpecification$lambda(e));
      } else {
        throw $p;
      }
    }
    return null;
  };
  protoOf(IPEXRangeFormatCatalog).allProductRefs = function () {
    return this.itemRepository.getAllProductNames();
  };
  protoOf(IPEXRangeFormatCatalog).allRefs = function () {
    return this.itemRepository.getAllNames();
  };
  protoOf(IPEXRangeFormatCatalog).toString = function () {
    return 'IPEX Range Format Catalog';
  };
  protoOf(IPEXRangeFormatCatalog).addItem = function (itemJson) {
    var rangeItem = this.parser.parseItem(itemJson, this.customComponentsParsers);
    return firstOrNull(this.resolveItems(mutableListOf([rangeItem])));
  };
  protoOf(IPEXRangeFormatCatalog).addItems = function (itemsJson) {
    var rangeItems = toMutableList(this.parser.parseItems(itemsJson, this.customComponentsParsers));
    return this.resolveItems(rangeItems);
  };
  protoOf(IPEXRangeFormatCatalog).addItemsFromArray = function (items) {
    return this.resolveItems(toMutableList(items));
  };
  protoOf(IPEXRangeFormatCatalog).resolveItems = function (items) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var resolvedItems = ArrayList_init_$Create$();
    removeAll(items, IPEXRangeFormatCatalog$resolveItems$lambda(this));
    var resolveAndRemoveItem = IPEXRangeFormatCatalog$resolveItems$lambda_0(items, this, resolvedItems);
    $l$loop: while (items.n() > 0) {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList_init_$Create$();
      var tmp0_iterator = items.t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.range.ipex.range.catalog.IPEXRangeFormatCatalog.resolveItems.<anonymous>' call
        if (this.o4b_1.inheritanceIsResolvable(element)) {
          destination.q(element);
        }
      }
      var resolvable = destination;
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator_0 = resolvable.t();
      while (tmp0_iterator_0.u()) {
        var element_0 = tmp0_iterator_0.w();
        // Inline function 'com.ikea.range.ipex.range.catalog.IPEXRangeFormatCatalog.resolveItems.<anonymous>' call
        resolveAndRemoveItem(element_0);
      }
      if (resolvable.b1()) {
        break $l$loop;
      }
    }
    if (items.n() > 0) {
      var tmp = Companion_getInstance_5().w4b_1;
      tmp.warn(IPEXRangeFormatCatalog$resolveItems$lambda_1(items));
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    return copyToArray(resolvedItems);
  };
  protoOf(IPEXRangeFormatCatalog).clearItems = function (itemIds) {
    this.itemRepository.clear(itemIds);
  };
  protoOf(IPEXRangeFormatCatalog).v4b = function () {
    return this.getAllItemDTOs;
  };
  function resolve($this, itemDTO) {
    var tmp;
    if (itemDTO.inherits == null) {
      tmp = itemDTO;
    } else {
      var resultingItem = itemDTO;
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject = reversedArray(itemDTO.inherits);
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.range.ipex.range.catalog.InheritanceResolver.resolve.<anonymous>' call
        var tmp0_elvis_lhs = $this.x4b_1.findItemDTO(element);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          throw Exception_init_$Create$("Item '" + itemDTO.id + "' extends '" + element + "' that cannot be found");
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var parentItem = tmp_0;
        resultingItem = resultingItem.inherit(parentItem);
      }
      tmp = resultingItem;
    }
    return tmp;
  }
  function InheritanceResolver(itemRepository) {
    this.x4b_1 = itemRepository;
  }
  protoOf(InheritanceResolver).itemWithResolvedInheritance = function (itemDTO) {
    return resolve(this, itemDTO);
  };
  protoOf(InheritanceResolver).inheritanceIsResolvable = function (itemDTO) {
    var tmp0_safe_receiver = itemDTO.inherits;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.all' call
        var inductionVariable = 0;
        var last = tmp0_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp0_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.range.ipex.range.catalog.InheritanceResolver.inheritanceIsResolvable.<anonymous>' call
          var item = this.x4b_1.findItemDTO(element);
          if (!(!(item == null) ? this.inheritanceIsResolvable(item) : false)) {
            tmp$ret$1 = false;
            break $l$block;
          }
        }
        tmp$ret$1 = true;
      }
      tmp = tmp$ret$1;
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
  };
  function ItemRepository() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.y4b_1 = LinkedHashMap_init_$Create$();
  }
  protoOf(ItemRepository).findItemDTO = function (name) {
    return this.y4b_1.b3(name);
  };
  protoOf(ItemRepository).getAllItemDTOs = function () {
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = this.y4b_1.p2();
    return copyToArray(this_0);
  };
  protoOf(ItemRepository).getAllNames = function () {
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = this.y4b_1.o2();
    return copyToArray(this_0);
  };
  protoOf(ItemRepository).getAllProductNames = function () {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this.y4b_1;
    var destination = LinkedHashMap_init_$Create$();
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = this_0.q2().t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.range.ipex.range.catalog.ItemRepository.getAllProductNames.<anonymous>' call
      // Inline function 'com.ikea.core.utils.isNotNull' call
      var tmp0_safe_receiver = element.u2().components;
      if (!((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.product) == null)) {
        destination.r2(element.t2(), element.u2());
      }
    }
    var this_1 = destination.o2();
    return copyToArray(this_1);
  };
  protoOf(ItemRepository).z4b = function (itemNames) {
    if (!(itemNames == null)) {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = itemNames.length;
      while (inductionVariable < last) {
        var element = itemNames[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.range.ipex.range.catalog.ItemRepository.clear.<anonymous>' call
        this.y4b_1.v2(element);
      }
    } else {
      this.y4b_1.z();
    }
  };
  protoOf(ItemRepository).clear = function (itemNames, $super) {
    itemNames = itemNames === VOID ? null : itemNames;
    return this.z4b(itemNames);
  };
  protoOf(ItemRepository).set = function (name, item) {
    // Inline function 'kotlin.collections.set' call
    this.y4b_1.r2(name, item);
  };
  function ReadOnlyItemRepository() {
  }
  function Companion_1() {
    Companion_instance_2 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.a4c_1 = [null, null, null, null, new ReferenceArraySerializer(PrimitiveClasses_getInstance().s7(), DoubleSerializer_getInstance()), null, null];
  }
  protoOf(Companion_1).l17 = function () {
    return $serializer_getInstance_5();
  };
  var Companion_instance_2;
  function Companion_getInstance_6() {
    if (Companion_instance_2 == null)
      new Companion_1();
    return Companion_instance_2;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.ipex.range.dto.component.AssemblyChildDTO', this, 7);
    tmp0_serialDesc.cv('partKey', false);
    tmp0_serialDesc.cv('connector', true);
    tmp0_serialDesc.cv('connectorOnHost', true);
    tmp0_serialDesc.cv('position', true);
    tmp0_serialDesc.cv('transform', true);
    tmp0_serialDesc.cv('children', true);
    tmp0_serialDesc.cv('locked', true);
    this.b4c_1 = tmp0_serialDesc;
  }
  protoOf($serializer).ok = function () {
    return this.b4c_1;
  };
  protoOf($serializer).rv = function () {
    var tmp0_cached = Companion_getInstance_6().a4c_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(PositionTemplateSerializer_getInstance()), get_nullable(tmp0_cached[4]), get_nullable(new ReferenceArraySerializer(getKClass(AssemblyChildDTO), $serializer_getInstance_5())), get_nullable(BooleanSerializer_getInstance())];
  };
  protoOf($serializer).qk = function (decoder) {
    var tmp0_desc = this.b4c_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_input = decoder.nn(tmp0_desc);
    var tmp12_cached = Companion_getInstance_6().a4c_1;
    if (tmp11_input.do()) {
      tmp4_local0 = tmp11_input.xn(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.bo(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.bo(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.bo(tmp0_desc, 3, PositionTemplateSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.bo(tmp0_desc, 4, tmp12_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.bo(tmp0_desc, 5, new ReferenceArraySerializer(getKClass(AssemblyChildDTO), $serializer_getInstance_5()), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.bo(tmp0_desc, 6, BooleanSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.xn(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.bo(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.bo(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.bo(tmp0_desc, 3, PositionTemplateSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.bo(tmp0_desc, 4, tmp12_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.bo(tmp0_desc, 5, new ReferenceArraySerializer(getKClass(AssemblyChildDTO), $serializer_getInstance_5()), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.bo(tmp0_desc, 6, BooleanSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp11_input.on(tmp0_desc);
    return AssemblyChildDTO_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  };
  protoOf($serializer).c4c = function (encoder, value) {
    var tmp0_desc = this.b4c_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    var tmp2_cached = Companion_getInstance_6().a4c_1;
    tmp1_output.cp(tmp0_desc, 0, value.partKey);
    if (tmp1_output.kp(tmp0_desc, 1) ? true : !(value.connector == null)) {
      tmp1_output.gp(tmp0_desc, 1, StringSerializer_getInstance(), value.connector);
    }
    if (tmp1_output.kp(tmp0_desc, 2) ? true : !(value.connectorOnHost == null)) {
      tmp1_output.gp(tmp0_desc, 2, StringSerializer_getInstance(), value.connectorOnHost);
    }
    if (tmp1_output.kp(tmp0_desc, 3) ? true : !(value.position == null)) {
      tmp1_output.gp(tmp0_desc, 3, PositionTemplateSerializer_getInstance(), value.position);
    }
    if (tmp1_output.kp(tmp0_desc, 4) ? true : !(value.transform == null)) {
      tmp1_output.gp(tmp0_desc, 4, tmp2_cached[4], value.transform);
    }
    if (tmp1_output.kp(tmp0_desc, 5) ? true : !(value.children == null)) {
      tmp1_output.gp(tmp0_desc, 5, new ReferenceArraySerializer(getKClass(AssemblyChildDTO), $serializer_getInstance_5()), value.children);
    }
    if (tmp1_output.kp(tmp0_desc, 6) ? true : !(value.locked === true)) {
      tmp1_output.gp(tmp0_desc, 6, BooleanSerializer_getInstance(), value.locked);
    }
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer).pk = function (encoder, value) {
    return this.c4c(encoder, value instanceof AssemblyChildDTO ? value : THROW_CCE());
  };
  var $serializer_instance;
  function $serializer_getInstance_5() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function AssemblyChildDTO_init_$Init$(seen1, partKey, connector, connectorOnHost, position, transform, children, locked, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_5().b4c_1);
    }
    $this.partKey = partKey;
    if (0 === (seen1 & 2))
      $this.connector = null;
    else
      $this.connector = connector;
    if (0 === (seen1 & 4))
      $this.connectorOnHost = null;
    else
      $this.connectorOnHost = connectorOnHost;
    if (0 === (seen1 & 8))
      $this.position = null;
    else
      $this.position = position;
    if (0 === (seen1 & 16))
      $this.transform = null;
    else
      $this.transform = transform;
    if (0 === (seen1 & 32))
      $this.children = null;
    else
      $this.children = children;
    if (0 === (seen1 & 64))
      $this.locked = true;
    else
      $this.locked = locked;
    return $this;
  }
  function AssemblyChildDTO_init_$Create$(seen1, partKey, connector, connectorOnHost, position, transform, children, locked, serializationConstructorMarker) {
    return AssemblyChildDTO_init_$Init$(seen1, partKey, connector, connectorOnHost, position, transform, children, locked, serializationConstructorMarker, objectCreate(protoOf(AssemblyChildDTO)));
  }
  function AssemblyChildDTO(partKey, connector, connectorOnHost, position, transform, children, locked) {
    Companion_getInstance_6();
    connector = connector === VOID ? null : connector;
    connectorOnHost = connectorOnHost === VOID ? null : connectorOnHost;
    position = position === VOID ? null : position;
    transform = transform === VOID ? null : transform;
    children = children === VOID ? null : children;
    locked = locked === VOID ? true : locked;
    this.partKey = partKey;
    this.connector = connector;
    this.connectorOnHost = connectorOnHost;
    this.position = position;
    this.transform = transform;
    this.children = children;
    this.locked = locked;
  }
  protoOf(AssemblyChildDTO).z1j = function () {
    return this.partKey;
  };
  protoOf(AssemblyChildDTO).n1k = function () {
    return this.connector;
  };
  protoOf(AssemblyChildDTO).m1k = function () {
    return this.connectorOnHost;
  };
  protoOf(AssemblyChildDTO).ct = function () {
    return this.position;
  };
  protoOf(AssemblyChildDTO).d1x = function () {
    return this.transform;
  };
  protoOf(AssemblyChildDTO).c1k = function () {
    return this.children;
  };
  protoOf(AssemblyChildDTO).d1k = function () {
    return this.locked;
  };
  function Companion_2() {
  }
  protoOf(Companion_2).l17 = function () {
    return $serializer_getInstance_6();
  };
  var Companion_instance_3;
  function Companion_getInstance_7() {
    return Companion_instance_3;
  }
  function $serializer_0() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.ipex.range.dto.component.ColliderDTO', this, 4);
    tmp0_serialDesc.cv('dimension', true);
    tmp0_serialDesc.cv('id', false);
    tmp0_serialDesc.cv('layer', true);
    tmp0_serialDesc.cv('sourceTemplateId', true);
    this.d4c_1 = tmp0_serialDesc;
  }
  protoOf($serializer_0).ok = function () {
    return this.d4c_1;
  };
  protoOf($serializer_0).rv = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(Companion_getInstance_2()), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  protoOf($serializer_0).qk = function (decoder) {
    var tmp0_desc = this.d4c_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.nn(tmp0_desc);
    if (tmp8_input.do()) {
      tmp4_local0 = tmp8_input.bo(tmp0_desc, 0, Companion_getInstance_2(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.xn(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.xn(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.xn(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.bo(tmp0_desc, 0, Companion_getInstance_2(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.xn(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.xn(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.xn(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.on(tmp0_desc);
    return ColliderDTO_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_0).e4c = function (encoder, value) {
    var tmp0_desc = this.d4c_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    if (tmp1_output.kp(tmp0_desc, 0) ? true : !(value.dimension == null)) {
      tmp1_output.gp(tmp0_desc, 0, Companion_getInstance_2(), value.dimension);
    }
    tmp1_output.cp(tmp0_desc, 1, value.id);
    if (tmp1_output.kp(tmp0_desc, 2) ? true : !(value.layer === 'collision')) {
      tmp1_output.cp(tmp0_desc, 2, value.layer);
    }
    if (tmp1_output.kp(tmp0_desc, 3) ? true : !(value.sourceTemplateId === '')) {
      tmp1_output.cp(tmp0_desc, 3, value.sourceTemplateId);
    }
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_0).pk = function (encoder, value) {
    return this.e4c(encoder, value instanceof ColliderDTO ? value : THROW_CCE());
  };
  var $serializer_instance_0;
  function $serializer_getInstance_6() {
    if ($serializer_instance_0 == null)
      new $serializer_0();
    return $serializer_instance_0;
  }
  function ColliderDTO_init_$Init$(seen1, dimension, id, layer, sourceTemplateId, serializationConstructorMarker, $this) {
    if (!(2 === (2 & seen1))) {
      throwMissingFieldException(seen1, 2, $serializer_getInstance_6().d4c_1);
    }
    if (0 === (seen1 & 1))
      $this.dimension = null;
    else
      $this.dimension = dimension;
    $this.id = id;
    if (0 === (seen1 & 4))
      $this.layer = 'collision';
    else
      $this.layer = layer;
    if (0 === (seen1 & 8))
      $this.sourceTemplateId = '';
    else
      $this.sourceTemplateId = sourceTemplateId;
    return $this;
  }
  function ColliderDTO_init_$Create$(seen1, dimension, id, layer, sourceTemplateId, serializationConstructorMarker) {
    return ColliderDTO_init_$Init$(seen1, dimension, id, layer, sourceTemplateId, serializationConstructorMarker, objectCreate(protoOf(ColliderDTO)));
  }
  function ColliderDTO(dimension, id, layer, sourceTemplateId) {
    dimension = dimension === VOID ? null : dimension;
    layer = layer === VOID ? 'collision' : layer;
    sourceTemplateId = sourceTemplateId === VOID ? '' : sourceTemplateId;
    this.dimension = dimension;
    this.id = id;
    this.layer = layer;
    this.sourceTemplateId = sourceTemplateId;
  }
  protoOf(ColliderDTO).q43 = function () {
    return this.dimension;
  };
  protoOf(ColliderDTO).s1k = function () {
    return this.id;
  };
  protoOf(ColliderDTO).j3a = function () {
    return this.layer;
  };
  protoOf(ColliderDTO).t43 = function (_set____db54di) {
    this.sourceTemplateId = _set____db54di;
  };
  protoOf(ColliderDTO).u43 = function () {
    return this.sourceTemplateId;
  };
  function CustomSerializer() {
    CustomSerializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.ipex.range.dto.component.ProductDTO', null, 3);
    tmp0_serialDesc.cv('dexfItemId', false);
    tmp0_serialDesc.cv('type', true);
    tmp0_serialDesc.cv('partsInPackage', true);
    this.f4c_1 = tmp0_serialDesc;
  }
  protoOf(CustomSerializer).qk = function (decoder) {
    var element = decoder.mn(Companion_instance.l17());
    var tmp;
    if (element instanceof JsonObject) {
      var tmp_0;
      try {
        var tmp_1 = element.o17('dexfItemId');
        var tmp_2 = (tmp_1 instanceof JsonPrimitive ? tmp_1 : THROW_CCE()).p17();
        var tmp_3 = element.o17('type');
        var tmp0_safe_receiver = (tmp_3 == null ? true : tmp_3 instanceof JsonPrimitive) ? tmp_3 : THROW_CCE();
        var tmp_4 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p17();
        var tmp_5 = element.o17('partsInPackage');
        var tmp1_safe_receiver = (tmp_5 == null ? true : tmp_5 instanceof JsonPrimitive) ? tmp_5 : THROW_CCE();
        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : get_contentOrNull(tmp1_safe_receiver);
        var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : toIntOrNull(tmp2_safe_receiver);
        tmp_0 = new ProductDTO(tmp_2, tmp_4, tmp3_elvis_lhs == null ? 1 : tmp3_elvis_lhs);
      } catch ($p) {
        var tmp_6;
        if ($p instanceof Exception) {
          var e = $p;
          var message = 'Product component malformed in JSON: ' + element + '. ' + e.message;
          throw IllegalStateException_init_$Create$(toString(message));
        } else {
          throw $p;
        }
      }
      tmp = tmp_0;
    } else {
      if (element instanceof JsonPrimitive) {
        tmp = new ProductDTO(element.p17());
      } else {
        var message_0 = 'Product component malformed in JSON: ' + element;
        throw IllegalStateException_init_$Create$(toString(message_0));
      }
    }
    return tmp;
  };
  protoOf(CustomSerializer).ok = function () {
    return this.f4c_1;
  };
  protoOf(CustomSerializer).g4c = function (encoder, value) {
    var tmp0_desc = this.f4c_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    tmp1_output.cp(tmp0_desc, 0, value.dexfItemId);
    if (tmp1_output.kp(tmp0_desc, 1) ? true : !(value.type == null)) {
      tmp1_output.gp(tmp0_desc, 1, StringSerializer_getInstance(), value.type);
    }
    if (tmp1_output.kp(tmp0_desc, 2) ? true : !(value.partsInPackage === 1)) {
      tmp1_output.xo(tmp0_desc, 2, value.partsInPackage);
    }
    tmp1_output.on(tmp0_desc);
  };
  protoOf(CustomSerializer).pk = function (encoder, value) {
    return this.g4c(encoder, value instanceof ProductDTO ? value : THROW_CCE());
  };
  protoOf(CustomSerializer).l17 = function () {
    return CustomSerializer_getInstance_2();
  };
  var CustomSerializer_instance;
  function CustomSerializer_getInstance_2() {
    if (CustomSerializer_instance == null)
      new CustomSerializer();
    return CustomSerializer_instance;
  }
  function ProductDTO(dexfItemId, type, partsInPackage) {
    CustomSerializer_getInstance_2();
    type = type === VOID ? null : type;
    partsInPackage = partsInPackage === VOID ? 1 : partsInPackage;
    this.dexfItemId = dexfItemId;
    this.type = type;
    this.partsInPackage = partsInPackage;
  }
  protoOf(ProductDTO).h4c = function () {
    return this.dexfItemId;
  };
  protoOf(ProductDTO).a1x = function () {
    return this.type;
  };
  protoOf(ProductDTO).x3x = function () {
    return this.partsInPackage;
  };
  function inheritCustomComponents($this, parentCCBs) {
    var result = toMutableMap($this.customComponents);
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = parentCCBs.q2().t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inheritCustomComponents.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var key = element.t2();
      // Inline function 'kotlin.collections.component2' call
      var parentCCB = element.u2();
      var childCCB = result.b3(key);
      if (!(childCCB == null)) {
        // Inline function 'kotlin.collections.set' call
        var value = childCCB.inherit(parentCCB);
        result.r2(key, value);
      } else {
        // Inline function 'kotlin.collections.set' call
        result.r2(key, parentCCB);
      }
    }
    return result;
  }
  function inheritAssembly($this, assemblyDTO, otherAssemblyDTO) {
    var tmp;
    if (otherAssemblyDTO == null) {
      tmp = assemblyDTO;
    } else {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = otherAssemblyDTO.length;
      while (inductionVariable < last) {
        var element = otherAssemblyDTO[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inheritAssembly.<anonymous>' call
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.none' call
          var inductionVariable_0 = 0;
          var last_0 = assemblyDTO.length;
          while (inductionVariable_0 < last_0) {
            var element_0 = assemblyDTO[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inheritAssembly.<anonymous>.<anonymous>' call
            if (element_0.partKey === element.partKey) {
              tmp$ret$1 = false;
              break $l$block;
            }
          }
          tmp$ret$1 = true;
        }
        if (tmp$ret$1) {
          destination.q(element);
        }
      }
      tmp = plus_0(assemblyDTO, destination);
    }
    return tmp;
  }
  function inheritColliders($this, colliderDTO, otherColliderDTO) {
    var tmp;
    if (otherColliderDTO == null) {
      tmp = colliderDTO;
    } else {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = otherColliderDTO.length;
      while (inductionVariable < last) {
        var element = otherColliderDTO[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inheritColliders.<anonymous>' call
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.none' call
          var inductionVariable_0 = 0;
          var last_0 = colliderDTO.length;
          while (inductionVariable_0 < last_0) {
            var element_0 = colliderDTO[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inheritColliders.<anonymous>.<anonymous>' call
            if (element_0.id === element.id) {
              tmp$ret$1 = false;
              break $l$block;
            }
          }
          tmp$ret$1 = true;
        }
        if (tmp$ret$1) {
          destination.q(element);
        }
      }
      tmp = plus_0(colliderDTO, destination);
    }
    return tmp;
  }
  function inheritFunctionalZones($this, functionalZones, otherFunctionalZones) {
    var tmp;
    if (otherFunctionalZones == null) {
      tmp = functionalZones;
    } else {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = otherFunctionalZones.length;
      while (inductionVariable < last) {
        var element = otherFunctionalZones[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inheritFunctionalZones.<anonymous>' call
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.none' call
          var inductionVariable_0 = 0;
          var last_0 = functionalZones.length;
          while (inductionVariable_0 < last_0) {
            var element_0 = functionalZones[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inheritFunctionalZones.<anonymous>.<anonymous>' call
            if (element_0.id === element.id) {
              tmp$ret$1 = false;
              break $l$block;
            }
          }
          tmp$ret$1 = true;
        }
        if (tmp$ret$1) {
          destination.q(element);
        }
      }
      tmp = plus_0(functionalZones, destination);
    }
    return tmp;
  }
  function inheritConnectors($this, connectorDTO, otherConnectorDTO) {
    var tmp;
    if (otherConnectorDTO == null) {
      tmp = connectorDTO;
    } else {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = otherConnectorDTO.length;
      while (inductionVariable < last) {
        var element = otherConnectorDTO[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inheritConnectors.<anonymous>' call
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.none' call
          var inductionVariable_0 = 0;
          var last_0 = connectorDTO.length;
          while (inductionVariable_0 < last_0) {
            var element_0 = connectorDTO[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inheritConnectors.<anonymous>.<anonymous>' call
            if (element_0.name === element.name) {
              tmp$ret$1 = false;
              break $l$block;
            }
          }
          tmp$ret$1 = true;
        }
        if (tmp$ret$1) {
          destination.q(element);
        }
      }
      tmp = plus_0(connectorDTO, destination);
    }
    return tmp;
  }
  function inheritProductStructure($this, productStructureDTO, otherProductStructureDTO) {
    var tmp;
    if (otherProductStructureDTO == null) {
      tmp = productStructureDTO;
    } else {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = otherProductStructureDTO.length;
      while (inductionVariable < last) {
        var element = otherProductStructureDTO[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inheritProductStructure.<anonymous>' call
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.none' call
          var inductionVariable_0 = 0;
          var last_0 = productStructureDTO.length;
          while (inductionVariable_0 < last_0) {
            var element_0 = productStructureDTO[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inheritProductStructure.<anonymous>.<anonymous>' call
            if (element_0.partKey === element.partKey) {
              tmp$ret$1 = false;
              break $l$block;
            }
          }
          tmp$ret$1 = true;
        }
        if (tmp$ret$1) {
          destination.q(element);
        }
      }
      tmp = plus_0(productStructureDTO, destination);
    }
    return tmp;
  }
  function inheritMeta($this, meta, otherMeta) {
    var tmp;
    if (otherMeta == null) {
      tmp = meta;
    } else {
      return plus_1(otherMeta, meta);
    }
    return tmp;
  }
  function inheritAllowedDoorPairs($this, allowedDoorPairs, otherAllowedDoorPairs) {
    var tmp;
    if (otherAllowedDoorPairs == null) {
      tmp = allowedDoorPairs;
    } else {
      // Inline function 'kotlin.collections.plus' call
      // Inline function 'kotlin.js.asDynamic' call
      var pairs = otherAllowedDoorPairs.concat(allowedDoorPairs);
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = pairs.length;
      while (inductionVariable < last) {
        var element = pairs[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inheritAllowedDoorPairs.<anonymous>' call
        sort(element);
      }
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.distinctBy' call
      var set = HashSet_init_$Create$();
      var list = ArrayList_init_$Create$();
      var inductionVariable_0 = 0;
      var last_0 = pairs.length;
      while (inductionVariable_0 < last_0) {
        var e = pairs[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inheritAllowedDoorPairs.<anonymous>' call
        var key = joinToString_0(e, '-');
        if (set.q(key)) {
          list.q(e);
        }
      }
      tmp = copyToArray(list);
    }
    return tmp;
  }
  function Companion_3() {
    Companion_instance_4 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    var tmp_0 = new ReferenceArraySerializer(getKClass(AssemblyChildDTO), $serializer_getInstance_5());
    var tmp_1 = new ReferenceArraySerializer(getKClass(ColliderDTO), $serializer_getInstance_6());
    var tmp_2 = new ReferenceArraySerializer(getKClass(ConnectorItemTemplate), Companion_getInstance_3());
    var tmp_3 = new ReferenceArraySerializer(getKClass(ProductStructureItemTemplate), $serializer_getInstance());
    var tmp_4 = new ReferenceArraySerializer(getKClass(ColliderDTO), $serializer_getInstance_6());
    var tmp_5 = new ReferenceArraySerializer(PrimitiveClasses_getInstance().t7(), new ReferenceArraySerializer(PrimitiveClasses_getInstance().q7(), IntSerializer_getInstance()));
    var tmp_6 = new LinkedHashMapSerializer(StringSerializer_getInstance(), JsonElementSerializer_getInstance());
    var tmp_7 = StringSerializer_getInstance();
    var tmp_8 = getKClass(CustomComponentBuilder);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [];
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.i4c_1 = [tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, null, null, null, null, null, null, null, tmp_5, null, null, null, null, null, null, null, null, null, null, tmp_6, null, null, null, null, null, null, null, null, null, new LinkedHashMapSerializer(tmp_7, PolymorphicSerializer_init_$Create$(tmp_8, tmp$ret$2))];
  }
  protoOf(Companion_3).l17 = function () {
    return $serializer_getInstance_7();
  };
  var Companion_instance_4;
  function Companion_getInstance_8() {
    if (Companion_instance_4 == null)
      new Companion_3();
    return Companion_instance_4;
  }
  function $serializer_1() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.ipex.range.dto.item.ItemComponentsDTO', this, 34);
    tmp0_serialDesc.cv('assembly', true);
    tmp0_serialDesc.cv('colliders', true);
    tmp0_serialDesc.cv('connectors', true);
    tmp0_serialDesc.cv('productStructure', true);
    tmp0_serialDesc.cv('functionalZones', true);
    tmp0_serialDesc.cv('autoAdaptGroup', true);
    tmp0_serialDesc.cv('product', true);
    tmp0_serialDesc.cv('modelURI', true);
    tmp0_serialDesc.cv('modelTransform', true);
    tmp0_serialDesc.cv('selectable', true);
    tmp0_serialDesc.cv('outlineable', true);
    tmp0_serialDesc.cv('draggable', true);
    tmp0_serialDesc.cv('allowedDoorPairs', true);
    tmp0_serialDesc.cv('autoAdaptHost', true);
    tmp0_serialDesc.cv('door', true);
    tmp0_serialDesc.cv('doorFront', true);
    tmp0_serialDesc.cv('handle', true);
    tmp0_serialDesc.cv('drawer', true);
    tmp0_serialDesc.cv('frame', true);
    tmp0_serialDesc.cv('leg', true);
    tmp0_serialDesc.cv('innerLight', true);
    tmp0_serialDesc.cv('outerLight', true);
    tmp0_serialDesc.cv('outlined', true);
    tmp0_serialDesc.cv('meta', true);
    tmp0_serialDesc.cv('propping', true);
    tmp0_serialDesc.cv('alwaysHangDown', true);
    tmp0_serialDesc.cv('serializeEntity', true);
    tmp0_serialDesc.cv('placementZoneByHeight', true);
    tmp0_serialDesc.cv('functionalMargin', true);
    tmp0_serialDesc.cv('recommendedInitialPositionFromFloor', true);
    tmp0_serialDesc.cv('visualLightSource', true);
    tmp0_serialDesc.cv('dragSurfaces', true);
    tmp0_serialDesc.cv('dragProjectionPoint', true);
    tmp0_serialDesc.cv('customComponents', true);
    this.j4c_1 = tmp0_serialDesc;
  }
  protoOf($serializer_1).ok = function () {
    return this.j4c_1;
  };
  protoOf($serializer_1).rv = function () {
    var tmp0_cached = Companion_getInstance_8().i4c_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(tmp0_cached[0]), get_nullable(tmp0_cached[1]), get_nullable(tmp0_cached[2]), get_nullable(tmp0_cached[3]), get_nullable(tmp0_cached[4]), get_nullable(CustomSerializer_getInstance()), get_nullable(CustomSerializer_getInstance_2()), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_0()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(tmp0_cached[12]), get_nullable(CustomSerializer_getInstance_0()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(tmp0_cached[23]), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable($serializer_getInstance_1()), get_nullable(MarginTemplateSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable($serializer_getInstance_2()), get_nullable(CustomSerializer_getInstance_1()), get_nullable(PositionTemplateSerializer_getInstance()), tmp0_cached[33]];
  };
  protoOf($serializer_1).qk = function (decoder) {
    var tmp0_desc = this.j4c_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_bitMask1 = 0;
    var tmp5_local0 = null;
    var tmp6_local1 = null;
    var tmp7_local2 = null;
    var tmp8_local3 = null;
    var tmp9_local4 = null;
    var tmp10_local5 = null;
    var tmp11_local6 = null;
    var tmp12_local7 = null;
    var tmp13_local8 = null;
    var tmp14_local9 = null;
    var tmp15_local10 = null;
    var tmp16_local11 = null;
    var tmp17_local12 = null;
    var tmp18_local13 = null;
    var tmp19_local14 = null;
    var tmp20_local15 = null;
    var tmp21_local16 = null;
    var tmp22_local17 = null;
    var tmp23_local18 = null;
    var tmp24_local19 = null;
    var tmp25_local20 = null;
    var tmp26_local21 = null;
    var tmp27_local22 = null;
    var tmp28_local23 = null;
    var tmp29_local24 = null;
    var tmp30_local25 = null;
    var tmp31_local26 = null;
    var tmp32_local27 = null;
    var tmp33_local28 = null;
    var tmp34_local29 = null;
    var tmp35_local30 = null;
    var tmp36_local31 = null;
    var tmp37_local32 = null;
    var tmp38_local33 = null;
    var tmp39_input = decoder.nn(tmp0_desc);
    var tmp40_cached = Companion_getInstance_8().i4c_1;
    if (tmp39_input.do()) {
      tmp5_local0 = tmp39_input.bo(tmp0_desc, 0, tmp40_cached[0], tmp5_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp6_local1 = tmp39_input.bo(tmp0_desc, 1, tmp40_cached[1], tmp6_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp7_local2 = tmp39_input.bo(tmp0_desc, 2, tmp40_cached[2], tmp7_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp8_local3 = tmp39_input.bo(tmp0_desc, 3, tmp40_cached[3], tmp8_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp9_local4 = tmp39_input.bo(tmp0_desc, 4, tmp40_cached[4], tmp9_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp10_local5 = tmp39_input.bo(tmp0_desc, 5, CustomSerializer_getInstance(), tmp10_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp11_local6 = tmp39_input.bo(tmp0_desc, 6, CustomSerializer_getInstance_2(), tmp11_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp12_local7 = tmp39_input.bo(tmp0_desc, 7, StringSerializer_getInstance(), tmp12_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp13_local8 = tmp39_input.bo(tmp0_desc, 8, $serializer_getInstance_0(), tmp13_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp14_local9 = tmp39_input.bo(tmp0_desc, 9, BooleanSerializer_getInstance(), tmp14_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp15_local10 = tmp39_input.bo(tmp0_desc, 10, BooleanSerializer_getInstance(), tmp15_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp16_local11 = tmp39_input.bo(tmp0_desc, 11, BooleanSerializer_getInstance(), tmp16_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp17_local12 = tmp39_input.bo(tmp0_desc, 12, tmp40_cached[12], tmp17_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp18_local13 = tmp39_input.bo(tmp0_desc, 13, CustomSerializer_getInstance_0(), tmp18_local13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp19_local14 = tmp39_input.bo(tmp0_desc, 14, BooleanSerializer_getInstance(), tmp19_local14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp20_local15 = tmp39_input.bo(tmp0_desc, 15, BooleanSerializer_getInstance(), tmp20_local15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
      tmp21_local16 = tmp39_input.bo(tmp0_desc, 16, BooleanSerializer_getInstance(), tmp21_local16);
      tmp3_bitMask0 = tmp3_bitMask0 | 65536;
      tmp22_local17 = tmp39_input.bo(tmp0_desc, 17, BooleanSerializer_getInstance(), tmp22_local17);
      tmp3_bitMask0 = tmp3_bitMask0 | 131072;
      tmp23_local18 = tmp39_input.bo(tmp0_desc, 18, BooleanSerializer_getInstance(), tmp23_local18);
      tmp3_bitMask0 = tmp3_bitMask0 | 262144;
      tmp24_local19 = tmp39_input.bo(tmp0_desc, 19, BooleanSerializer_getInstance(), tmp24_local19);
      tmp3_bitMask0 = tmp3_bitMask0 | 524288;
      tmp25_local20 = tmp39_input.bo(tmp0_desc, 20, BooleanSerializer_getInstance(), tmp25_local20);
      tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
      tmp26_local21 = tmp39_input.bo(tmp0_desc, 21, BooleanSerializer_getInstance(), tmp26_local21);
      tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
      tmp27_local22 = tmp39_input.bo(tmp0_desc, 22, BooleanSerializer_getInstance(), tmp27_local22);
      tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
      tmp28_local23 = tmp39_input.bo(tmp0_desc, 23, tmp40_cached[23], tmp28_local23);
      tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
      tmp29_local24 = tmp39_input.bo(tmp0_desc, 24, BooleanSerializer_getInstance(), tmp29_local24);
      tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
      tmp30_local25 = tmp39_input.bo(tmp0_desc, 25, BooleanSerializer_getInstance(), tmp30_local25);
      tmp3_bitMask0 = tmp3_bitMask0 | 33554432;
      tmp31_local26 = tmp39_input.bo(tmp0_desc, 26, BooleanSerializer_getInstance(), tmp31_local26);
      tmp3_bitMask0 = tmp3_bitMask0 | 67108864;
      tmp32_local27 = tmp39_input.bo(tmp0_desc, 27, $serializer_getInstance_1(), tmp32_local27);
      tmp3_bitMask0 = tmp3_bitMask0 | 134217728;
      tmp33_local28 = tmp39_input.bo(tmp0_desc, 28, MarginTemplateSerializer_getInstance(), tmp33_local28);
      tmp3_bitMask0 = tmp3_bitMask0 | 268435456;
      tmp34_local29 = tmp39_input.bo(tmp0_desc, 29, IntSerializer_getInstance(), tmp34_local29);
      tmp3_bitMask0 = tmp3_bitMask0 | 536870912;
      tmp35_local30 = tmp39_input.bo(tmp0_desc, 30, $serializer_getInstance_2(), tmp35_local30);
      tmp3_bitMask0 = tmp3_bitMask0 | 1073741824;
      tmp36_local31 = tmp39_input.bo(tmp0_desc, 31, CustomSerializer_getInstance_1(), tmp36_local31);
      tmp3_bitMask0 = tmp3_bitMask0 | -2147483648;
      tmp37_local32 = tmp39_input.bo(tmp0_desc, 32, PositionTemplateSerializer_getInstance(), tmp37_local32);
      tmp4_bitMask1 = tmp4_bitMask1 | 1;
      tmp38_local33 = tmp39_input.zn(tmp0_desc, 33, tmp40_cached[33], tmp38_local33);
      tmp4_bitMask1 = tmp4_bitMask1 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp39_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp5_local0 = tmp39_input.bo(tmp0_desc, 0, tmp40_cached[0], tmp5_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp6_local1 = tmp39_input.bo(tmp0_desc, 1, tmp40_cached[1], tmp6_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp7_local2 = tmp39_input.bo(tmp0_desc, 2, tmp40_cached[2], tmp7_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp8_local3 = tmp39_input.bo(tmp0_desc, 3, tmp40_cached[3], tmp8_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp9_local4 = tmp39_input.bo(tmp0_desc, 4, tmp40_cached[4], tmp9_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp10_local5 = tmp39_input.bo(tmp0_desc, 5, CustomSerializer_getInstance(), tmp10_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp11_local6 = tmp39_input.bo(tmp0_desc, 6, CustomSerializer_getInstance_2(), tmp11_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp12_local7 = tmp39_input.bo(tmp0_desc, 7, StringSerializer_getInstance(), tmp12_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp13_local8 = tmp39_input.bo(tmp0_desc, 8, $serializer_getInstance_0(), tmp13_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp14_local9 = tmp39_input.bo(tmp0_desc, 9, BooleanSerializer_getInstance(), tmp14_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp15_local10 = tmp39_input.bo(tmp0_desc, 10, BooleanSerializer_getInstance(), tmp15_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp16_local11 = tmp39_input.bo(tmp0_desc, 11, BooleanSerializer_getInstance(), tmp16_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp17_local12 = tmp39_input.bo(tmp0_desc, 12, tmp40_cached[12], tmp17_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp18_local13 = tmp39_input.bo(tmp0_desc, 13, CustomSerializer_getInstance_0(), tmp18_local13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp19_local14 = tmp39_input.bo(tmp0_desc, 14, BooleanSerializer_getInstance(), tmp19_local14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp20_local15 = tmp39_input.bo(tmp0_desc, 15, BooleanSerializer_getInstance(), tmp20_local15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          case 16:
            tmp21_local16 = tmp39_input.bo(tmp0_desc, 16, BooleanSerializer_getInstance(), tmp21_local16);
            tmp3_bitMask0 = tmp3_bitMask0 | 65536;
            break;
          case 17:
            tmp22_local17 = tmp39_input.bo(tmp0_desc, 17, BooleanSerializer_getInstance(), tmp22_local17);
            tmp3_bitMask0 = tmp3_bitMask0 | 131072;
            break;
          case 18:
            tmp23_local18 = tmp39_input.bo(tmp0_desc, 18, BooleanSerializer_getInstance(), tmp23_local18);
            tmp3_bitMask0 = tmp3_bitMask0 | 262144;
            break;
          case 19:
            tmp24_local19 = tmp39_input.bo(tmp0_desc, 19, BooleanSerializer_getInstance(), tmp24_local19);
            tmp3_bitMask0 = tmp3_bitMask0 | 524288;
            break;
          case 20:
            tmp25_local20 = tmp39_input.bo(tmp0_desc, 20, BooleanSerializer_getInstance(), tmp25_local20);
            tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
            break;
          case 21:
            tmp26_local21 = tmp39_input.bo(tmp0_desc, 21, BooleanSerializer_getInstance(), tmp26_local21);
            tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
            break;
          case 22:
            tmp27_local22 = tmp39_input.bo(tmp0_desc, 22, BooleanSerializer_getInstance(), tmp27_local22);
            tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
            break;
          case 23:
            tmp28_local23 = tmp39_input.bo(tmp0_desc, 23, tmp40_cached[23], tmp28_local23);
            tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
            break;
          case 24:
            tmp29_local24 = tmp39_input.bo(tmp0_desc, 24, BooleanSerializer_getInstance(), tmp29_local24);
            tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
            break;
          case 25:
            tmp30_local25 = tmp39_input.bo(tmp0_desc, 25, BooleanSerializer_getInstance(), tmp30_local25);
            tmp3_bitMask0 = tmp3_bitMask0 | 33554432;
            break;
          case 26:
            tmp31_local26 = tmp39_input.bo(tmp0_desc, 26, BooleanSerializer_getInstance(), tmp31_local26);
            tmp3_bitMask0 = tmp3_bitMask0 | 67108864;
            break;
          case 27:
            tmp32_local27 = tmp39_input.bo(tmp0_desc, 27, $serializer_getInstance_1(), tmp32_local27);
            tmp3_bitMask0 = tmp3_bitMask0 | 134217728;
            break;
          case 28:
            tmp33_local28 = tmp39_input.bo(tmp0_desc, 28, MarginTemplateSerializer_getInstance(), tmp33_local28);
            tmp3_bitMask0 = tmp3_bitMask0 | 268435456;
            break;
          case 29:
            tmp34_local29 = tmp39_input.bo(tmp0_desc, 29, IntSerializer_getInstance(), tmp34_local29);
            tmp3_bitMask0 = tmp3_bitMask0 | 536870912;
            break;
          case 30:
            tmp35_local30 = tmp39_input.bo(tmp0_desc, 30, $serializer_getInstance_2(), tmp35_local30);
            tmp3_bitMask0 = tmp3_bitMask0 | 1073741824;
            break;
          case 31:
            tmp36_local31 = tmp39_input.bo(tmp0_desc, 31, CustomSerializer_getInstance_1(), tmp36_local31);
            tmp3_bitMask0 = tmp3_bitMask0 | -2147483648;
            break;
          case 32:
            tmp37_local32 = tmp39_input.bo(tmp0_desc, 32, PositionTemplateSerializer_getInstance(), tmp37_local32);
            tmp4_bitMask1 = tmp4_bitMask1 | 1;
            break;
          case 33:
            tmp38_local33 = tmp39_input.zn(tmp0_desc, 33, tmp40_cached[33], tmp38_local33);
            tmp4_bitMask1 = tmp4_bitMask1 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp39_input.on(tmp0_desc);
    return ItemComponentsDTO_init_$Create$(tmp3_bitMask0, tmp4_bitMask1, tmp5_local0, tmp6_local1, tmp7_local2, tmp8_local3, tmp9_local4, tmp10_local5, tmp11_local6, tmp12_local7, tmp13_local8, tmp14_local9, tmp15_local10, tmp16_local11, tmp17_local12, tmp18_local13, tmp19_local14, tmp20_local15, tmp21_local16, tmp22_local17, tmp23_local18, tmp24_local19, tmp25_local20, tmp26_local21, tmp27_local22, tmp28_local23, tmp29_local24, tmp30_local25, tmp31_local26, tmp32_local27, tmp33_local28, tmp34_local29, tmp35_local30, tmp36_local31, tmp37_local32, tmp38_local33, null);
  };
  protoOf($serializer_1).k4c = function (encoder, value) {
    var tmp0_desc = this.j4c_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    var tmp2_cached = Companion_getInstance_8().i4c_1;
    if (tmp1_output.kp(tmp0_desc, 0) ? true : !(value.assembly == null)) {
      tmp1_output.gp(tmp0_desc, 0, tmp2_cached[0], value.assembly);
    }
    if (tmp1_output.kp(tmp0_desc, 1) ? true : !(value.colliders == null)) {
      tmp1_output.gp(tmp0_desc, 1, tmp2_cached[1], value.colliders);
    }
    if (tmp1_output.kp(tmp0_desc, 2) ? true : !(value.connectors == null)) {
      tmp1_output.gp(tmp0_desc, 2, tmp2_cached[2], value.connectors);
    }
    if (tmp1_output.kp(tmp0_desc, 3) ? true : !(value.productStructure == null)) {
      tmp1_output.gp(tmp0_desc, 3, tmp2_cached[3], value.productStructure);
    }
    if (tmp1_output.kp(tmp0_desc, 4) ? true : !(value.functionalZones == null)) {
      tmp1_output.gp(tmp0_desc, 4, tmp2_cached[4], value.functionalZones);
    }
    if (tmp1_output.kp(tmp0_desc, 5) ? true : !(value.autoAdaptGroup == null)) {
      tmp1_output.gp(tmp0_desc, 5, CustomSerializer_getInstance(), value.autoAdaptGroup);
    }
    if (tmp1_output.kp(tmp0_desc, 6) ? true : !(value.product == null)) {
      tmp1_output.gp(tmp0_desc, 6, CustomSerializer_getInstance_2(), value.product);
    }
    if (tmp1_output.kp(tmp0_desc, 7) ? true : !(value.modelURI == null)) {
      tmp1_output.gp(tmp0_desc, 7, StringSerializer_getInstance(), value.modelURI);
    }
    if (tmp1_output.kp(tmp0_desc, 8) ? true : !(value.modelTransform == null)) {
      tmp1_output.gp(tmp0_desc, 8, $serializer_getInstance_0(), value.modelTransform);
    }
    if (tmp1_output.kp(tmp0_desc, 9) ? true : !(value.selectable == null)) {
      tmp1_output.gp(tmp0_desc, 9, BooleanSerializer_getInstance(), value.selectable);
    }
    if (tmp1_output.kp(tmp0_desc, 10) ? true : !(value.outlineable == null)) {
      tmp1_output.gp(tmp0_desc, 10, BooleanSerializer_getInstance(), value.outlineable);
    }
    if (tmp1_output.kp(tmp0_desc, 11) ? true : !(value.draggable == null)) {
      tmp1_output.gp(tmp0_desc, 11, BooleanSerializer_getInstance(), value.draggable);
    }
    if (tmp1_output.kp(tmp0_desc, 12) ? true : !(value.allowedDoorPairs == null)) {
      tmp1_output.gp(tmp0_desc, 12, tmp2_cached[12], value.allowedDoorPairs);
    }
    if (tmp1_output.kp(tmp0_desc, 13) ? true : !(value.autoAdaptHost == null)) {
      tmp1_output.gp(tmp0_desc, 13, CustomSerializer_getInstance_0(), value.autoAdaptHost);
    }
    if (tmp1_output.kp(tmp0_desc, 14) ? true : !(value.door == null)) {
      tmp1_output.gp(tmp0_desc, 14, BooleanSerializer_getInstance(), value.door);
    }
    if (tmp1_output.kp(tmp0_desc, 15) ? true : !(value.doorFront == null)) {
      tmp1_output.gp(tmp0_desc, 15, BooleanSerializer_getInstance(), value.doorFront);
    }
    if (tmp1_output.kp(tmp0_desc, 16) ? true : !(value.handle == null)) {
      tmp1_output.gp(tmp0_desc, 16, BooleanSerializer_getInstance(), value.handle);
    }
    if (tmp1_output.kp(tmp0_desc, 17) ? true : !(value.drawer == null)) {
      tmp1_output.gp(tmp0_desc, 17, BooleanSerializer_getInstance(), value.drawer);
    }
    if (tmp1_output.kp(tmp0_desc, 18) ? true : !(value.frame == null)) {
      tmp1_output.gp(tmp0_desc, 18, BooleanSerializer_getInstance(), value.frame);
    }
    if (tmp1_output.kp(tmp0_desc, 19) ? true : !(value.leg == null)) {
      tmp1_output.gp(tmp0_desc, 19, BooleanSerializer_getInstance(), value.leg);
    }
    if (tmp1_output.kp(tmp0_desc, 20) ? true : !(value.innerLight == null)) {
      tmp1_output.gp(tmp0_desc, 20, BooleanSerializer_getInstance(), value.innerLight);
    }
    if (tmp1_output.kp(tmp0_desc, 21) ? true : !(value.outerLight == null)) {
      tmp1_output.gp(tmp0_desc, 21, BooleanSerializer_getInstance(), value.outerLight);
    }
    if (tmp1_output.kp(tmp0_desc, 22) ? true : !(value.outlined == null)) {
      tmp1_output.gp(tmp0_desc, 22, BooleanSerializer_getInstance(), value.outlined);
    }
    if (tmp1_output.kp(tmp0_desc, 23) ? true : !(value.meta == null)) {
      tmp1_output.gp(tmp0_desc, 23, tmp2_cached[23], value.meta);
    }
    if (tmp1_output.kp(tmp0_desc, 24) ? true : !(value.propping == null)) {
      tmp1_output.gp(tmp0_desc, 24, BooleanSerializer_getInstance(), value.propping);
    }
    if (tmp1_output.kp(tmp0_desc, 25) ? true : !(value.alwaysHangDown == null)) {
      tmp1_output.gp(tmp0_desc, 25, BooleanSerializer_getInstance(), value.alwaysHangDown);
    }
    if (tmp1_output.kp(tmp0_desc, 26) ? true : !(value.serializeEntity == null)) {
      tmp1_output.gp(tmp0_desc, 26, BooleanSerializer_getInstance(), value.serializeEntity);
    }
    if (tmp1_output.kp(tmp0_desc, 27) ? true : !(value.placementZoneByHeight == null)) {
      tmp1_output.gp(tmp0_desc, 27, $serializer_getInstance_1(), value.placementZoneByHeight);
    }
    if (tmp1_output.kp(tmp0_desc, 28) ? true : !(value.functionalMargin == null)) {
      tmp1_output.gp(tmp0_desc, 28, MarginTemplateSerializer_getInstance(), value.functionalMargin);
    }
    if (tmp1_output.kp(tmp0_desc, 29) ? true : !(value.recommendedInitialPositionFromFloor == null)) {
      tmp1_output.gp(tmp0_desc, 29, IntSerializer_getInstance(), value.recommendedInitialPositionFromFloor);
    }
    if (tmp1_output.kp(tmp0_desc, 30) ? true : !(value.visualLightSource == null)) {
      tmp1_output.gp(tmp0_desc, 30, $serializer_getInstance_2(), value.visualLightSource);
    }
    if (tmp1_output.kp(tmp0_desc, 31) ? true : !(value.dragSurfaces == null)) {
      tmp1_output.gp(tmp0_desc, 31, CustomSerializer_getInstance_1(), value.dragSurfaces);
    }
    if (tmp1_output.kp(tmp0_desc, 32) ? true : !(value.dragProjectionPoint == null)) {
      tmp1_output.gp(tmp0_desc, 32, PositionTemplateSerializer_getInstance(), value.dragProjectionPoint);
    }
    var tmp;
    if (tmp1_output.kp(tmp0_desc, 33)) {
      tmp = true;
    } else {
      var tmp_0 = value.customComponents;
      // Inline function 'kotlin.collections.mapOf' call
      var tmp$ret$0 = emptyMap();
      tmp = !equals(tmp_0, tmp$ret$0);
    }
    if (tmp) {
      tmp1_output.ep(tmp0_desc, 33, tmp2_cached[33], value.customComponents);
    }
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_1).pk = function (encoder, value) {
    return this.k4c(encoder, value instanceof ItemComponentsDTO ? value : THROW_CCE());
  };
  var $serializer_instance_1;
  function $serializer_getInstance_7() {
    if ($serializer_instance_1 == null)
      new $serializer_1();
    return $serializer_instance_1;
  }
  function ItemComponentsDTO_init_$Init$(seen1, seen2, assembly, colliders, connectors, productStructure, functionalZones, autoAdaptGroup, product, modelURI, modelTransform, selectable, outlineable, draggable, allowedDoorPairs, autoAdaptHost, door, doorFront, handle, drawer, frame, leg, innerLight, outerLight, outlined, meta, propping, alwaysHangDown, serializeEntity, placementZoneByHeight, functionalMargin, recommendedInitialPositionFromFloor, visualLightSource, dragSurfaces, dragProjectionPoint, customComponents, serializationConstructorMarker, $this) {
    if (!!(!(0 === (0 & seen1)) | !(0 === (0 & seen2)))) {
      // Inline function 'kotlin.intArrayOf' call
      var tmp = new Int32Array([seen1, seen2]);
      // Inline function 'kotlin.intArrayOf' call
      var tmp$ret$1 = new Int32Array([0, 0]);
      throwArrayMissingFieldException(tmp, tmp$ret$1, $serializer_getInstance_7().j4c_1);
    }
    if (0 === (seen1 & 1))
      $this.assembly = null;
    else
      $this.assembly = assembly;
    if (0 === (seen1 & 2))
      $this.colliders = null;
    else
      $this.colliders = colliders;
    if (0 === (seen1 & 4))
      $this.connectors = null;
    else
      $this.connectors = connectors;
    if (0 === (seen1 & 8))
      $this.productStructure = null;
    else
      $this.productStructure = productStructure;
    if (0 === (seen1 & 16))
      $this.functionalZones = null;
    else
      $this.functionalZones = functionalZones;
    if (0 === (seen1 & 32))
      $this.autoAdaptGroup = null;
    else
      $this.autoAdaptGroup = autoAdaptGroup;
    if (0 === (seen1 & 64))
      $this.product = null;
    else
      $this.product = product;
    if (0 === (seen1 & 128))
      $this.modelURI = null;
    else
      $this.modelURI = modelURI;
    if (0 === (seen1 & 256))
      $this.modelTransform = null;
    else
      $this.modelTransform = modelTransform;
    if (0 === (seen1 & 512))
      $this.selectable = null;
    else
      $this.selectable = selectable;
    if (0 === (seen1 & 1024))
      $this.outlineable = null;
    else
      $this.outlineable = outlineable;
    if (0 === (seen1 & 2048))
      $this.draggable = null;
    else
      $this.draggable = draggable;
    if (0 === (seen1 & 4096))
      $this.allowedDoorPairs = null;
    else
      $this.allowedDoorPairs = allowedDoorPairs;
    if (0 === (seen1 & 8192))
      $this.autoAdaptHost = null;
    else
      $this.autoAdaptHost = autoAdaptHost;
    if (0 === (seen1 & 16384))
      $this.door = null;
    else
      $this.door = door;
    if (0 === (seen1 & 32768))
      $this.doorFront = null;
    else
      $this.doorFront = doorFront;
    if (0 === (seen1 & 65536))
      $this.handle = null;
    else
      $this.handle = handle;
    if (0 === (seen1 & 131072))
      $this.drawer = null;
    else
      $this.drawer = drawer;
    if (0 === (seen1 & 262144))
      $this.frame = null;
    else
      $this.frame = frame;
    if (0 === (seen1 & 524288))
      $this.leg = null;
    else
      $this.leg = leg;
    if (0 === (seen1 & 1048576))
      $this.innerLight = null;
    else
      $this.innerLight = innerLight;
    if (0 === (seen1 & 2097152))
      $this.outerLight = null;
    else
      $this.outerLight = outerLight;
    if (0 === (seen1 & 4194304))
      $this.outlined = null;
    else
      $this.outlined = outlined;
    if (0 === (seen1 & 8388608))
      $this.meta = null;
    else
      $this.meta = meta;
    if (0 === (seen1 & 16777216))
      $this.propping = null;
    else
      $this.propping = propping;
    if (0 === (seen1 & 33554432))
      $this.alwaysHangDown = null;
    else
      $this.alwaysHangDown = alwaysHangDown;
    if (0 === (seen1 & 67108864))
      $this.serializeEntity = null;
    else
      $this.serializeEntity = serializeEntity;
    if (0 === (seen1 & 134217728))
      $this.placementZoneByHeight = null;
    else
      $this.placementZoneByHeight = placementZoneByHeight;
    if (0 === (seen1 & 268435456))
      $this.functionalMargin = null;
    else
      $this.functionalMargin = functionalMargin;
    if (0 === (seen1 & 536870912))
      $this.recommendedInitialPositionFromFloor = null;
    else
      $this.recommendedInitialPositionFromFloor = recommendedInitialPositionFromFloor;
    if (0 === (seen1 & 1073741824))
      $this.visualLightSource = null;
    else
      $this.visualLightSource = visualLightSource;
    if (0 === (seen1 & -2147483648))
      $this.dragSurfaces = null;
    else
      $this.dragSurfaces = dragSurfaces;
    if (0 === (seen2 & 1))
      $this.dragProjectionPoint = null;
    else
      $this.dragProjectionPoint = dragProjectionPoint;
    if (0 === (seen2 & 2)) {
      var tmp_0 = $this;
      // Inline function 'kotlin.collections.mapOf' call
      tmp_0.customComponents = emptyMap();
    } else
      $this.customComponents = customComponents;
    return $this;
  }
  function ItemComponentsDTO_init_$Create$(seen1, seen2, assembly, colliders, connectors, productStructure, functionalZones, autoAdaptGroup, product, modelURI, modelTransform, selectable, outlineable, draggable, allowedDoorPairs, autoAdaptHost, door, doorFront, handle, drawer, frame, leg, innerLight, outerLight, outlined, meta, propping, alwaysHangDown, serializeEntity, placementZoneByHeight, functionalMargin, recommendedInitialPositionFromFloor, visualLightSource, dragSurfaces, dragProjectionPoint, customComponents, serializationConstructorMarker) {
    return ItemComponentsDTO_init_$Init$(seen1, seen2, assembly, colliders, connectors, productStructure, functionalZones, autoAdaptGroup, product, modelURI, modelTransform, selectable, outlineable, draggable, allowedDoorPairs, autoAdaptHost, door, doorFront, handle, drawer, frame, leg, innerLight, outerLight, outlined, meta, propping, alwaysHangDown, serializeEntity, placementZoneByHeight, functionalMargin, recommendedInitialPositionFromFloor, visualLightSource, dragSurfaces, dragProjectionPoint, customComponents, serializationConstructorMarker, objectCreate(protoOf(ItemComponentsDTO)));
  }
  function ItemComponentsDTO(assembly, colliders, connectors, productStructure, functionalZones, autoAdaptGroup, product, modelURI, modelTransform, selectable, outlineable, draggable, allowedDoorPairs, autoAdaptHost, door, doorFront, handle, drawer, frame, leg, innerLight, outerLight, outlined, meta, propping, alwaysHangDown, serializeEntity, placementZoneByHeight, functionalMargin, recommendedInitialPositionFromFloor, visualLightSource, dragSurfaces, dragProjectionPoint, customComponents) {
    Companion_getInstance_8();
    assembly = assembly === VOID ? null : assembly;
    colliders = colliders === VOID ? null : colliders;
    connectors = connectors === VOID ? null : connectors;
    productStructure = productStructure === VOID ? null : productStructure;
    functionalZones = functionalZones === VOID ? null : functionalZones;
    autoAdaptGroup = autoAdaptGroup === VOID ? null : autoAdaptGroup;
    product = product === VOID ? null : product;
    modelURI = modelURI === VOID ? null : modelURI;
    modelTransform = modelTransform === VOID ? null : modelTransform;
    selectable = selectable === VOID ? null : selectable;
    outlineable = outlineable === VOID ? null : outlineable;
    draggable = draggable === VOID ? null : draggable;
    allowedDoorPairs = allowedDoorPairs === VOID ? null : allowedDoorPairs;
    autoAdaptHost = autoAdaptHost === VOID ? null : autoAdaptHost;
    door = door === VOID ? null : door;
    doorFront = doorFront === VOID ? null : doorFront;
    handle = handle === VOID ? null : handle;
    drawer = drawer === VOID ? null : drawer;
    frame = frame === VOID ? null : frame;
    leg = leg === VOID ? null : leg;
    innerLight = innerLight === VOID ? null : innerLight;
    outerLight = outerLight === VOID ? null : outerLight;
    outlined = outlined === VOID ? null : outlined;
    meta = meta === VOID ? null : meta;
    propping = propping === VOID ? null : propping;
    alwaysHangDown = alwaysHangDown === VOID ? null : alwaysHangDown;
    serializeEntity = serializeEntity === VOID ? null : serializeEntity;
    placementZoneByHeight = placementZoneByHeight === VOID ? null : placementZoneByHeight;
    functionalMargin = functionalMargin === VOID ? null : functionalMargin;
    recommendedInitialPositionFromFloor = recommendedInitialPositionFromFloor === VOID ? null : recommendedInitialPositionFromFloor;
    visualLightSource = visualLightSource === VOID ? null : visualLightSource;
    dragSurfaces = dragSurfaces === VOID ? null : dragSurfaces;
    dragProjectionPoint = dragProjectionPoint === VOID ? null : dragProjectionPoint;
    var tmp;
    if (customComponents === VOID) {
      // Inline function 'kotlin.collections.mapOf' call
      tmp = emptyMap();
    } else {
      tmp = customComponents;
    }
    customComponents = tmp;
    this.assembly = assembly;
    this.colliders = colliders;
    this.connectors = connectors;
    this.productStructure = productStructure;
    this.functionalZones = functionalZones;
    this.autoAdaptGroup = autoAdaptGroup;
    this.product = product;
    this.modelURI = modelURI;
    this.modelTransform = modelTransform;
    this.selectable = selectable;
    this.outlineable = outlineable;
    this.draggable = draggable;
    this.allowedDoorPairs = allowedDoorPairs;
    this.autoAdaptHost = autoAdaptHost;
    this.door = door;
    this.doorFront = doorFront;
    this.handle = handle;
    this.drawer = drawer;
    this.frame = frame;
    this.leg = leg;
    this.innerLight = innerLight;
    this.outerLight = outerLight;
    this.outlined = outlined;
    this.meta = meta;
    this.propping = propping;
    this.alwaysHangDown = alwaysHangDown;
    this.serializeEntity = serializeEntity;
    this.placementZoneByHeight = placementZoneByHeight;
    this.functionalMargin = functionalMargin;
    this.recommendedInitialPositionFromFloor = recommendedInitialPositionFromFloor;
    this.visualLightSource = visualLightSource;
    this.dragSurfaces = dragSurfaces;
    this.dragProjectionPoint = dragProjectionPoint;
    this.customComponents = customComponents;
  }
  protoOf(ItemComponentsDTO).l4c = function (_set____db54di) {
    this.assembly = _set____db54di;
  };
  protoOf(ItemComponentsDTO).h44 = function () {
    return this.assembly;
  };
  protoOf(ItemComponentsDTO).m4c = function (_set____db54di) {
    this.colliders = _set____db54di;
  };
  protoOf(ItemComponentsDTO).n4c = function () {
    return this.colliders;
  };
  protoOf(ItemComponentsDTO).f44 = function (_set____db54di) {
    this.connectors = _set____db54di;
  };
  protoOf(ItemComponentsDTO).a1y = function () {
    return this.connectors;
  };
  protoOf(ItemComponentsDTO).f46 = function (_set____db54di) {
    this.productStructure = _set____db54di;
  };
  protoOf(ItemComponentsDTO).g46 = function () {
    return this.productStructure;
  };
  protoOf(ItemComponentsDTO).o4c = function (_set____db54di) {
    this.functionalZones = _set____db54di;
  };
  protoOf(ItemComponentsDTO).e44 = function () {
    return this.functionalZones;
  };
  protoOf(ItemComponentsDTO).y3x = function () {
    return this.autoAdaptGroup;
  };
  protoOf(ItemComponentsDTO).n42 = function () {
    return this.product;
  };
  protoOf(ItemComponentsDTO).t3x = function () {
    return this.modelURI;
  };
  protoOf(ItemComponentsDTO).h40 = function () {
    return this.modelTransform;
  };
  protoOf(ItemComponentsDTO).j44 = function () {
    return this.selectable;
  };
  protoOf(ItemComponentsDTO).k44 = function (_set____db54di) {
    this.outlineable = _set____db54di;
  };
  protoOf(ItemComponentsDTO).l44 = function () {
    return this.outlineable;
  };
  protoOf(ItemComponentsDTO).m44 = function (_set____db54di) {
    this.draggable = _set____db54di;
  };
  protoOf(ItemComponentsDTO).n44 = function () {
    return this.draggable;
  };
  protoOf(ItemComponentsDTO).o44 = function (_set____db54di) {
    this.allowedDoorPairs = _set____db54di;
  };
  protoOf(ItemComponentsDTO).p44 = function () {
    return this.allowedDoorPairs;
  };
  protoOf(ItemComponentsDTO).q44 = function (_set____db54di) {
    this.autoAdaptHost = _set____db54di;
  };
  protoOf(ItemComponentsDTO).r44 = function () {
    return this.autoAdaptHost;
  };
  protoOf(ItemComponentsDTO).u44 = function (_set____db54di) {
    this.door = _set____db54di;
  };
  protoOf(ItemComponentsDTO).v44 = function () {
    return this.door;
  };
  protoOf(ItemComponentsDTO).w44 = function (_set____db54di) {
    this.doorFront = _set____db54di;
  };
  protoOf(ItemComponentsDTO).x44 = function () {
    return this.doorFront;
  };
  protoOf(ItemComponentsDTO).y44 = function (_set____db54di) {
    this.handle = _set____db54di;
  };
  protoOf(ItemComponentsDTO).z44 = function () {
    return this.handle;
  };
  protoOf(ItemComponentsDTO).a45 = function (_set____db54di) {
    this.drawer = _set____db54di;
  };
  protoOf(ItemComponentsDTO).b45 = function () {
    return this.drawer;
  };
  protoOf(ItemComponentsDTO).c45 = function (_set____db54di) {
    this.frame = _set____db54di;
  };
  protoOf(ItemComponentsDTO).d45 = function () {
    return this.frame;
  };
  protoOf(ItemComponentsDTO).e45 = function (_set____db54di) {
    this.leg = _set____db54di;
  };
  protoOf(ItemComponentsDTO).f45 = function () {
    return this.leg;
  };
  protoOf(ItemComponentsDTO).p4c = function (_set____db54di) {
    this.innerLight = _set____db54di;
  };
  protoOf(ItemComponentsDTO).q4c = function () {
    return this.innerLight;
  };
  protoOf(ItemComponentsDTO).r4c = function (_set____db54di) {
    this.outerLight = _set____db54di;
  };
  protoOf(ItemComponentsDTO).s4c = function () {
    return this.outerLight;
  };
  protoOf(ItemComponentsDTO).i45 = function (_set____db54di) {
    this.outlined = _set____db54di;
  };
  protoOf(ItemComponentsDTO).j45 = function () {
    return this.outlined;
  };
  protoOf(ItemComponentsDTO).k45 = function (_set____db54di) {
    this.meta = _set____db54di;
  };
  protoOf(ItemComponentsDTO).z3x = function () {
    return this.meta;
  };
  protoOf(ItemComponentsDTO).l45 = function (_set____db54di) {
    this.propping = _set____db54di;
  };
  protoOf(ItemComponentsDTO).z3e = function () {
    return this.propping;
  };
  protoOf(ItemComponentsDTO).m45 = function (_set____db54di) {
    this.alwaysHangDown = _set____db54di;
  };
  protoOf(ItemComponentsDTO).n45 = function () {
    return this.alwaysHangDown;
  };
  protoOf(ItemComponentsDTO).o45 = function (_set____db54di) {
    this.serializeEntity = _set____db54di;
  };
  protoOf(ItemComponentsDTO).p45 = function () {
    return this.serializeEntity;
  };
  protoOf(ItemComponentsDTO).q45 = function (_set____db54di) {
    this.placementZoneByHeight = _set____db54di;
  };
  protoOf(ItemComponentsDTO).r45 = function () {
    return this.placementZoneByHeight;
  };
  protoOf(ItemComponentsDTO).s45 = function (_set____db54di) {
    this.functionalMargin = _set____db54di;
  };
  protoOf(ItemComponentsDTO).t45 = function () {
    return this.functionalMargin;
  };
  protoOf(ItemComponentsDTO).u45 = function (_set____db54di) {
    this.recommendedInitialPositionFromFloor = _set____db54di;
  };
  protoOf(ItemComponentsDTO).v45 = function () {
    return this.recommendedInitialPositionFromFloor;
  };
  protoOf(ItemComponentsDTO).w45 = function (_set____db54di) {
    this.visualLightSource = _set____db54di;
  };
  protoOf(ItemComponentsDTO).x45 = function () {
    return this.visualLightSource;
  };
  protoOf(ItemComponentsDTO).b46 = function (_set____db54di) {
    this.dragSurfaces = _set____db54di;
  };
  protoOf(ItemComponentsDTO).c46 = function () {
    return this.dragSurfaces;
  };
  protoOf(ItemComponentsDTO).d46 = function (_set____db54di) {
    this.dragProjectionPoint = _set____db54di;
  };
  protoOf(ItemComponentsDTO).e46 = function () {
    return this.dragProjectionPoint;
  };
  protoOf(ItemComponentsDTO).t4c = function (_set____db54di) {
    this.customComponents = _set____db54di;
  };
  protoOf(ItemComponentsDTO).u4c = function () {
    return this.customComponents;
  };
  protoOf(ItemComponentsDTO).inherit = function (parentComponents) {
    var tmp0_safe_receiver = this.assembly;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inherit.<anonymous>' call
      tmp = inheritAssembly(this, tmp0_safe_receiver, parentComponents.assembly);
    }
    var tmp1_elvis_lhs = tmp;
    var tmp40_assembly = tmp1_elvis_lhs == null ? parentComponents.assembly : tmp1_elvis_lhs;
    var tmp2_safe_receiver = this.colliders;
    var tmp_0;
    if (tmp2_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inherit.<anonymous>' call
      tmp_0 = inheritColliders(this, tmp2_safe_receiver, parentComponents.colliders);
    }
    var tmp3_elvis_lhs = tmp_0;
    var tmp41_colliders = tmp3_elvis_lhs == null ? parentComponents.colliders : tmp3_elvis_lhs;
    var tmp4_safe_receiver = this.connectors;
    var tmp_1;
    if (tmp4_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inherit.<anonymous>' call
      tmp_1 = inheritConnectors(this, tmp4_safe_receiver, parentComponents.connectors);
    }
    var tmp5_elvis_lhs = tmp_1;
    var tmp42_connectors = tmp5_elvis_lhs == null ? parentComponents.connectors : tmp5_elvis_lhs;
    var tmp6_safe_receiver = this.productStructure;
    var tmp_2;
    if (tmp6_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inherit.<anonymous>' call
      tmp_2 = inheritProductStructure(this, tmp6_safe_receiver, parentComponents.productStructure);
    }
    var tmp7_elvis_lhs = tmp_2;
    var tmp43_productStructure = tmp7_elvis_lhs == null ? parentComponents.productStructure : tmp7_elvis_lhs;
    var tmp29_safe_receiver = this.meta;
    var tmp_3;
    if (tmp29_safe_receiver == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inherit.<anonymous>' call
      tmp_3 = inheritMeta(this, tmp29_safe_receiver, parentComponents.meta);
    }
    var tmp30_elvis_lhs = tmp_3;
    var tmp44_meta = tmp30_elvis_lhs == null ? parentComponents.meta : tmp30_elvis_lhs;
    var tmp17_safe_receiver = this.allowedDoorPairs;
    var tmp_4;
    if (tmp17_safe_receiver == null) {
      tmp_4 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inherit.<anonymous>' call
      tmp_4 = inheritAllowedDoorPairs(this, tmp17_safe_receiver, parentComponents.allowedDoorPairs);
    }
    var tmp18_elvis_lhs = tmp_4;
    var tmp45_allowedDoorPairs = tmp18_elvis_lhs == null ? parentComponents.allowedDoorPairs : tmp18_elvis_lhs;
    var tmp8_safe_receiver = this.functionalZones;
    var tmp_5;
    if (tmp8_safe_receiver == null) {
      tmp_5 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inherit.<anonymous>' call
      tmp_5 = inheritFunctionalZones(this, tmp8_safe_receiver, parentComponents.functionalZones);
    }
    var tmp9_elvis_lhs = tmp_5;
    var tmp46_functionalZones = tmp9_elvis_lhs == null ? parentComponents.functionalZones : tmp9_elvis_lhs;
    var tmp10_elvis_lhs = this.autoAdaptGroup;
    var tmp47_autoAdaptGroup = tmp10_elvis_lhs == null ? parentComponents.autoAdaptGroup : tmp10_elvis_lhs;
    var tmp11_elvis_lhs = this.product;
    var tmp48_product = tmp11_elvis_lhs == null ? parentComponents.product : tmp11_elvis_lhs;
    var tmp12_elvis_lhs = this.modelURI;
    var tmp49_modelURI = tmp12_elvis_lhs == null ? parentComponents.modelURI : tmp12_elvis_lhs;
    var tmp13_elvis_lhs = this.modelTransform;
    var tmp50_modelTransform = tmp13_elvis_lhs == null ? parentComponents.modelTransform : tmp13_elvis_lhs;
    var tmp14_elvis_lhs = this.selectable;
    var tmp51_selectable = tmp14_elvis_lhs == null ? parentComponents.selectable : tmp14_elvis_lhs;
    var tmp15_elvis_lhs = this.outlineable;
    var tmp52_outlineable = tmp15_elvis_lhs == null ? parentComponents.outlineable : tmp15_elvis_lhs;
    var tmp16_elvis_lhs = this.draggable;
    var tmp53_draggable = tmp16_elvis_lhs == null ? parentComponents.draggable : tmp16_elvis_lhs;
    var tmp19_elvis_lhs = this.autoAdaptHost;
    var tmp54_autoAdaptHost = tmp19_elvis_lhs == null ? parentComponents.autoAdaptHost : tmp19_elvis_lhs;
    var tmp20_elvis_lhs = this.door;
    var tmp55_door = tmp20_elvis_lhs == null ? parentComponents.door : tmp20_elvis_lhs;
    var tmp21_elvis_lhs = this.doorFront;
    var tmp56_doorFront = tmp21_elvis_lhs == null ? parentComponents.doorFront : tmp21_elvis_lhs;
    var tmp22_elvis_lhs = this.handle;
    var tmp57_handle = tmp22_elvis_lhs == null ? parentComponents.handle : tmp22_elvis_lhs;
    var tmp23_elvis_lhs = this.drawer;
    var tmp58_drawer = tmp23_elvis_lhs == null ? parentComponents.drawer : tmp23_elvis_lhs;
    var tmp24_elvis_lhs = this.frame;
    var tmp59_frame = tmp24_elvis_lhs == null ? parentComponents.frame : tmp24_elvis_lhs;
    var tmp25_elvis_lhs = this.leg;
    var tmp60_leg = tmp25_elvis_lhs == null ? parentComponents.leg : tmp25_elvis_lhs;
    var tmp26_elvis_lhs = this.innerLight;
    var tmp61_innerLight = tmp26_elvis_lhs == null ? parentComponents.innerLight : tmp26_elvis_lhs;
    var tmp27_elvis_lhs = this.outerLight;
    var tmp62_outerLight = tmp27_elvis_lhs == null ? parentComponents.outerLight : tmp27_elvis_lhs;
    var tmp28_elvis_lhs = this.outlined;
    var tmp63_outlined = tmp28_elvis_lhs == null ? parentComponents.outlined : tmp28_elvis_lhs;
    var tmp31_elvis_lhs = this.propping;
    var tmp64_propping = tmp31_elvis_lhs == null ? parentComponents.propping : tmp31_elvis_lhs;
    var tmp32_elvis_lhs = this.alwaysHangDown;
    var tmp65_alwaysHangDown = tmp32_elvis_lhs == null ? parentComponents.alwaysHangDown : tmp32_elvis_lhs;
    var tmp33_elvis_lhs = this.serializeEntity;
    var tmp66_serializeEntity = tmp33_elvis_lhs == null ? parentComponents.serializeEntity : tmp33_elvis_lhs;
    var tmp34_elvis_lhs = this.placementZoneByHeight;
    var tmp67_placementZoneByHeight = tmp34_elvis_lhs == null ? parentComponents.placementZoneByHeight : tmp34_elvis_lhs;
    var tmp35_elvis_lhs = this.functionalMargin;
    var tmp68_functionalMargin = tmp35_elvis_lhs == null ? parentComponents.functionalMargin : tmp35_elvis_lhs;
    var tmp36_elvis_lhs = this.recommendedInitialPositionFromFloor;
    var tmp69_recommendedInitialPositionFromFloor = tmp36_elvis_lhs == null ? parentComponents.recommendedInitialPositionFromFloor : tmp36_elvis_lhs;
    var tmp37_elvis_lhs = this.visualLightSource;
    var tmp70_visualLightSource = tmp37_elvis_lhs == null ? parentComponents.visualLightSource : tmp37_elvis_lhs;
    var tmp38_elvis_lhs = this.dragSurfaces;
    var tmp71_dragSurfaces = tmp38_elvis_lhs == null ? parentComponents.dragSurfaces : tmp38_elvis_lhs;
    var tmp39_elvis_lhs = this.dragProjectionPoint;
    var tmp72_dragProjectionPoint = tmp39_elvis_lhs == null ? parentComponents.dragProjectionPoint : tmp39_elvis_lhs;
    var tmp73_customComponents = inheritCustomComponents(this, parentComponents.customComponents);
    var item = new ItemComponentsDTO(tmp40_assembly, tmp41_colliders, tmp42_connectors, tmp43_productStructure, tmp46_functionalZones, tmp47_autoAdaptGroup, tmp48_product, tmp49_modelURI, tmp50_modelTransform, tmp51_selectable, tmp52_outlineable, tmp53_draggable, tmp45_allowedDoorPairs, tmp54_autoAdaptHost, tmp55_door, tmp56_doorFront, tmp57_handle, tmp58_drawer, tmp59_frame, tmp60_leg, tmp61_innerLight, tmp62_outerLight, tmp63_outlined, tmp44_meta, tmp64_propping, tmp65_alwaysHangDown, tmp66_serializeEntity, tmp67_placementZoneByHeight, tmp68_functionalMargin, tmp69_recommendedInitialPositionFromFloor, tmp70_visualLightSource, tmp71_dragSurfaces, tmp72_dragProjectionPoint, tmp73_customComponents);
    return item;
  };
  function Companion_4() {
    Companion_instance_5 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.v4c_1 = [null, new LinkedHashMapSerializer(StringSerializer_getInstance(), StringSerializer_getInstance()), new ReferenceArraySerializer(getKClass(Part), $serializer_getInstance_3())];
  }
  protoOf(Companion_4).l17 = function () {
    return $serializer_getInstance_8();
  };
  var Companion_instance_5;
  function Companion_getInstance_9() {
    if (Companion_instance_5 == null)
      new Companion_4();
    return Companion_instance_5;
  }
  function $serializer_2() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.ipex.range.dto.item.ItemParametersDTO', this, 3);
    tmp0_serialDesc.cv('size', true);
    tmp0_serialDesc.cv('labels', true);
    tmp0_serialDesc.cv('parts', true);
    this.w4c_1 = tmp0_serialDesc;
  }
  protoOf($serializer_2).ok = function () {
    return this.w4c_1;
  };
  protoOf($serializer_2).rv = function () {
    var tmp0_cached = Companion_getInstance_9().v4c_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable($serializer_getInstance_4()), get_nullable(tmp0_cached[1]), get_nullable(tmp0_cached[2])];
  };
  protoOf($serializer_2).qk = function (decoder) {
    var tmp0_desc = this.w4c_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.nn(tmp0_desc);
    var tmp8_cached = Companion_getInstance_9().v4c_1;
    if (tmp7_input.do()) {
      tmp4_local0 = tmp7_input.bo(tmp0_desc, 0, $serializer_getInstance_4(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.bo(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.bo(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.bo(tmp0_desc, 0, $serializer_getInstance_4(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.bo(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.bo(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.on(tmp0_desc);
    return ItemParametersDTO_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_2).x4c = function (encoder, value) {
    var tmp0_desc = this.w4c_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    var tmp2_cached = Companion_getInstance_9().v4c_1;
    if (tmp1_output.kp(tmp0_desc, 0) ? true : !(value.size == null)) {
      tmp1_output.gp(tmp0_desc, 0, $serializer_getInstance_4(), value.size);
    }
    if (tmp1_output.kp(tmp0_desc, 1) ? true : !(value.labels == null)) {
      tmp1_output.gp(tmp0_desc, 1, tmp2_cached[1], value.labels);
    }
    if (tmp1_output.kp(tmp0_desc, 2) ? true : !(value.parts == null)) {
      tmp1_output.gp(tmp0_desc, 2, tmp2_cached[2], value.parts);
    }
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_2).pk = function (encoder, value) {
    return this.x4c(encoder, value instanceof ItemParametersDTO ? value : THROW_CCE());
  };
  var $serializer_instance_2;
  function $serializer_getInstance_8() {
    if ($serializer_instance_2 == null)
      new $serializer_2();
    return $serializer_instance_2;
  }
  function ItemParametersDTO_init_$Init$(seen1, size, labels, parts, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen1))) {
      throwMissingFieldException(seen1, 0, $serializer_getInstance_8().w4c_1);
    }
    if (0 === (seen1 & 1))
      $this.size = null;
    else
      $this.size = size;
    if (0 === (seen1 & 2))
      $this.labels = null;
    else
      $this.labels = labels;
    if (0 === (seen1 & 4))
      $this.parts = null;
    else
      $this.parts = parts;
    return $this;
  }
  function ItemParametersDTO_init_$Create$(seen1, size, labels, parts, serializationConstructorMarker) {
    return ItemParametersDTO_init_$Init$(seen1, size, labels, parts, serializationConstructorMarker, objectCreate(protoOf(ItemParametersDTO)));
  }
  function ItemParametersDTO(size, labels, parts) {
    Companion_getInstance_9();
    size = size === VOID ? null : size;
    labels = labels === VOID ? null : labels;
    parts = parts === VOID ? null : parts;
    this.size = size;
    this.labels = labels;
    this.parts = parts;
  }
  protoOf(ItemParametersDTO).n = function () {
    return this.size;
  };
  protoOf(ItemParametersDTO).y4c = function () {
    return this.labels;
  };
  protoOf(ItemParametersDTO).w1k = function () {
    return this.parts;
  };
  protoOf(ItemParametersDTO).inherit = function (parentParameters) {
    var tmp0_safe_receiver = parentParameters.parts;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.associate' call
      var capacity = coerceAtLeast(mapCapacity(tmp0_safe_receiver.length), 16);
      // Inline function 'kotlin.collections.associateTo' call
      var destination = LinkedHashMap_init_$Create$_0(capacity);
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp0_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.plusAssign' call
        // Inline function 'com.ikea.range.ipex.range.dto.item.ItemParametersDTO.inherit.<anonymous>' call
        var pair = new Pair(element.partKey, element);
        destination.r2(pair.ye_1, pair.ze_1);
      }
      tmp = destination;
    }
    var tmp1_elvis_lhs = tmp;
    var parentParts = tmp1_elvis_lhs == null ? emptyMap() : tmp1_elvis_lhs;
    var tmp2_safe_receiver = this.parts;
    var tmp_0;
    if (tmp2_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.associate' call
      var capacity_0 = coerceAtLeast(mapCapacity(tmp2_safe_receiver.length), 16);
      // Inline function 'kotlin.collections.associateTo' call
      var destination_0 = LinkedHashMap_init_$Create$_0(capacity_0);
      var inductionVariable_0 = 0;
      var last_0 = tmp2_safe_receiver.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = tmp2_safe_receiver[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'kotlin.collections.plusAssign' call
        // Inline function 'com.ikea.range.ipex.range.dto.item.ItemParametersDTO.inherit.<anonymous>' call
        var pair_0 = new Pair(element_0.partKey, element_0);
        destination_0.r2(pair_0.ye_1, pair_0.ze_1);
      }
      tmp_0 = destination_0;
    }
    var tmp3_elvis_lhs = tmp_0;
    var parts = tmp3_elvis_lhs == null ? emptyMap() : tmp3_elvis_lhs;
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = plus_1(parentParts, parts);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList_init_$Create$_0(this_0.n());
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = this_0.q2().t();
    while (tmp0_iterator.u()) {
      var item = tmp0_iterator.w();
      // Inline function 'com.ikea.range.ipex.range.dto.item.ItemParametersDTO.inherit.<anonymous>' call
      var tmp$ret$7 = item.u2();
      destination_1.q(tmp$ret$7);
    }
    var newParts = copyToArray(destination_1);
    var tmp4_elvis_lhs = this.size;
    var tmp_1 = tmp4_elvis_lhs == null ? parentParameters.size : tmp4_elvis_lhs;
    var tmp6_elvis_lhs = parentParameters.labels;
    var tmp_2 = tmp6_elvis_lhs == null ? emptyMap() : tmp6_elvis_lhs;
    var tmp5_elvis_lhs = this.labels;
    return new ItemParametersDTO(tmp_1, plus_1(tmp_2, tmp5_elvis_lhs == null ? emptyMap() : tmp5_elvis_lhs), newParts);
  };
  function Companion_5() {
    Companion_instance_6 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.r4b_1 = [null, null, new ReferenceArraySerializer(PrimitiveClasses_getInstance().u7(), StringSerializer_getInstance()), null, null];
  }
  protoOf(Companion_5).l17 = function () {
    return $serializer_getInstance_9();
  };
  var Companion_instance_6;
  function Companion_getInstance_10() {
    if (Companion_instance_6 == null)
      new Companion_5();
    return Companion_instance_6;
  }
  function $serializer_3() {
    $serializer_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.ipex.range.dto.item.RangeItemDTO', this, 5);
    tmp0_serialDesc.cv('id', true);
    tmp0_serialDesc.cv('description', true);
    tmp0_serialDesc.cv('inherits', true);
    tmp0_serialDesc.cv('parameters', true);
    tmp0_serialDesc.cv('components', true);
    this.z4c_1 = tmp0_serialDesc;
  }
  protoOf($serializer_3).ok = function () {
    return this.z4c_1;
  };
  protoOf($serializer_3).rv = function () {
    var tmp0_cached = Companion_getInstance_10().r4b_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(tmp0_cached[2]), get_nullable($serializer_getInstance_8()), get_nullable($serializer_getInstance_7())];
  };
  protoOf($serializer_3).qk = function (decoder) {
    var tmp0_desc = this.z4c_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.nn(tmp0_desc);
    var tmp10_cached = Companion_getInstance_10().r4b_1;
    if (tmp9_input.do()) {
      tmp4_local0 = tmp9_input.xn(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.xn(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.bo(tmp0_desc, 2, tmp10_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.bo(tmp0_desc, 3, $serializer_getInstance_8(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.bo(tmp0_desc, 4, $serializer_getInstance_7(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.xn(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.xn(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.bo(tmp0_desc, 2, tmp10_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.bo(tmp0_desc, 3, $serializer_getInstance_8(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.bo(tmp0_desc, 4, $serializer_getInstance_7(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.on(tmp0_desc);
    return RangeItemDTO_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_3).a4d = function (encoder, value) {
    var tmp0_desc = this.z4c_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    var tmp2_cached = Companion_getInstance_10().r4b_1;
    if (tmp1_output.kp(tmp0_desc, 0) ? true : !(value.id === '')) {
      tmp1_output.cp(tmp0_desc, 0, value.id);
    }
    if (tmp1_output.kp(tmp0_desc, 1) ? true : !(value.description === '')) {
      tmp1_output.cp(tmp0_desc, 1, value.description);
    }
    if (tmp1_output.kp(tmp0_desc, 2) ? true : !(value.inherits == null)) {
      tmp1_output.gp(tmp0_desc, 2, tmp2_cached[2], value.inherits);
    }
    if (tmp1_output.kp(tmp0_desc, 3) ? true : !(value.parameters == null)) {
      tmp1_output.gp(tmp0_desc, 3, $serializer_getInstance_8(), value.parameters);
    }
    if (tmp1_output.kp(tmp0_desc, 4) ? true : !(value.components == null)) {
      tmp1_output.gp(tmp0_desc, 4, $serializer_getInstance_7(), value.components);
    }
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_3).pk = function (encoder, value) {
    return this.a4d(encoder, value instanceof RangeItemDTO ? value : THROW_CCE());
  };
  var $serializer_instance_3;
  function $serializer_getInstance_9() {
    if ($serializer_instance_3 == null)
      new $serializer_3();
    return $serializer_instance_3;
  }
  function RangeItemDTO_init_$Init$(seen1, id, description, inherits, parameters, components, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen1))) {
      throwMissingFieldException(seen1, 0, $serializer_getInstance_9().z4c_1);
    }
    if (0 === (seen1 & 1))
      $this.id = '';
    else
      $this.id = id;
    if (0 === (seen1 & 2))
      $this.description = '';
    else
      $this.description = description;
    if (0 === (seen1 & 4))
      $this.inherits = null;
    else
      $this.inherits = inherits;
    if (0 === (seen1 & 8))
      $this.parameters = null;
    else
      $this.parameters = parameters;
    if (0 === (seen1 & 16))
      $this.components = null;
    else
      $this.components = components;
    return $this;
  }
  function RangeItemDTO_init_$Create$(seen1, id, description, inherits, parameters, components, serializationConstructorMarker) {
    return RangeItemDTO_init_$Init$(seen1, id, description, inherits, parameters, components, serializationConstructorMarker, objectCreate(protoOf(RangeItemDTO)));
  }
  function RangeItemDTO(id, description, inherits, parameters, components) {
    Companion_getInstance_10();
    id = id === VOID ? '' : id;
    description = description === VOID ? '' : description;
    inherits = inherits === VOID ? null : inherits;
    parameters = parameters === VOID ? null : parameters;
    components = components === VOID ? null : components;
    this.id = id;
    this.description = description;
    this.inherits = inherits;
    this.parameters = parameters;
    this.components = components;
  }
  protoOf(RangeItemDTO).s1k = function () {
    return this.id;
  };
  protoOf(RangeItemDTO).u40 = function () {
    return this.description;
  };
  protoOf(RangeItemDTO).p3z = function () {
    return this.inherits;
  };
  protoOf(RangeItemDTO).b4d = function () {
    return this.parameters;
  };
  protoOf(RangeItemDTO).j1m = function () {
    return this.components;
  };
  protoOf(RangeItemDTO).inherit = function (parentItem) {
    var tmp0_safe_receiver = parentItem.components;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.dto.item.RangeItemDTO.inherit.<anonymous>' call
      var tmp0_safe_receiver_0 = this.components;
      var tmp1_elvis_lhs = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.inherit(tmp0_safe_receiver);
      tmp = tmp1_elvis_lhs == null ? (new ItemComponentsDTO()).inherit(tmp0_safe_receiver) : tmp1_elvis_lhs;
    }
    var tmp1_elvis_lhs_0 = tmp;
    var newComponents = tmp1_elvis_lhs_0 == null ? this.components : tmp1_elvis_lhs_0;
    var tmp2_safe_receiver = parentItem.parameters;
    var tmp_0;
    if (tmp2_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.dto.item.RangeItemDTO.inherit.<anonymous>' call
      var tmp0_safe_receiver_1 = this.parameters;
      var tmp1_elvis_lhs_1 = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.inherit(tmp2_safe_receiver);
      tmp_0 = tmp1_elvis_lhs_1 == null ? (new ItemParametersDTO()).inherit(tmp2_safe_receiver) : tmp1_elvis_lhs_1;
    }
    var tmp3_elvis_lhs = tmp_0;
    var newParameters = tmp3_elvis_lhs == null ? this.parameters : tmp3_elvis_lhs;
    return new RangeItemDTO(this.id, this.description, this.inherits, newParameters, newComponents);
  };
  function ItemParser$Companion$jsonParser$lambda($this$Json) {
    $this$Json.f16_1 = true;
    $this$Json.e16_1 = true;
    return Unit_instance;
  }
  function parseCustomComponents($this, item, itemJsonElement, parsers) {
    if (!(parsers == null)) {
      var knownComponentKeys = get_elementNames(Companion_getInstance_8().l17().ok());
      // Inline function 'kotlin.collections.find' call
      var this_0 = get_jsonObject(itemJsonElement).q2();
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var tmp0_iterator = this_0.t();
        while (tmp0_iterator.u()) {
          var element = tmp0_iterator.w();
          // Inline function 'com.ikea.range.ipex.range.parser.ItemParser.parseCustomComponents.<anonymous>' call
          if (element.t2() === 'components') {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      var componentEntries = tmp$ret$1;
      if (componentEntries == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.collections.associate' call
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var this_1 = get_jsonObject(componentEntries.u2()).q2();
        var destination = ArrayList_init_$Create$();
        var tmp0_iterator_0 = this_1.t();
        while (tmp0_iterator_0.u()) {
          var element_0 = tmp0_iterator_0.w();
          // Inline function 'com.ikea.range.ipex.range.parser.ItemParser.parseCustomComponents.<anonymous>.<anonymous>' call
          if (!contains_0(knownComponentKeys, element_0.t2())) {
            destination.q(element_0);
          }
        }
        var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(destination, 10)), 16);
        // Inline function 'kotlin.collections.associateTo' call
        var destination_0 = LinkedHashMap_init_$Create$_0(capacity);
        var tmp0_iterator_1 = destination.t();
        while (tmp0_iterator_1.u()) {
          var element_1 = tmp0_iterator_1.w();
          // Inline function 'kotlin.collections.plusAssign' call
          // Inline function 'com.ikea.range.ipex.range.parser.ItemParser.parseCustomComponents.<anonymous>.<anonymous>' call
          var pair = to(element_1.t2(), element_1.u2());
          destination_0.r2(pair.ye_1, pair.ze_1);
        }
        var rawCustomComponents = destination_0;
        // Inline function 'kotlin.collections.mapNotNull' call
        // Inline function 'kotlin.collections.mapNotNullTo' call
        var destination_1 = ArrayList_init_$Create$();
        // Inline function 'kotlin.collections.forEach' call
        // Inline function 'kotlin.collections.iterator' call
        var tmp0_iterator_2 = rawCustomComponents.q2().t();
        while (tmp0_iterator_2.u()) {
          var element_2 = tmp0_iterator_2.w();
          // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
          var tmp$ret$14;
          $l$block_1: {
            // Inline function 'com.ikea.range.ipex.range.parser.ItemParser.parseCustomComponents.<anonymous>.<anonymous>' call
            // Inline function 'kotlin.collections.component1' call
            var key = element_2.t2();
            // Inline function 'kotlin.collections.component2' call
            var value = element_2.u2();
            var tmp$ret$13;
            $l$block_0: {
              // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
              var tmp0_iterator_3 = parsers.t();
              while (tmp0_iterator_3.u()) {
                var element_3 = tmp0_iterator_3.w();
                // Inline function 'com.ikea.range.ipex.range.parser.ItemParser.parseCustomComponents.<anonymous>.<anonymous>.<anonymous>' call
                var result = element_3.parse(key, toString(value));
                if (!(result == null)) {
                  tmp$ret$13 = result;
                  break $l$block_0;
                }
              }
              tmp$ret$13 = null;
            }
            var tmp0_elvis_lhs = tmp$ret$13;
            var tmp;
            if (tmp0_elvis_lhs == null) {
              tmp$ret$14 = null;
              break $l$block_1;
            } else {
              tmp = tmp0_elvis_lhs;
            }
            var builder = tmp;
            tmp$ret$14 = to(key, builder);
          }
          var tmp0_safe_receiver = tmp$ret$14;
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            destination_1.q(tmp0_safe_receiver);
          }
        }
        var customComponents = toMap(destination_1);
        var tmp0_safe_receiver_0 = item.components;
        var tmp_0;
        if (tmp0_safe_receiver_0 == null) {
          tmp_0 = Unit_instance;
        } else {
          tmp0_safe_receiver_0.customComponents = customComponents;
          tmp_0 = Unit_instance;
        }
      }
    }
  }
  function Companion_6() {
    Companion_instance_7 = this;
    var tmp = this;
    tmp.jsonParser = Json(VOID, ItemParser$Companion$jsonParser$lambda);
  }
  protoOf(Companion_6).q3y = function () {
    return this.jsonParser;
  };
  var Companion_instance_7;
  function Companion_getInstance_11() {
    if (Companion_instance_7 == null)
      new Companion_6();
    return Companion_instance_7;
  }
  function ItemParser() {
    Companion_getInstance_11();
  }
  protoOf(ItemParser).c4d = function (itemJson, parsers) {
    var item = Companion_getInstance_11().jsonParser.j15(Companion_getInstance_10().l17(), itemJson);
    parseCustomComponents(this, item, Companion_getInstance_11().jsonParser.m15(itemJson), parsers);
    return item;
  };
  protoOf(ItemParser).parseItem = function (itemJson, parsers, $super) {
    parsers = parsers === VOID ? null : parsers;
    return this.c4d(itemJson, parsers);
  };
  protoOf(ItemParser).d4d = function (itemsJson, parsers) {
    try {
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.map' call
      var this_0 = get_jsonArray(Companion_getInstance_11().jsonParser.m15(itemsJson));
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.t();
      while (tmp0_iterator.u()) {
        var item = tmp0_iterator.w();
        // Inline function 'com.ikea.range.ipex.range.parser.ItemParser.parseItems.<anonymous>' call
        var item_0 = Companion_getInstance_11().jsonParser.j15(Companion_getInstance_10().l17(), toString(item));
        parseCustomComponents(this, item_0, item, parsers);
        destination.q(item_0);
      }
      return copyToArray(destination);
    } catch ($p) {
      if ($p instanceof Error_0) {
        var e = $p;
        // Inline function 'kotlin.error' call
        var message = toString_1(e.message);
        throw IllegalStateException_init_$Create$(toString(message));
      } else {
        throw $p;
      }
    }
  };
  protoOf(ItemParser).parseItems = function (itemsJson, parsers, $super) {
    parsers = parsers === VOID ? null : parsers;
    return this.d4d(itemsJson, parsers);
  };
  //region block: post-declaration
  protoOf(IPEXRangeFormatCatalog).createCustomAssembly = createCustomAssembly;
  protoOf(IPEXRangeFormatCatalog).createCustomAssemblySpecification = createCustomAssemblySpecification;
  defineProp(protoOf(IPEXRangeFormatCatalog), 'thisClassIsGuaranteedToNotModifyOrQueryCoreState', function () {
    return this.a1m();
  });
  protoOf($serializer).sv = typeParametersSerializers;
  protoOf($serializer_0).sv = typeParametersSerializers;
  protoOf($serializer_1).sv = typeParametersSerializers;
  protoOf($serializer_2).sv = typeParametersSerializers;
  protoOf($serializer_3).sv = typeParametersSerializers;
  //endregion
  //region block: init
  Companion_instance_3 = new Companion_2();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$ipex = $com$ikea$range.ipex || ($com$ikea$range.ipex = {});
    var $com$ikea$range$ipex$range = $com$ikea$range$ipex.range || ($com$ikea$range$ipex.range = {});
    var $com$ikea$range$ipex$range$builder = $com$ikea$range$ipex$range.builder || ($com$ikea$range$ipex$range.builder = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$ipex = $com$ikea$range.ipex || ($com$ikea$range.ipex = {});
    var $com$ikea$range$ipex$range = $com$ikea$range$ipex.range || ($com$ikea$range$ipex.range = {});
    var $com$ikea$range$ipex$range$builder = $com$ikea$range$ipex$range.builder || ($com$ikea$range$ipex$range.builder = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$ipex = $com$ikea$range.ipex || ($com$ikea$range.ipex = {});
    var $com$ikea$range$ipex$range = $com$ikea$range$ipex.range || ($com$ikea$range$ipex.range = {});
    var $com$ikea$range$ipex$range$builder = $com$ikea$range$ipex$range.builder || ($com$ikea$range$ipex$range.builder = {});
    $com$ikea$range$ipex$range$builder.ComponentsCommonData = ComponentsCommonData;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$ipex = $com$ikea$range.ipex || ($com$ikea$range.ipex = {});
    var $com$ikea$range$ipex$range = $com$ikea$range$ipex.range || ($com$ikea$range$ipex.range = {});
    var $com$ikea$range$ipex$range$builder = $com$ikea$range$ipex$range.builder || ($com$ikea$range$ipex$range.builder = {});
    $com$ikea$range$ipex$range$builder.ProductSpecificationBuilder = ProductSpecificationBuilder;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$ipex = $com$ikea$range.ipex || ($com$ikea$range.ipex = {});
    var $com$ikea$range$ipex$range = $com$ikea$range$ipex.range || ($com$ikea$range$ipex.range = {});
    var $com$ikea$range$ipex$range$builder = $com$ikea$range$ipex$range.builder || ($com$ikea$range$ipex$range.builder = {});
    var $com$ikea$range$ipex$range$builder$component = $com$ikea$range$ipex$range$builder.component || ($com$ikea$range$ipex$range$builder.component = {});
    $com$ikea$range$ipex$range$builder$component.AllowedDoorPairsComponentBuilder = AllowedDoorPairsComponentBuilder;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$ipex = $com$ikea$range.ipex || ($com$ikea$range.ipex = {});
    var $com$ikea$range$ipex$range = $com$ikea$range$ipex.range || ($com$ikea$range$ipex.range = {});
    var $com$ikea$range$ipex$range$builder = $com$ikea$range$ipex$range.builder || ($com$ikea$range$ipex$range.builder = {});
    var $com$ikea$range$ipex$range$builder$component = $com$ikea$range$ipex$range$builder.component || ($com$ikea$range$ipex$range$builder.component = {});
    $com$ikea$range$ipex$range$builder$component.AssemblyComponentsBuilder = AssemblyComponentsBuilder;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$ipex = $com$ikea$range.ipex || ($com$ikea$range.ipex = {});
    var $com$ikea$range$ipex$range = $com$ikea$range$ipex.range || ($com$ikea$range$ipex.range = {});
    var $com$ikea$range$ipex$range$builder = $com$ikea$range$ipex$range.builder || ($com$ikea$range$ipex$range.builder = {});
    var $com$ikea$range$ipex$range$builder$component = $com$ikea$range$ipex$range$builder.component || ($com$ikea$range$ipex$range$builder.component = {});
    $com$ikea$range$ipex$range$builder$component.AutoAdaptGuestComponentBuilder = AutoAdaptGuestComponentBuilder;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$ipex = $com$ikea$range.ipex || ($com$ikea$range.ipex = {});
    var $com$ikea$range$ipex$range = $com$ikea$range$ipex.range || ($com$ikea$range$ipex.range = {});
    var $com$ikea$range$ipex$range$builder = $com$ikea$range$ipex$range.builder || ($com$ikea$range$ipex$range.builder = {});
    var $com$ikea$range$ipex$range$builder$component = $com$ikea$range$ipex$range$builder.component || ($com$ikea$range$ipex$range$builder.component = {});
    $com$ikea$range$ipex$range$builder$component.AutoAdaptHostComponentBuilder = AutoAdaptHostComponentBuilder;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$ipex = $com$ikea$range.ipex || ($com$ikea$range.ipex = {});
    var $com$ikea$range$ipex$range = $com$ikea$range$ipex.range || ($com$ikea$range$ipex.range = {});
    var $com$ikea$range$ipex$range$builder = $com$ikea$range$ipex$range.builder || ($com$ikea$range$ipex$range.builder = {});
    var $com$ikea$range$ipex$range$builder$component = $com$ikea$range$ipex$range$builder.component || ($com$ikea$range$ipex$range$builder.component = {});
    $com$ikea$range$ipex$range$builder$component.BooleanComponentBuilder = BooleanComponentBuilder;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$ipex = $com$ikea$range.ipex || ($com$ikea$range.ipex = {});
    var $com$ikea$range$ipex$range = $com$ikea$range$ipex.range || ($com$ikea$range$ipex.range = {});
    var $com$ikea$range$ipex$range$builder = $com$ikea$range$ipex$range.builder || ($com$ikea$range$ipex$range.builder = {});
    var $com$ikea$range$ipex$range$builder$component = $com$ikea$range$ipex$range$builder.component || ($com$ikea$range$ipex$range$builder.component = {});
    $com$ikea$range$ipex$range$builder$component.ColliderShapeComponentBuilder = ColliderShapeComponentBuilder;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$ipex = $com$ikea$range.ipex || ($com$ikea$range.ipex = {});
    var $com$ikea$range$ipex$range = $com$ikea$range$ipex.range || ($com$ikea$range$ipex.range = {});
    var $com$ikea$range$ipex$range$builder = $com$ikea$range$ipex$range.builder || ($com$ikea$range$ipex$range.builder = {});
    var $com$ikea$range$ipex$range$builder$component = $com$ikea$range$ipex$range$builder.component || ($com$ikea$range$ipex$range$builder.component = {});
    $com$ikea$range$ipex$range$builder$component.ConnectorsComponentBuilder = ConnectorsComponentBuilder;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$ipex = $com$ikea$range.ipex || ($com$ikea$range.ipex = {});
    var $com$ikea$range$ipex$range = $com$ikea$range$ipex.range || ($com$ikea$range$ipex.range = {});
    var $com$ikea$range$ipex$range$builder = $com$ikea$range$ipex$range.builder || ($com$ikea$range$ipex$range.builder = {});
    var $com$ikea$range$ipex$range$builder$component = $com$ikea$range$ipex$range$builder.component || ($com$ikea$range$ipex$range$builder.component = {});
    $com$ikea$range$ipex$range$builder$component.DragProjectionPointComponentBuilder = DragProjectionPointComponentBuilder;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$ipex = $com$ikea$range.ipex || ($com$ikea$range.ipex = {});
    var $com$ikea$range$ipex$range = $com$ikea$range$ipex.range || ($com$ikea$range$ipex.range = {});
    var $com$ikea$range$ipex$range$builder = $com$ikea$range$ipex$range.builder || ($com$ikea$range$ipex$range.builder = {});
    var $com$ikea$range$ipex$range$builder$component = $com$ikea$range$ipex$range$builder.component || ($com$ikea$range$ipex$range$builder.component = {});
    $com$ikea$range$ipex$range$builder$component.DragSurfacesComponentBuilder = DragSurfacesComponentBuilder;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$ipex = $com$ikea$range.ipex || ($com$ikea$range.ipex = {});
    var $com$ikea$range$ipex$range = $com$ikea$range$ipex.range || ($com$ikea$range$ipex.range = {});
    var $com$ikea$range$ipex$range$builder = $com$ikea$range$ipex$range.builder || ($com$ikea$range$ipex$range.builder = {});
    var $com$ikea$range$ipex$range$builder$component = $com$ikea$range$ipex$range$builder.component || ($com$ikea$range$ipex$range$builder.component = {});
    $com$ikea$range$ipex$range$builder$component.FunctionalMarginShapeComponentBuilder = FunctionalMarginShapeComponentBuilder;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$ipex = $com$ikea$range.ipex || ($com$ikea$range.ipex = {});
    var $com$ikea$range$ipex$range = $com$ikea$range$ipex.range || ($com$ikea$range$ipex.range = {});
    var $com$ikea$range$ipex$range$builder = $com$ikea$range$ipex$range.builder || ($com$ikea$range$ipex$range.builder = {});
    var $com$ikea$range$ipex$range$builder$component = $com$ikea$range$ipex$range$builder.component || ($com$ikea$range$ipex$range$builder.component = {});
    $com$ikea$range$ipex$range$builder$component.FunctionalZonesLocalComponentBuilder = FunctionalZonesLocalComponentBuilder;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$ipex = $com$ikea$range.ipex || ($com$ikea$range.ipex = {});
    var $com$ikea$range$ipex$range = $com$ikea$range$ipex.range || ($com$ikea$range$ipex.range = {});
    var $com$ikea$range$ipex$range$builder = $com$ikea$range$ipex$range.builder || ($com$ikea$range$ipex$range.builder = {});
    var $com$ikea$range$ipex$range$builder$component = $com$ikea$range$ipex$range$builder.component || ($com$ikea$range$ipex$range$builder.component = {});
    $com$ikea$range$ipex$range$builder$component.LightComponentBuilder = LightComponentBuilder;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$ipex = $com$ikea$range.ipex || ($com$ikea$range.ipex = {});
    var $com$ikea$range$ipex$range = $com$ikea$range$ipex.range || ($com$ikea$range$ipex.range = {});
    var $com$ikea$range$ipex$range$builder = $com$ikea$range$ipex$range.builder || ($com$ikea$range$ipex$range.builder = {});
    var $com$ikea$range$ipex$range$builder$component = $com$ikea$range$ipex$range$builder.component || ($com$ikea$range$ipex$range$builder.component = {});
    $com$ikea$range$ipex$range$builder$component.MetaDataComponentBuilder = MetaDataComponentBuilder;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$ipex = $com$ikea$range.ipex || ($com$ikea$range.ipex = {});
    var $com$ikea$range$ipex$range = $com$ikea$range$ipex.range || ($com$ikea$range$ipex.range = {});
    var $com$ikea$range$ipex$range$builder = $com$ikea$range$ipex$range.builder || ($com$ikea$range$ipex$range.builder = {});
    var $com$ikea$range$ipex$range$builder$component = $com$ikea$range$ipex$range$builder.component || ($com$ikea$range$ipex$range$builder.component = {});
    $com$ikea$range$ipex$range$builder$component.ModelInfoComponentBuilder = ModelInfoComponentBuilder;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$ipex = $com$ikea$range.ipex || ($com$ikea$range.ipex = {});
    var $com$ikea$range$ipex$range = $com$ikea$range$ipex.range || ($com$ikea$range$ipex.range = {});
    var $com$ikea$range$ipex$range$builder = $com$ikea$range$ipex$range.builder || ($com$ikea$range$ipex$range.builder = {});
    var $com$ikea$range$ipex$range$builder$component = $com$ikea$range$ipex$range$builder.component || ($com$ikea$range$ipex$range$builder.component = {});
    $com$ikea$range$ipex$range$builder$component.ModelTransformComponentBuilder = ModelTransformComponentBuilder;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$ipex = $com$ikea$range.ipex || ($com$ikea$range.ipex = {});
    var $com$ikea$range$ipex$range = $com$ikea$range$ipex.range || ($com$ikea$range$ipex.range = {});
    var $com$ikea$range$ipex$range$builder = $com$ikea$range$ipex$range.builder || ($com$ikea$range$ipex$range.builder = {});
    var $com$ikea$range$ipex$range$builder$component = $com$ikea$range$ipex$range$builder.component || ($com$ikea$range$ipex$range$builder.component = {});
    $com$ikea$range$ipex$range$builder$component.PlacementZoneByHeightComponentBuilder = PlacementZoneByHeightComponentBuilder;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$ipex = $com$ikea$range.ipex || ($com$ikea$range.ipex = {});
    var $com$ikea$range$ipex$range = $com$ikea$range$ipex.range || ($com$ikea$range$ipex.range = {});
    var $com$ikea$range$ipex$range$builder = $com$ikea$range$ipex$range.builder || ($com$ikea$range$ipex$range.builder = {});
    var $com$ikea$range$ipex$range$builder$component = $com$ikea$range$ipex$range$builder.component || ($com$ikea$range$ipex$range$builder.component = {});
    $com$ikea$range$ipex$range$builder$component.ProductStructureComponentBuilder = ProductStructureComponentBuilder;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$ipex = $com$ikea$range.ipex || ($com$ikea$range.ipex = {});
    var $com$ikea$range$ipex$range = $com$ikea$range$ipex.range || ($com$ikea$range$ipex.range = {});
    var $com$ikea$range$ipex$range$builder = $com$ikea$range$ipex$range.builder || ($com$ikea$range$ipex$range.builder = {});
    var $com$ikea$range$ipex$range$builder$component = $com$ikea$range$ipex$range$builder.component || ($com$ikea$range$ipex$range$builder.component = {});
    $com$ikea$range$ipex$range$builder$component.ProppingComponentBuilder = ProppingComponentBuilder;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$ipex = $com$ikea$range.ipex || ($com$ikea$range.ipex = {});
    var $com$ikea$range$ipex$range = $com$ikea$range$ipex.range || ($com$ikea$range$ipex.range = {});
    var $com$ikea$range$ipex$range$builder = $com$ikea$range$ipex$range.builder || ($com$ikea$range$ipex$range.builder = {});
    var $com$ikea$range$ipex$range$builder$component = $com$ikea$range$ipex$range$builder.component || ($com$ikea$range$ipex$range$builder.component = {});
    $com$ikea$range$ipex$range$builder$component.RecommendedInitialPositionFromFloorComponentBuilder = RecommendedInitialPositionFromFloorComponentBuilder;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$ipex = $com$ikea$range.ipex || ($com$ikea$range.ipex = {});
    var $com$ikea$range$ipex$range = $com$ikea$range$ipex.range || ($com$ikea$range$ipex.range = {});
    var $com$ikea$range$ipex$range$builder = $com$ikea$range$ipex$range.builder || ($com$ikea$range$ipex$range.builder = {});
    var $com$ikea$range$ipex$range$builder$component = $com$ikea$range$ipex$range$builder.component || ($com$ikea$range$ipex$range$builder.component = {});
    $com$ikea$range$ipex$range$builder$component.RelativeConnectorsComponentBuilder = RelativeConnectorsComponentBuilder;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$ipex = $com$ikea$range.ipex || ($com$ikea$range.ipex = {});
    var $com$ikea$range$ipex$range = $com$ikea$range$ipex.range || ($com$ikea$range$ipex.range = {});
    var $com$ikea$range$ipex$range$builder = $com$ikea$range$ipex$range.builder || ($com$ikea$range$ipex$range.builder = {});
    var $com$ikea$range$ipex$range$builder$component = $com$ikea$range$ipex$range$builder.component || ($com$ikea$range$ipex$range$builder.component = {});
    $com$ikea$range$ipex$range$builder$component.RequiredComponentsBuilder = RequiredComponentsBuilder;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$ipex = $com$ikea$range.ipex || ($com$ikea$range.ipex = {});
    var $com$ikea$range$ipex$range = $com$ikea$range$ipex.range || ($com$ikea$range$ipex.range = {});
    var $com$ikea$range$ipex$range$builder = $com$ikea$range$ipex$range.builder || ($com$ikea$range$ipex$range.builder = {});
    var $com$ikea$range$ipex$range$builder$component = $com$ikea$range$ipex$range$builder.component || ($com$ikea$range$ipex$range$builder.component = {});
    $com$ikea$range$ipex$range$builder$component.VisualLightSourceComponentBuilder = VisualLightSourceComponentBuilder;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$ipex = $com$ikea$range.ipex || ($com$ikea$range.ipex = {});
    var $com$ikea$range$ipex$range = $com$ikea$range$ipex.range || ($com$ikea$range$ipex.range = {});
    var $com$ikea$range$ipex$range$catalog = $com$ikea$range$ipex$range.catalog || ($com$ikea$range$ipex$range.catalog = {});
    $com$ikea$range$ipex$range$catalog.AmendableCatalog = AmendableCatalog;
    defineProp($com$ikea$range$ipex$range$catalog.AmendableCatalog, 'Companion', Companion_getInstance_4);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$ipex = $com$ikea$range.ipex || ($com$ikea$range.ipex = {});
    var $com$ikea$range$ipex$range = $com$ikea$range$ipex.range || ($com$ikea$range$ipex.range = {});
    var $com$ikea$range$ipex$range$catalog = $com$ikea$range$ipex$range.catalog || ($com$ikea$range$ipex$range.catalog = {});
    $com$ikea$range$ipex$range$catalog.IPEXRangeFormatCatalog = IPEXRangeFormatCatalog;
    defineProp($com$ikea$range$ipex$range$catalog.IPEXRangeFormatCatalog, 'Companion', Companion_getInstance_5);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$ipex = $com$ikea$range.ipex || ($com$ikea$range.ipex = {});
    var $com$ikea$range$ipex$range = $com$ikea$range$ipex.range || ($com$ikea$range$ipex.range = {});
    var $com$ikea$range$ipex$range$catalog = $com$ikea$range$ipex$range.catalog || ($com$ikea$range$ipex$range.catalog = {});
    $com$ikea$range$ipex$range$catalog.InheritanceResolver = InheritanceResolver;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$ipex = $com$ikea$range.ipex || ($com$ikea$range.ipex = {});
    var $com$ikea$range$ipex$range = $com$ikea$range$ipex.range || ($com$ikea$range$ipex.range = {});
    var $com$ikea$range$ipex$range$catalog = $com$ikea$range$ipex$range.catalog || ($com$ikea$range$ipex$range.catalog = {});
    $com$ikea$range$ipex$range$catalog.ItemRepository = ItemRepository;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$ipex = $com$ikea$range.ipex || ($com$ikea$range.ipex = {});
    var $com$ikea$range$ipex$range = $com$ikea$range$ipex.range || ($com$ikea$range$ipex.range = {});
    var $com$ikea$range$ipex$range$catalog = $com$ikea$range$ipex$range.catalog || ($com$ikea$range$ipex$range.catalog = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$ipex = $com$ikea$range.ipex || ($com$ikea$range.ipex = {});
    var $com$ikea$range$ipex$range = $com$ikea$range$ipex.range || ($com$ikea$range$ipex.range = {});
    var $com$ikea$range$ipex$range$dto = $com$ikea$range$ipex$range.dto || ($com$ikea$range$ipex$range.dto = {});
    var $com$ikea$range$ipex$range$dto$component = $com$ikea$range$ipex$range$dto.component || ($com$ikea$range$ipex$range$dto.component = {});
    $com$ikea$range$ipex$range$dto$component.AssemblyChildDTO = AssemblyChildDTO;
    defineProp($com$ikea$range$ipex$range$dto$component.AssemblyChildDTO, 'Companion', Companion_getInstance_6);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$ipex = $com$ikea$range.ipex || ($com$ikea$range.ipex = {});
    var $com$ikea$range$ipex$range = $com$ikea$range$ipex.range || ($com$ikea$range$ipex.range = {});
    var $com$ikea$range$ipex$range$dto = $com$ikea$range$ipex$range.dto || ($com$ikea$range$ipex$range.dto = {});
    var $com$ikea$range$ipex$range$dto$component = $com$ikea$range$ipex$range$dto.component || ($com$ikea$range$ipex$range$dto.component = {});
    $com$ikea$range$ipex$range$dto$component.ColliderDTO = ColliderDTO;
    defineProp($com$ikea$range$ipex$range$dto$component.ColliderDTO, 'Companion', Companion_getInstance_7);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$ipex = $com$ikea$range.ipex || ($com$ikea$range.ipex = {});
    var $com$ikea$range$ipex$range = $com$ikea$range$ipex.range || ($com$ikea$range$ipex.range = {});
    var $com$ikea$range$ipex$range$dto = $com$ikea$range$ipex$range.dto || ($com$ikea$range$ipex$range.dto = {});
    var $com$ikea$range$ipex$range$dto$component = $com$ikea$range$ipex$range$dto.component || ($com$ikea$range$ipex$range$dto.component = {});
    $com$ikea$range$ipex$range$dto$component.ProductDTO = ProductDTO;
    defineProp($com$ikea$range$ipex$range$dto$component.ProductDTO, 'CustomSerializer', CustomSerializer_getInstance_2);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$ipex = $com$ikea$range.ipex || ($com$ikea$range.ipex = {});
    var $com$ikea$range$ipex$range = $com$ikea$range$ipex.range || ($com$ikea$range$ipex.range = {});
    var $com$ikea$range$ipex$range$dto = $com$ikea$range$ipex$range.dto || ($com$ikea$range$ipex$range.dto = {});
    var $com$ikea$range$ipex$range$dto$item = $com$ikea$range$ipex$range$dto.item || ($com$ikea$range$ipex$range$dto.item = {});
    $com$ikea$range$ipex$range$dto$item.ItemComponentsDTO = ItemComponentsDTO;
    defineProp($com$ikea$range$ipex$range$dto$item.ItemComponentsDTO, 'Companion', Companion_getInstance_8);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$ipex = $com$ikea$range.ipex || ($com$ikea$range.ipex = {});
    var $com$ikea$range$ipex$range = $com$ikea$range$ipex.range || ($com$ikea$range$ipex.range = {});
    var $com$ikea$range$ipex$range$dto = $com$ikea$range$ipex$range.dto || ($com$ikea$range$ipex$range.dto = {});
    var $com$ikea$range$ipex$range$dto$item = $com$ikea$range$ipex$range$dto.item || ($com$ikea$range$ipex$range$dto.item = {});
    $com$ikea$range$ipex$range$dto$item.ItemParametersDTO = ItemParametersDTO;
    defineProp($com$ikea$range$ipex$range$dto$item.ItemParametersDTO, 'Companion', Companion_getInstance_9);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$ipex = $com$ikea$range.ipex || ($com$ikea$range.ipex = {});
    var $com$ikea$range$ipex$range = $com$ikea$range$ipex.range || ($com$ikea$range$ipex.range = {});
    var $com$ikea$range$ipex$range$dto = $com$ikea$range$ipex$range.dto || ($com$ikea$range$ipex$range.dto = {});
    var $com$ikea$range$ipex$range$dto$item = $com$ikea$range$ipex$range$dto.item || ($com$ikea$range$ipex$range$dto.item = {});
    $com$ikea$range$ipex$range$dto$item.RangeItemDTO = RangeItemDTO;
    defineProp($com$ikea$range$ipex$range$dto$item.RangeItemDTO, 'Companion', Companion_getInstance_10);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$ipex = $com$ikea$range.ipex || ($com$ikea$range.ipex = {});
    var $com$ikea$range$ipex$range = $com$ikea$range$ipex.range || ($com$ikea$range$ipex.range = {});
    var $com$ikea$range$ipex$range$parser = $com$ikea$range$ipex$range.parser || ($com$ikea$range$ipex$range.parser = {});
    $com$ikea$range$ipex$range$parser.ItemParser = ItemParser;
    defineProp($com$ikea$range$ipex$range$parser.ItemParser, 'Companion', Companion_getInstance_11);
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  _.$_$ = _.$_$ || {};
  _.$_$.a = StaticComponentBuilder;
  _.$_$.b = AmendableCatalog;
  _.$_$.c = IPEXRangeFormatCatalog;
  _.$_$.d = RangeItemDTO;
  //endregion
  return _;
}));

//# sourceMappingURL=ipex-range-format.js.map
